
    var appConfig       		= require('./config').getConfig()
    var componentList   		= require('./componentList')
    var componentTree;
	const CONSTANTS     		= require('./constants')
	const utils         				= require('./utils')
	var $               			= utils.$ || {}
	var validator				= require('../client/validator')
    const etagResourceHandler   = require('../client/etagResourceHandler')
	const actionRegistry		= require('./actionRegistry')
	const Youtube						= require('./youtube')




	///////////////////////////////
	///// CORE
	///////////////////////////////

	/**
	 * this is the constructor of the Component Object and is the central element used to perform front end processes.
	 *
	 * @param properties        object - this is the leaf or the component data described in other files. All Properties within this object will be taken as the Components' properties. One special case are the methods in { methods: {} } which will be taken as first level properties of this Component as well.
	 * @param requestID         string - actual requestID
	 *                          NOTE: used by server only
	 * @param sessionID         string - actual sessionID
	 *                          NOTE: used by server only
	 * @param serviceDomain     string - actual serviceDomain
	 *                          NOTE: used by server only
	 * @param environment       object - actual known environment
	 *                          NOTE: used by server only
	 * @constructor
	 */
	function Component(properties, requestID, sessionID, serviceDomain, environment){
		if(requestID != undefined)      this.__proto__.requestID = requestID;
		if(sessionID != undefined)      this.__proto__.sessionID = sessionID;
		if(serviceDomain != undefined)  this.__proto__.serviceDomain = serviceDomain;

		// really empty component objects may happen in case of merges and such stuff
		if(properties === undefined || properties.component === undefined) return;

		// init store if necessary (this must not be done in global scope to prevent circular component dependencies between component.js, store.js and componentTree.js)
		if(!store) store = require('./store');

		// set properties
		for(var propertyName in properties){
			if(propertyName === 'methods'){
				// set methods
				for(var methodName in properties[propertyName]){
					this[methodName] = properties[propertyName][methodName];
				}
			}
			else {
				this[propertyName] = properties[propertyName];
			}
		}

		// set base properties
		this.model = this.model || {};
		this.model.componentIndex = this.componentIndex || 0;
		this.model.states = this.model.states || {};

		this.resourceData = this.resourceData || {};

		this.inclusionPerformed = false;
		this.inclusionKey = this.inclusionKey || false;
		this.inclusionActionSourceComponentIndex = this.inclusionActionSourceComponentIndex || false;
		this.inclusionChain = [];
		this.actualInclusionKey = 1;

		this._extends = this._extends || [];
		this.extensionComponentClass = this.extensionComponentClass || '';

		this.config             		= this.config || {};
		this.config.isReady     		= false;
		// this.rendered   = this.rendered || {};
		this.hooks      	= this.hooks || {};
		this.hooksInCharge	= {};
		this.registry   	= {};

		this.actions        = this.actions || {};
		this.resetActions   = {};
		this.actionIndex    = 0;

		this._nrOfPreloadingFiles   = 0;
		this._nrOfActionsInProgress = 0;

		this.shadowComponents = this.shadowComponents || {};

		this.activeEnvironment = utils.simpleCopy(environment);
		this.activeEnvironmentSet = false;
		this.environmentUpdateByParent = false;

		// TODO: DEBUG CLEANUP
		// if(appConfig.isClient){
		// 	this.checkMissingComponents();
		// }
	}



	// TODO: DEBUG CLEANUP
	// Component.prototype.checkMissingComponents = function(){
	//     setTimeout(function(self){
	// 		if(!componentTree.lookup[self.componentIndex]){
	// 			console.error('COMPONENT MISSING @ ', self.componentIndex, self.componentClass);
	// 		}
	// 		else {
	// 	        self.checkMissingComponents();
	// 		}
	//     }, 1000, this);
	// };
	// Component.prototype.checkComponentIndexProblem = function(){
	//     var children = [];
	//     var lostChildren = [];
	//     var self = this;
	//
	// 	this.find(undefined, function(child){
	// 		children[child.componentIndex] = true;
	// 		console.log('check: child', child.componentIndex, child.componentClass);
	// 	});
	//
	// 	utils.forEach(componentTree.lookup, function(component, componentIndex){
	// 		if(component.parentComponentIndex == self.componentIndex && !children[componentIndex]){
	// 			console.log('check: lost-child', componentIndex, component.componentClass);
	// 			lostChildren[componentIndex] = true;
	// 		}
	// 	});
	// };


    /**
     * this function should be used to destroy a component without any residuals
     */
    Component.prototype.getStorage = function(){
		if(appConfig.isClient && globalThis.storage){
			return globalThis.storage
		}
		return store.get(this.requestID, this.sessionID, this.serviceDomain)
	};

    /**
     * this function should be used to destroy a component without any residuals
     */
    Component.prototype.destroy = function(spliceOnly, childDestroy, actingRegisterSecret, actingRegisterType){
	    // init
	    var self = this;
		var returnAfterRegistryCleanup = false
	    if(!componentTree) componentTree = globalThis.componentTree;

	    if(!childDestroy){
		    var destroyChildList = [];
		    var notReadyToDie = undefined;

		    // find children to destroy
		    this.find(
		    	undefined,
		    	undefined,
			    function(child){
		    		if(child._nrOfActionsInProgress > 0){
					    notReadyToDie = child.componentIndex;
					    return 'break';
				    }
				    destroyChildList.push(child.componentIndex);
			    },
				false
		    );

		    // i have left something to do
		    if(this._nrOfActionsInProgress > 0){
			    componentTree.iAmNotReadyToDie(this.componentIndex, this.componentIndex);
				returnAfterRegistryCleanup = true
		    }
		    // one of my children has left something to do
		    else if(notReadyToDie != undefined){
			    componentTree.iAmNotReadyToDie(notReadyToDie, this.componentIndex);
				returnAfterRegistryCleanup = true
		    }

			// destroy parent registry entry by params if necessary
			// NOTE: 	this is necessary so the registry references are removed even if components are not ready to die yet, because the actingRegister-Params do not survive until the deadHead-killingSpree.
			// 			e.g., tabStrip registry
			if(returnAfterRegistryCleanup){
				if(
					this.parentComponentIndex != undefined &&
					componentTree.lookup[this.parentComponentIndex] &&
					actingRegisterSecret != undefined &&
					actingRegisterType != undefined &&
					componentTree.lookup[this.parentComponentIndex].registry &&
					componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret]
				){
					delete componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret][actingRegisterType];
					if(utils.collectionSize(componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret]) <= 0){
						delete componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret];
					}
				}

				return;
			}

		    // destroy all children
			var component;
			for(const index in destroyChildList){
				if((component = componentTree.lookup[destroyChildList[index]])) component.destroy(false, true);
			}
	    }

		// release further error handling if a component ceases to live.
		// this is just a precaution to prevent error handling from being turned off indefinitely by accident.
		self.releaseFurtherErrorHandling()

	    if(!utils.isEmpty(this.parentComponentInstanceID) && this.parentComponentInstanceID.substring(0, 1) === '/'){
	    	// am I the boss of the found tree?
		    if(
		    	componentTree.trees[this.parentComponentInstanceID]
			    &&
			    componentTree.trees[this.parentComponentInstanceID].childLayoutIndex != undefined
			    &&
			    componentTree.trees[this.parentComponentInstanceID].children[componentTree.trees[this.parentComponentInstanceID].childLayoutIndex]
			    &&
			    componentTree.trees[this.parentComponentInstanceID].children[componentTree.trees[this.parentComponentInstanceID].childLayoutIndex].componentIndex == this.componentIndex
		    ){
		        // remove trees entry
		        delete componentTree.trees[this.parentComponentInstanceID];
		        // remove cached html entry if necessary
			    if(componentTree.html[this.parentComponentInstanceID])  delete componentTree.html[this.parentComponentInstanceID];
		    }
	    }

	    // destroy original parent action if necessary
	    if(this.originalActionParentComponentIndex != undefined && componentTree.lookup[this.originalActionParentComponentIndex]){
		    if(this.originalParentActionKey != undefined && componentTree.lookup[this.originalActionParentComponentIndex].actions && componentTree.lookup[this.originalActionParentComponentIndex].actions[this.originalParentActionKey]){
			    // static actions will be reset instead of being deleted.
				const isStatic 		= componentTree.lookup[this.originalActionParentComponentIndex].actions[this.originalParentActionKey].static
				const resetAction 	= componentTree.lookup[this.originalActionParentComponentIndex].resetActions[this.originalParentActionKey]
				delete componentTree.lookup[this.originalActionParentComponentIndex].actions[this.originalParentActionKey];
				if(isStatic !== false && !childDestroy && resetAction){
					componentTree.lookup[this.originalActionParentComponentIndex].actions[this.originalParentActionKey] = utils.simpleCopy(resetAction)
				}
		    }
	    }

	    if(this.parentComponentIndex != undefined && componentTree.lookup[this.parentComponentIndex]){
	        // destroy parent action if necessary
		    if(this.parentActionKey != undefined && componentTree.lookup[this.parentComponentIndex].actions && componentTree.lookup[this.parentComponentIndex].actions[this.parentActionKey]){
		    	// static actions will be reset instead of being deleted.
				const isStatic 		= componentTree.lookup[this.parentComponentIndex].actions[this.parentActionKey].static
				const resetAction 	= componentTree.lookup[this.parentComponentIndex].resetActions[this.parentActionKey]
				delete componentTree.lookup[this.parentComponentIndex].actions[this.parentActionKey];
				if(isStatic !== false && !childDestroy && resetAction){
					componentTree.lookup[this.parentComponentIndex].actions[this.parentActionKey] = utils.simpleCopy(resetAction)
				}
		    }

		    // destroy parent registry entry if necessary
		    if(this.config.registerSecret != undefined && this.config.registerType != undefined && componentTree.lookup[this.parentComponentIndex].registry && componentTree.lookup[this.parentComponentIndex].registry[this.config.registerSecret]){
			    delete componentTree.lookup[this.parentComponentIndex].registry[this.config.registerSecret][this.config.registerType];
			    if(utils.collectionSize(componentTree.lookup[this.parentComponentIndex].registry[this.config.registerSecret]) <= 0){
				    delete componentTree.lookup[this.parentComponentIndex].registry[this.config.registerSecret];
			    }
		    }

		    // destroy parent registry entry by params if necessary
		    if(actingRegisterSecret != undefined && actingRegisterType != undefined && componentTree.lookup[this.parentComponentIndex].registry && componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret]){
			    delete componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret][actingRegisterType];
			    if(utils.collectionSize(componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret]) <= 0){
				    delete componentTree.lookup[this.parentComponentIndex].registry[actingRegisterSecret];
			    }
		    }
	    }

		// cleanup intermediaryParent's intermediaryChildren lookup if necessary
		if(this.intermediaryParentComponentIndex && ((componentTree.lookup[this.intermediaryParentComponentIndex] || {}).intermediaryChildren || {})[this.componentIndex]){
			delete componentTree.lookup[this.intermediaryParentComponentIndex].intermediaryChildren[this.componentIndex]
		}

	    if(spliceOnly) {
		    if(this.parentComponentIndex != undefined && componentTree.lookup[this.parentComponentIndex]){
	            var sectionIndex, index;
	            var parentElement = componentTree.lookup[this.parentComponentIndex];
		    	if(self.parentSectionID){
		    		for(var s in parentElement.children){
					    if(parentElement.children[s].sectionID == self.parentSectionID){
						    parentElement = parentElement.children[s];
					    	sectionIndex = s;
					    	break;
					    }
				    }
			    }
			    if(parentElement){
				    for(var i in parentElement.children){
					    if(parentElement.children[i].componentIndex == self.componentIndex){
						    index = i;
						    break;
					    }
				    }
			    }

			    if(index != undefined){
			    	if(sectionIndex != undefined){
					    componentTree.lookup[this.parentComponentIndex].children[sectionIndex].children.splice(index, 1);
				    }
				    else {
					    componentTree.lookup[this.parentComponentIndex].children.splice(index, 1);
				    }
			    }
		    }
	    }
	    else {
		    // destroy handlers in componentTree.handlers register
		    utils.map(componentTree.handlers, function(handlerList, handlerName){
		        utils.forEach(handlerList, function(handler, handlerIndex){
			        if(self.componentIndex == handler.calleeComponentIndex){
			            delete handlerList[handlerIndex];
			        }
		        });

			    return handlerList;
		    });

		    // destroy environment dependent lookup entries
		    utils.forEach(componentTree.environmentDependentLookup, function(component, componentIndex){
		    	if(component.componentIndex == self.componentIndex){
				    delete componentTree.environmentDependentLookup[self.componentIndex];
			    }
		    });

		    // destroy tab index register entry if necessary
		    if(this.config.focusAble && this.config.tabIndex){
		    	var focusPriority = 0;
		    	if(this.config.focusPriority) focusPriority = this.config.focusPriority;
		    	if(componentTree.tabIndexRegister[focusPriority]) delete componentTree.tabIndexRegister[focusPriority][this.config.tabIndex];
		    }

		    // destroy html in dom
		    if(this.refresh$().length > 0) this.$.remove();

		    // destroy lookup reference(s)
		    if(this.componentIndex != undefined && componentTree.lookup[this.componentIndex]){
		    	delete componentTree.lookup[this.componentIndex];
		    	if(this.config.staticLookupName && componentTree.lookup[this.config.staticLookupName] && componentTree.lookup[this.config.staticLookupName].componentIndex === this.componentIndex){
		    		delete componentTree.lookup[this.config.staticLookupName];
			    }
		    }

		    // focus right component if necessary
		    if(!childDestroy && !$('*:focus').length) componentTree.focusRightComponent();
	    }
    };

    /**
     * this function should be used to clear the dom's contents but not the component itself.
     */
    Component.prototype.clear = function(){
	    if(this.refresh$().length > 0) this.$.html('');
    };

    /**
     * this function should be used to remove the dom's contents including the component itself.
     */
    Component.prototype.remove = function(){
	    if(this.refresh$().length > 0) this.$.remove();
    };

    /**
	 * this function returns a jQuery selector for the dom element corresponding to this component
	 *
	 * @returns string
	 */
	Component.prototype.selector = function(){
		if((appConfig || {}).useIDSelector && !this.config.preventIDSelector){
			return '#' + utils.getComponentIDByIndex(this.componentIndex);
		}
		return '[data-component-index="' + this.componentIndex + '"]';
	};

	/**
	 * this function refreshes and returns the new jQuery object for the dom element corresponding to this component
	 *
	 * @returns jQuery
	 */
	Component.prototype.refresh$ = function(){
		return (this.$ = $(this.selector()));
	};

	/**
	 * this function is used to trigger hooks which may be implemented within this component. hooks are defined within the { hooks: { ... } } property
	 *
	 * @param   hook        	string - name of the hook which should be triggered
	 * @param   options     	object - options which can be given to the function call
	 * @param   attachTrigger   object - context object used to store promises needed to manage attach- and postAttach-phases.
	 * @returns Promise
	 */
	Component.prototype.trigger = async function(hook, options, attachTrigger){
		this.hooksInCharge[hook] = true;

		return this.triggerInclude(this, hook, options).then(function(data){
			return data.component.triggerBase(data.component, data.hook, data.options, data.result, attachTrigger).then(function(data){
				return data.component.triggerCore(data.component, data.hook, data.options, data.result).then(function(data){
					return data.component.triggerTop(data.component, data.hook, data.options, data.result, attachTrigger).then(function(data){
						data.component.hooksInCharge[hook] = false;

						// trigger on ready triggers if necessary
						if(data.hook === 'attach' && data.component.onReadyTriggers && (!data.options || !data.options.onReadyTrigger)){
							var performingActions = [];
							for(var t in data.component.onReadyTriggers){
								performingActions.push(data.component.trigger(data.component.onReadyTriggers[t].hook, data.component.onReadyTriggers[t].options, attachTrigger));
							}
							data.component.onReadyTriggers = undefined;
							if(performingActions.length > 0){
								return utils.promise.performAll(data.component, performingActions).then(function(responses){
									return utils.promise.resolve(data);
								});
							}
						}

						return utils.promise.resolve(data);
					});
				});
			});
		});
	};

    /**
     * this function is used to ensure that the trigger will be called after the attach trigger has been completed.
     * NOTE: this can mean immediately or later.
     *
     * @param   hook        string - name of the hook which should be triggered
     * @param   options     object - options which can be given to the function call
     * @returns Promise
     */
    Component.prototype.triggerWhenReady = function(hook, options){
    	if(this.config.isReady){
    		return this.trigger(hook, options);
	    }
    	else {
    		if(!this.onReadyTriggers) this.onReadyTriggers = [];
			options = options || {};
    		options.onReadyTrigger = true;
		    this.onReadyTriggers.push({ hook: hook, options: options });
	    }
    };

	/**
	 * this function is used to trigger a hook on the closest parent component which does have implemented the wanted hook
	 * and optional meets the componentClass definitions defined by componentClass param.
	 *
	 * @param   hook                string - name of the hook which should be triggered
	 * @param   options             object - options which can be given to the function call
	 * @param   componentClass      string | array | whitespace separated string - component class(es) of wanted parent - optional
	 * @returns mixed             	false if no parent implementing the trigger can be found and the triggerPromise otherwise.
	 */
	Component.prototype.triggerClosest = async function(hook, options, componentClass){
		let triggerFound
		this.parentComponents(componentClass, function(parentComponent){
			if(utils.isFunction(parentComponent.hooks[hook])){
				triggerFound = parentComponent.trigger(hook, options)
				return false
			}
		})
		if(triggerFound){
			await triggerFound
		}
	};

	/**
	 * this function is used to trigger a hook on the closest child component which does have implemented the wanted hook
	 * and optional meets the componentClass definitions defined by componentClass param.
	 *
	 * @param   hook                string - name of the hook which should be triggered
	 * @param   options             object - options which can be given to the function call
	 * @param   componentClass      string | array | whitespace separated string - component class(es) of wanted parent - optional
	 * @returns boolean             false if no child implementing the trigger can be found and true otherwise.
	 */
	Component.prototype.triggerFind = function(hook, options, componentClass){
		var triggerFound = false;
		this.find(componentClass, function(childComponent){
			if(utils.isFunction(childComponent.hooks[hook])){
				childComponent.trigger(hook, options);
				triggerFound = true;
			}
		});

		return triggerFound;
	};

	/**
	 * this is a promise function used to process the include-trigger which has to be processed at first
	 * in order to get the dynamic inclusions within the components' javascript ready at the right time.
	 *
	 * @param   component       Component - actual component object
	 * @param   hook            string - actual hook name
	 * @param   options         object - actual trigger options
	 * @param   result          mixed - actual result
	 * @returns Promise({ component: ..., hook: ..., options: ..., result: ... })
	 */
	Component.prototype.triggerInclude = function(component, hook, options, result){
		if(hook === 'attach'){
			component.refresh$();
			component.hooksInCharge.include = true;
			return component.triggerCore(component, 'include', options, result).then(function(data){
				data.component.hooksInCharge.include = false;
				return utils.promise.resolve({
					component:  data.component,
					hook:       'attach',
					options:    data.options,
					result:     data.result
				});
			});
		}

		// return promise
		return utils.promise.resolve({
			component:  component,
			hook:       hook,
			options:    options,
			result:     result
		});
	};

    /**
     * this is a promise function used to process the trigger base (preparations, perform actions, ...)
     *
     * @param   component       Component - actual component object
     * @param   hook            string - actual hook name
     * @param   options         object - actual trigger options
     * @param   result          mixed - actual result
	 * @param   attachTrigger   object - context object used to store promises needed to manage attach- and postAttach-phases.
     * @returns Promise({ component: ..., hook: ..., options: ..., result: ... })
     */
    Component.prototype.triggerBase = function(component, hook, options, result, attachTrigger){
    	// init
	    var performingActions = [];
	    if(options === undefined) options = {};
	    if(result === undefined)  result = false;

	    // pre attach - perform actions which can be done after dom-ready only
	    if (hook === 'attach') {
	    	// set tab index if necessary
			if(component.config.tabIndex){
				component.$.attr('tabIndex', component.config.tabIndex);
			}

	    	// bind events if necessary
			if(!options.refreshResourcesOnly){
		    	component.bindEvents(component.events);
			}

		    // register on parent if necessary
		    if(!utils.isEmpty(component.config.registerType) && typeof(component.config.registerSecret) !== 'undefined'){
			    component.parent(function(parentComponent){
				    parentComponent.register(component.config.registerSecret, component.config.registerType, component.componentIndex);
			    });
		    }

			// register resourceData-Actions
			if(component.resourceData.attributes !== undefined && !utils.isEmpty(component.resourceData.attributes.actions)){
				// mark resource actions as resource dependent
				utils.map(component.resourceData.attributes.actions, function(action){
					action.resourceDependent = true;
					return action;
				});
				component.actions = utils.merge(component.actions, component.resourceData.attributes.actions);
			}

			// register model-data-Actions
			if(component.model !== undefined && !utils.isEmpty(component.model.actions)){
				// mark resource actions as resource dependent
				utils.map(component.model.actions, function(action){
					// TODO: check if model actions should be resourceDependent...
					action.resourceDependent = true;
					return action;
				});
				component.actions = utils.merge(component.actions, component.model.actions);
			}

		    // collect inclusion-actions from inclusion-action-source-component
		    if(component.inclusionActionSourceComponentIndex && component.inclusionKey && component.inclusionActionSourceComponentIndex != component.componentIndex && globalThis.componentTree.lookup[component.inclusionActionSourceComponentIndex] && !utils.isEmpty(globalThis.componentTree.lookup[component.inclusionActionSourceComponentIndex].actions)){
				var movingComponent;
			    utils.forEach(globalThis.componentTree.lookup[component.inclusionActionSourceComponentIndex].actions, function(action, actionKey){
				    if(action.parentInclusionKey && component.inclusionKey == action.parentInclusionKey){
					    // throw errors caused by inclusion-action keys multi usage
						if(component.actions[actionKey]){
							throw new Error('restructureInclusionsTreePosition POSITION ALREADY IN USE!');
						}

						// move action
						component.actions[actionKey] = globalThis.componentTree.lookup[component.inclusionActionSourceComponentIndex].actions[actionKey];
						delete globalThis.componentTree.lookup[component.inclusionActionSourceComponentIndex].actions[actionKey];

						// correct action parameters
						movingComponent = ((globalThis.componentTree.lookup[component.componentIndex].actions[actionKey].source || {}).load || {}).component;
						if(movingComponent){
							movingComponent.parentComponentID 			= component.componentID;
							movingComponent.parentComponentIndex 		= component.componentIndex;
							movingComponent.parentComponentInstanceID 	= component.componentInstanceID;
							movingComponent.parentRouteComponentID 		= component.routeComponentID;
							movingComponent.parentSectionComponentID 	= component.sectionComponentID;
						}
						delete component.actions[actionKey].parentInclusionKey;
						component.actualInclusionKey = Math.max(component.actualInclusionKey, globalThis.componentTree.lookup[component.inclusionActionSourceComponentIndex].actualInclusionKey);
				    }
			    });
		    }

		    // re-perform refresh persistent and inclusion-actions
		    if(!utils.isEmpty(component.actions)){
			    utils.forEach(component.actions, function(action, actionKey){
				    // NOTE: this undefined check is necessary because other components can grab actions if they are inclusion-actions and if they belong to another component
				    if(typeof(action) != 'undefined'){
					    // perform ready actions which are marked to be refreshed (except load_resource actions which are not useful after the own render process)
					    if(action.refreshPersistent && action.ready && action.type !== CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE){
						    performingActions.push(component.performAction(actionKey, { autoRefresh: true, refreshResourcesOnly: options.refreshResourcesOnly }));
					    }
					    // perform include actions which should be performed within this component
					    else if(action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE && !action.parentInclusionKey){
						    performingActions.push(component.performAction(actionKey, { autoRefresh: true }, undefined, attachTrigger))
					    }
				    }
			    });
		    }
	    }

	    // perform actions if necessary
	    if(performingActions.length > 0){
		    return utils.promise.performAll(this, performingActions).then(function(data){
		    	return utils.promise.resolve({
				    component:  data.component,
				    hook:       hook,
				    options:    options,
				    result:     result
			    });
		    });
	    }

	    // return promise
	    return utils.promise.resolve({
		    component:  component,
		    hook:       hook,
		    options:    options,
		    result:     result
	    });
    };

    /**
     * this is a promise function used to process the trigger core (process hook if possible)
     *
     * @param   component       Component - actual component object
     * @param   hook            string - actual hook name
     * @param   options         object - actual trigger options
     * @param   result          mixed - actual result
     * @param   hookIndex 		int - hook index used within lists of hooks (hookInheritance)
	 * 							NOTE: this value must not be defined form outside!
     * @returns Promise({ component: ..., hook: ..., options: ..., result: ... })
     */
    Component.prototype.triggerCore = function(component, hook, options, result, hookIndex){
	    if(component.hooks[hook]) {
			hookIndex = hookIndex || 0;

			// init rules if necessary
			if(hookIndex === 0 && hook === 'attach' && (!options || !options.refresh)){
				component.initValidatorRuleSet();
			}

			var nrOfHooks = 1;
			if(utils.isArray(component.hooks[hook])) {
				if((nrOfHooks = component.hooks[hook].length) > 1){
					if(hookIndex === 0){
						result = [];
					}
				}
			}

			var hookFunction;
			if(hookIndex < nrOfHooks){
				if(nrOfHooks > 1){
					hookFunction = component.hooks[hook][hookIndex];
				}
				else {
					hookFunction = component.hooks[hook];
				}
			}

			if(typeof(hookFunction) === 'function') {
				// do work
				var res = hookFunction.call(component, component.$, options, hookIndex);
				if(nrOfHooks > 1){
					result[hookIndex] = res;
				} else {
					result = res;
				}

				// check if hook has returned a promise. in that case the promise chain should include it in order to perform the triggerTop really afterwards.
				if(utils.isCollection(res) && utils.isFunction(res.promise)){
					return res.then(function(data){
						// take result from base result or from trigger if possible
						if(nrOfHooks > 1){
							result[hookIndex] = (data || {}).result;
						} else {
							result = (data || {}).result;
						}

						if(hookIndex === (nrOfHooks - 1)){
							// return promise
							return utils.promise.resolve({
								component:  component,
								hook:       hook,
								options:    options,
								result:     result
							});
						}

						return component.triggerCore(component, hook, options, result, hookIndex + 1);
					});
				}
				else if(hookIndex < (nrOfHooks - 1)){
					return component.triggerCore(component, hook, options, result, hookIndex + 1);
				}
			}
		}

	    // return promise
	    return utils.promise.resolve({
		    component:  component,
		    hook:       hook,
		    options:    options,
		    result:     result
	    });
    };

    /**
     * this is a promise function used to process the trigger top (post-processing of hooks)
     *
     * @param   component       Component - actual component object
     * @param   hook            string - actual hook name
     * @param   options         object - actual trigger options
     * @param   result          mixed - actual result
	 * @param   attachTrigger   object - context object used to store promises needed to manage attach- and postAttach-phases.
     * @returns Promise({ component: ..., hook: ..., options: ..., result: ... })
     */
    Component.prototype.triggerTop = function(component, hook, options, result, attachTrigger){
    	var performingActions = [];
    	if(!componentTree) componentTree = globalThis.componentTree;

		// post attach
	    if (hook === 'attach') {
		    // perform inclusion-actions which has been added in js-code within the attach hook phase.
		    // NOTE: these actions cannot be sure that their attach trigger-chain will be executed before their parents' attach.
		    if(!utils.isEmpty(component.actions)){
			    utils.forEach(component.actions, function(action, actionKey){
				    // NOTE: this undefined check is necessary because other components can grab actions if they are inclusion-actions and if they belong to another component
				    if(typeof(action) != 'undefined'){
					    // perform include actions which should be performed within this component
					    if(action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE && !action.parentInclusionKey && !action.ready){
						    performingActions.push(component.performAction(actionKey, { autoRefresh: true }, undefined, attachTrigger))
					    }
				    }
			    });
		    }
	    }

	    // perform actions if necessary
	    if(performingActions.length > 0){
		    return utils.promise.performAll(this, performingActions).then(function(data){
		    	// mark component as ready if possible
		    	if(hook === 'attach'){
		    		data.component.config.isReady = true;
				    if(data.component.config.staticLookupName){
					    componentTree.lookup[data.component.config.staticLookupName] = componentTree.lookup[data.component.componentIndex];
				    }
				    data.component.$.removeClass('loading refreshLoading');
			    }

			    return utils.promise.resolve({
				    component:  data.component,
				    hook:       hook,
				    options:    options,
				    result:     result
			    });
		    });
	    }

	    // mark component as ready if possible
	    if(hook === 'attach'){
		    this.config.isReady = true;
		    if(this.config.staticLookupName){
			    componentTree.lookup[this.config.staticLookupName] = componentTree.lookup[this.componentIndex];
		    }
		    this.$.removeClass('loading refreshLoading');
	    }

	    // return promise
	    return utils.promise.resolve({
		    component:  component,
		    hook:       hook,
		    options:    options,
		    result:     result
	    });
    };

    /**
	 * this function is used to register a child on this parent component.
	 * e.g.,    this functionality is needed for tabs and tabcontents which are independent components
	 *          and have to be registered on the tabStrip component identified by a secret
	 *          which has to be shared between tab- and tabContent-component.
	 *
	 * @param   registerSecret      string - parentComponent wide unique identifier (e.g., same id for tab and tabContent within a tabStrip)
	 * @param   registerType        string - identifies the element within one secret-group (e.g., "tab" or "tabContent")
	 * @param   componentIndex      int - component index of the component which wants to be registered
	 * @returns {boolean} - success
	 */
	Component.prototype.register = function(registerSecret, registerType, componentIndex){
		if(utils.isEmpty(globalThis.componentTree.lookup[componentIndex])) return false;

		this.registry[registerSecret] = this.registry[registerSecret] || {};
		this.registry[registerSecret][registerType] = globalThis.componentTree.lookup[componentIndex];
		return true;
	};

    /**
     * this function is used to call a global handler identified by the given handlerName.
     * the given arguments will be submitted directly to the handler.
     *
     * @param handlerName       string - handler name
     * @param args              array - optional array with arguments for the handler
     */
    Component.prototype.callHandler = function(handlerName, args){
		globalThis.componentTree.callHandler(this, handlerName, args);
    };

    /**
     * this is a wrapper function used to check if an environmental change should force the component to be refreshed.
     * furthermore,  it saves the last active environment parameters which gives the environmentRefreshNecessary function
     * of this component the ability to compare the active and the new environment.
     *
     * @param   newEnvironment          object - new environment
     * @param   serverKnownEnvironment  object - environment data which is known by the server
     * @params  initialExecution        boolean - is this the initial execution by client?
     * @params  externalDrivenCall      boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
     * @returns boolean                 returns true if a refresh is necessary according to the environmental changes and false otherwise.
     */
    Component.prototype.checkEnvironment = function(newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall){
	    if(!this.activeEnvironmentSet){
            this.activeEnvironment = serverKnownEnvironment;
            this.activeEnvironmentSet = true;
	    }

	    // ask the component if it is necessary to refresh if possible
	    if(
		    utils.isFunction(this.environmentRefreshNecessary)
		    &&
	    	this.environmentRefreshNecessary(
	    		this.activeEnvironment,
			    newEnvironment,
			    serverKnownEnvironment,
			    initialExecution,
			    externalDrivenCall,
			    this.environmentUpdateByParent
		    )
		    &&
		    !this.environmentUpdateByParent
		    &&
		    !(this.environmentUpdateByParent = false)
	    ){
	    	// tell all children (environment dependent or not) that they will be refreshed by one of its parents to prevent cascaded refresh operations
	    	this.find(undefined, function(childComponent){
			    childComponent.environmentUpdateByParent = true;
		    });

	    	return true;
	    }

	    // do not refresh if it is not necessary
	    return false;
    };

    /**
     * this function will be called after an environmental refresh, when all components within this env-refresh are ready.
     * NOTE: this means especially that all preloading files has been loaded.
     */
    Component.prototype.finalizeEnvironmentChange = function(){
    	this.htmlToDOM();
    };

	/**
	 * for generic programming purposes it may be necessary to define events within a component itself.
	 * this function is used to bind the defined events (given by { events. {...} } property) to the corresponding DOM-Elements.
	 *
	 * @param   events  {} || [] - the form of the event list can be one of the following:
	 *
	 * {
	 *      <eventType like click>: <callbackFunction>,
	 *      <eventType>: {
	 *          action: <callbackFunction>,
	 *          selector: '> div .a'
	 *      }
	 *  },
	 *  ...
	 *  or (this may be necessary for cascading of component events and dynamic events - e.g., perform action open tab from menu)
	 *  ...
	 *  [
	 *      {
	 *          <eventType like click>: <callbackFunction>,
	 *          <eventType>: {
	 *              action: <callbackFunction>,
	 *              selector: '> div .a'
	 *          }
	 *      },
	 *  ]
	 * }
	 *
	 * NOTE: the selector can be empty and will be applied to the components' DOM-Element itself. So in exact terms it is a sub-selector.
	 */
	Component.prototype.bindEvents = function(events){
		if(!utils.isEmpty(events)){
			var self = this;

			if(utils.isArray(events)){
				utils.forEach(events, function(eventList){
					self.bindEvents(eventList);
				});
			}
			else {
				var touchableEventName;
				utils.forEach(events, function (eventProperties, eventName) {
					if(eventProperties !== undefined && eventProperties !== null){
						// normalize event properties
						if (utils.isFunction(eventProperties)) {
							eventProperties = {action: eventProperties};
						}
						// check if event handler available
						if (utils.isFunction(eventProperties.action)) {
							// check if event name should be overwritten
							if(!utils.isEmpty(eventProperties.type)){
								eventName = eventProperties.type;
							}
							// check if selector is present and bind event accordingly
							if (!utils.isEmpty(eventProperties.selector)) {
								if(eventProperties.selectorAddSelf){
									self.$.on(eventName, {component: self}, eventProperties.action);
								}

								if(eventProperties.delegated === false){
									self.$.find(eventProperties.selector).on(eventName, {component: self}, eventProperties.action);
								} else {
									self.$.on(eventName, eventProperties.selector, {component: self}, eventProperties.action);
								}
							}
							else if (eventProperties.onDocument === true){
								$(document).on(eventName, {component: self}, eventProperties.action);
							}
							else {
								self.$.on(eventName, {component: self}, eventProperties.action);
							}
						}
						// error handling
						else {
							console.error(self.componentClass + ' - Component.bindEvents no action found!');
						}
					}
				});
			}
		}
	};

	/**
	 * this function is used to inject the components id and class into the first occurrence of a html-tag within the renderedContent parameter.
	 * NOTE:    if the renderedContent parameter does not contain any valid html-tag
	 *          (comments and such tags excluded) the default empty-template will be used instead.
	 *
	 * // TODO: sometimes class-definitions contain doubled whitespaces!
	 *
	 * @param   renderedContent         string - rendered html content
	 * @param   injectComponentIndex    int - componentIndex to inject (optional)
	 * @param   componentClass          string - componentClass to inject (optional) (default is the actual components' componentClass)
	 * @param   injectInclusionKey    	int - inclusionKey to inject (optional)
	 * @param   templateComponentKey    string - templateComponentKey which has been intended to load
	 * @param   storage                 object - actual storage
	 * @returns string                  if there is no need for any injections or it is not possible the unmodified given content will be returned.
	 */
	Component.prototype.injectIndex = function(renderedContent, injectComponentIndex, componentClass, injectInclusionKey, templateComponentKey, storage){
		let usedRenderedContent = renderedContent

		// respect TEXT_MODE and JSON_MODE which is mainly used by newsletter system (and moebelix templates) at the moment.
		if((((storage || {}).request || {}).queryParams || {}).TEXT_MODE || (((storage || {}).request || {}).queryParams || {}).JSON_MODE){
			return usedRenderedContent
		}

		const defaultElement = '<div class="emptyTemplate"></div>'
		let matches
		injectComponentIndex 	= injectComponentIndex || false
		injectInclusionKey 		= injectInclusionKey || false
		let injectComponentID 	= false
		if(appConfig.inject.selectors && injectComponentIndex && (appConfig || {}).useIDSelector && !this.config.preventIDSelector){
			injectComponentID = utils.getComponentIDByIndex(injectComponentIndex)
		}
		let anchor = ''
		if(appConfig.inject.anchors && this.config.anchorInjectionGranted){
			var injectAnchorID = this.getAnchorID()
			if(injectAnchorID){
				// since the a-tag is convenient to control the scrollTo position in case of an anchor-url usage it will be used. (opposing to set the id-attribute of the component itself.)
				// but: if the name-attribute would be used it might collide with ids which may be in use within the actual project.
				// therefor, there is no harm in using the id which would collide and be preferred by actual browsers in this scenario anyway.
				// furthermore, the name attribute has been marked deprecated a while ago.
				// for further details see:
				// 		https://developer.mozilla.org/en-US/docs/web/html/element/a#attr-name
				// 		https://html.spec.whatwg.org/multipage/browsing-the-web.html#scroll-to-fragid
				anchor = `<div class="fec_anchor" id="${injectAnchorID}"></div>`
			}
		}

		for(var i = 0; i < 2; i++){
			matches = usedRenderedContent.match(/<([^\s!>][^\s>]*)\s*([^>]+)?>/)
			if(matches){
				break
			}
			else if(((appConfig || {}).render || {}).suppressEmptyTemplates) {
				return usedRenderedContent
			} else {
				console.error('Component.injectIndex() - invalid renderedContent lead to defaultElement usage @ ' + componentClass + ' @ORIGINAL: ' + templateComponentKey)
				usedRenderedContent = defaultElement
			}
		}

		if(matches.length < 3){
			// TODO: throw error
			console.error(`inject index has to have one and only one parent tag in: ${usedRenderedContent}`)
			return renderedContent
		}

		// TODO: relationship form has 2 class attributes?!?
		const tag	= matches[1]
		const classMatch	= (' ' + matches[2]).match(/\sclass=(("([^"]+)")|('([^']+)'))/)
		const clazzes	= []
		if(appConfig.inject.componentClasses){
			clazzes.push((componentClass || '').trim())
		}
		if(appConfig.inject.loadingClass && appConfig.inject.selectors && injectComponentIndex){
			clazzes.push('loading')
		}

		let attributes = ''
		let newAttributes = []
		if(appConfig.inject.selectors && injectComponentID)     					newAttributes.push(`id="${injectComponentID}"`);
		if(appConfig.inject.selectors && injectComponentIndex) 						newAttributes.push(`data-component-index="${injectComponentIndex}"`);
		if(appConfig.inject.selectors && injectInclusionKey) 						newAttributes.push(`data-inclusion-key="${injectInclusionKey}"`);
		if(appConfig.debug.injectComponentInstanceID && this.componentInstanceID) 	newAttributes.push(`data-component-instance-id="${this.componentInstanceID}"`);
		if(clazzes.length > 0)														newAttributes.push(`class="${clazzes.join(' ')}"`);


		if(classMatch !== null){
			let clazzQuote = '"'
			if(typeof(classMatch[3]) !== 'undefined' && classMatch[3] != ''){
				clazzes.push(classMatch[3].trim())
				clazzQuote = '$3';
			}
			else if(typeof(classMatch[5]) !== 'undefined' && classMatch[5] != ''){
				clazzes.push(classMatch[5].trim())
				clazzQuote = '$6';
			}

			newAttributes = []
			if(appConfig.inject.selectors && injectComponentID) 						newAttributes.push(`id=${clazzQuote}${injectComponentID}${clazzQuote}`);
			if(appConfig.inject.selectors && injectComponentIndex) 						newAttributes.push(`data-component-index=${clazzQuote}${injectComponentIndex}${clazzQuote}`);
			if(appConfig.inject.selectors && injectInclusionKey) 						newAttributes.push(`data-inclusion-key=${clazzQuote}${injectInclusionKey}${clazzQuote}`);
			if(appConfig.debug.injectComponentInstanceID && this.componentInstanceID) 	newAttributes.push(`data-component-instance-id=${clazzQuote}${this.componentInstanceID}${clazzQuote}`);
			if(clazzes.length > 0)														newAttributes.push(`class=${clazzQuote}${clazzes.join(' ')}${clazzQuote}`);

			if(newAttributes.length > 0){
				newAttributes.unshift('')
				attributes = classMatch.input.replace(/\sclass=(((")([^"]+)")|((')([^']+)'))/, newAttributes.join(' '))
			}
		}
		else if(!utils.isEmpty(matches[2])) {
			newAttributes.push(matches[2])
		}

		if(!attributes && newAttributes.length > 0){
			newAttributes.unshift('')
			attributes = newAttributes.join(' ')
		}

		return usedRenderedContent.replace(/<([^>!][^>]*)>/, `<${tag}${attributes}>${anchor}`)
	}

    /**
     * this function is used to wipe out all resource dependent actions.
     */
    Component.prototype.resourceActionCleanup = function(){
    	// init
    	var self = this;

    	// reset sanitation state flags
		self._resourceSanitationDoneByPreloading = false;

    	// kick resource dependent actions and their components
		utils.forEach(self.actions, function(action, actionIndex){
			if(action.resourceDependent){
				utils.forEach(action.source, function(source, sourceName){
					if(source.component instanceof Component){
						source.component.destroy();
					}
					if(source.componentTree && source.componentTree.childLayoutIndex != undefined && source.componentTree.children[source.componentTree.childLayoutIndex] instanceof Component){
						source.componentTree.children[source.componentTree.childLayoutIndex].destroy();
					}
				});

				delete self.actions[actionIndex];
			}
		});
    };

    /**
     * this function is used to wipe out all inclusion actions
     */
    Component.prototype.inclusionActionCleanup = function(){
	    // init
	    var self = this;

	    // kick inclusion actions and their components
	    utils.forEach(self.actions, function(action, actionIndex){
		    if(action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE){
			    if(action.source.load.component instanceof Component) {
				    action.source.load.component.destroy();
			    } else {
					delete self.actions[actionIndex];
				}
		    }
	    });

	    // reset actual inclusion key
		self.actualInclusionKey = 1;

	    // reset inclusion performed state
	    self.inclusionPerformed = false;
    };

	/**
	 * this function is used to render and return a components' html code.
	 *
	 * @param   storage                     object - actual storage
	 * @param   routeParams					object - parameters defined by the actual route-call
	 * @param   template                    function() - template function which returns the html string - optional
	 * @param   refData						object - template data - optional
	 * @param   parentComponentGroup        array - actual parentComponentGroup
	 *                                      NOTE: used for internal inheritance logic only!
	 * @param   injectComponentIndex        boolean - should the actual componentIndex be injected or not
	 *                                      NOTE: used for internal inheritance logic only!
	 * @param   componentClass              string - componentClass which should be used for the component
	 *                                      NOTE: used for internal inheritance logic only!
	 * @param   inclusionKey                string - inclusion key which should be injected
	 *                                      NOTE: used for internal inheritance logic only!
	 * @param 	forceImmediateRender		boolean - should this inclusion (and all child inclusions) be rendered immediately?
	 * 										NOTE: used for internal inheritance logic only!
	 * @returns 					        string - in an error case an empty string will be returned
	 */
	Component.prototype.render = function(storage, routeParams, template, refData, parentComponentGroup, injectComponentIndex, componentClass, inclusionKey, forceImmediateRender){
		// init
		var self 	= this;
		storage 	= storage || this.getStorage();
		routeParams = routeParams || (appConfig.isClient && globalThis.routeParams ? globalThis.routeParams : {});

		// cleanup includes if necessary
		if(appConfig.isClient && !utils.isFunction(template)){
			this.inclusionActionCleanup();
		}

		if(!componentClass){
			componentClass = this.componentClass + ' ';
			if(utils.isFunction(this.getAdditionalClasses)){
				componentClass += (this.getAdditionalClasses() || []).join(' ');
			}
			if(!utils.isEmpty(this.extensionComponentClass)){
				componentClass = this.extensionComponentClass + ' ' + componentClass;
			}
			if(!utils.isEmpty(this.containerComponentClass)){
				componentClass += ' ' + this.containerComponentClass;
			}
		}

		// call onBeforeRender function if necessary
		if(!utils.isEmpty(this.onBeforeRender)){
			this.onBeforeRender(storage);
		}

		template = template || this.template;
		const data = {
			...(refData || {})
		}
		if(!data.config) 		data.config 		= this.config || {};
		if(!data.model) 		data.model 			= this.model || {};
		if(!data.resourceData) 	data.resourceData 	= this.resourceData || {};
		if(!data.formMapping) 	data.formMapping 	= this.formMapping || {};

		data.helpers = this.helpers(storage);
		data.include = function(a, b, c, d, e){
			// set right parentComponentGroup
			return self.include(a, b, parentComponentGroup || self.component, d, e, storage, routeParams, true, forceImmediateRender);
		};
		data.includeShadow = function(shadowComponentCodeName, data, storage, routeParams){
			return self.includeShadow(shadowComponentCodeName, data, storage, routeParams, true);
		};
		data.CONSTANTS = CONSTANTS;
		data.utils = utils;
		data.routeParams = routeParams || {};
		data.storage = {
			sessionID:  storage.sessionID,
			session:    storage.session || {},
			user:       storage.user,
			app:        storage.app,
			request:    storage.request || {},
			isServer:   storage.isServer,
			isClient:   storage.isClient,
			langCode: 	storage.langCode,
			__: 		storage.__,
		};
		data.environment = this.activeEnvironment || {};
		data.scope = this.scope

		try {
			return this.injectIndex(template(data), injectComponentIndex === false ? false : this.componentIndex, componentClass, inclusionKey, undefined, storage);
		} catch (error){
			console.error(error)
		}
	};

	/**
	 * this function is used to render the corresponding DOM-Node, replace the code within the DOM and trigger the attach-hook of the actual component again.
	 * the attach-hook will be triggered with a trigger option to be able to react within attach hooks to that.
	 *
	 * @param   refreshResources            	boolean - should the possible existent resource-definitions be used to try refreshing the resources? (default: true)
	 * @param   attachTriggerOptions        	object - these options will be given to the attach-trigger-call after a successfull dom placement
	 * @param   onElementNotFoundCallback   	function -  if the dom element of the actual component could not be found this optional callback will be invoked in context of the actual component.
	 *                                                  	as first and only parameter the attachTriggerOptions will be given.
	 * @param   performChildActionsIfPossible	boolean - default: true - this should not be set from outside. it will be used in cases of refreshes which are called from inside an action chain.
	 * @param   onAfterResourceRefreshCallback 	function -  right after the resource action being called this callback may handle some extra logic in a sync way
	 * @param   onAfterRefreshDoneCallback 		function -  right after the resource action has been completed this callback may handle some extra logic in a sync way
	 * @param   isCascadingRefresh 				boolean -  is this a refresh call triggered by another refresh call.
	 * 											NOTE: do not set this parameter. it is used for internal purposes only!
	 * @param 	doneCallback        			function - this is needed to know when the dom operations are done. @see MARK: ACTION_DOM_DONE_CALLBACK for further details.
	 * @param   attachTrigger   				object - context object used to store promises needed to manage attach- and postAttach-phases.
	 */
	Component.prototype.refresh = function(refreshResources, attachTriggerOptions, onElementNotFoundCallback, performChildActionsIfPossible, onAfterResourceRefreshCallback, onAfterRefreshDoneCallback, isCascadingRefresh = false, doneCallback, attachTrigger){
		// init
		var self = this;
		var refreshedByAction = false;
		attachTriggerOptions = attachTriggerOptions || {}
		this._tryToPreloadImages    = attachTriggerOptions.environmentChanged;
		this._nrOfPreloadingFiles   = 0;
		refreshResources = (refreshResources === undefined || refreshResources);
		if(performChildActionsIfPossible === undefined){
			performChildActionsIfPossible = true;
		}
		performChildActionsIfPossible = performChildActionsIfPossible && refreshResources;

		// tell component that it is about to be refreshed.
		if(utils.isFunction(self.onBeforeRefresh)){
			self.onBeforeRefresh(attachTriggerOptions)
		}

		var fieldCode = '';
		var refreshBaseSources = utils.promise.resolve();

		// stop cascading refreshes if a component demands it
		if(this.config.isRefreshStopper && isCascadingRefresh === true){
			if(doneCallback) doneCallback();
			return;
		}

		// refresh resources if necessary
		if(refreshResources){
			// prevent loss of focus if resources will be refreshed only
			if(attachTriggerOptions.refreshResourcesOnly && componentTree.grantAutoFocus){
				componentTree.grantAutoFocus = false;
				componentTree.grantAutoFocusMasterComponentIndex = this.componentIndex;
			}

			// TODO: handle other picker types too?
			// TODO: is this handling necessary since getPostBuildFieldActions Update?
			var refreshAtomDataTypes = {
				routePickerFull: 'route-picker-full',
				resourcePicker: 'resource-picker',
				tagPicker: 'tag-picker'
			};
			for(var radt in refreshAtomDataTypes){
				if(((self.model || {}).atom || {}).dataType === refreshAtomDataTypes[radt] && (fieldCode = self.model.fieldCode)){
					self.closest('base_form_form', function(parentFormComponent){
						if((parentFormComponent.model.namedFields || {})[fieldCode]){
							// NOTE: it is not sure if the resourcePickers model should be overwritten completely on refresh. FURTHER TESTS NEEDED!
							self.model = parentFormComponent.model.namedFields[fieldCode];
							refreshBaseSources = parentFormComponent.performAction(radt + '_' + fieldCode, {autoRefresh: true, postBuildAction: false, refreshResourcesViaHeartbeatKey: attachTriggerOptions.refreshResourcesViaHeartbeatKey, heartbeatPrewarmedResourceHashes: attachTriggerOptions.heartbeatPrewarmedResourceHashes });
						}
					});
					break;
				}
			}
		}

		// when to load via parentAction:
		// 		- by default a component will be loaded via parentAction if a resource has to be refreshed.
		// 		- if a component is defined by intermediaryChildren those have to be refreshed as well, which can be achieved most easily by performing the parent action.
		// 			NOTE: the children may decide to load their resources despite the "refreshResources"-flag equals to false according to their own configuration.
		if(self.parentActionKey !== undefined && (refreshResources || (utils.collectionSize(this.intermediaryChildren) > 0 && !isCascadingRefresh))){
			self.parent(function(parentComponent){
				if(parentComponent.actions[self.parentActionKey]){
					refreshedByAction = true;
					refreshBaseSources
						.then(function(){
							if(utils.isFunction(onAfterResourceRefreshCallback)){
								onAfterResourceRefreshCallback.apply(self);
							}
							return parentComponent.performAction(self.parentActionKey, { refresh: true, refreshResources, refreshResourcesOnly: attachTriggerOptions.refreshResourcesOnly })
								.then(() => {
									if(utils.isFunction(onAfterRefreshDoneCallback)){
										onAfterRefreshDoneCallback.apply(self);
									}
									return true
								})
							;
						})
						.always(() => doneCallback ? doneCallback() : true)
				}
			});
		}


		if(!refreshedByAction){
			// refreshDOM
			(function(){
				var prepareAction;

				if(performChildActionsIfPossible){
					// perform child actions in order to get the resources of children refreshed
					// even if the actual component is a component between the action stake-holder and
					// the children which's resources have to be refreshed.
					prepareAction = self.actionPerformChildActions(true, { refreshResourcesViaHeartbeatKey: attachTriggerOptions.refreshResourcesViaHeartbeatKey, heartbeatPrewarmedResourceHashes: attachTriggerOptions.heartbeatPrewarmedResourceHashes });
				}
				else {
					prepareAction = utils.promise.resolve({ preventPrepare: true });
				}

				refreshBaseSources
					.fail(() => doneCallback ? doneCallback(false) : false)
					.then(function(){
						if(utils.isFunction(onAfterResourceRefreshCallback)){
							onAfterResourceRefreshCallback.apply(self);
						}
						prepareAction
							.fail(() => doneCallback ? doneCallback(false) : false)
							.then(function(data){
								// prepare component if necessary
								// TODO: maybe there should be used the recursive prepare method for db-component-children of the actual one
								if(!(data || {}).preventPrepare && utils.isFunction(self.prepare)){
									self.prepare(globalThis.storage, false, { refresh: true });
								}

								var $component;
								var triggerDone = false;
								if(attachTriggerOptions.refreshResourcesOnly){
									self.toDOM(self.$, CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.ATTACH, utils.merge(attachTriggerOptions, { refresh: true }), undefined, true, doneCallback, attachTrigger);
									// reset auto focus grant state
									if(!componentTree.grantAutoFocus && componentTree.grantAutoFocusMasterComponentIndex === self.componentIndex){
										componentTree.grantAutoFocus = true;
									}
									triggerDone = true
								}
								else if(($component = self.refresh$()).length > 0){
									self.toDOM($component, CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.REPLACE, utils.merge(attachTriggerOptions, { refresh: true }), undefined, true, doneCallback, attachTrigger);
									triggerDone = true
								}
								else if(utils.isFunction(onElementNotFoundCallback)){
									onElementNotFoundCallback.apply(self, [utils.simpleMerge(attachTriggerOptions, { refresh: true })]);
								}
								else {
									console.warn(`Component.refresh() - actual DOM-Element not found! ${self.componentIndex}`);
								}

								if(triggerDone && utils.isFunction(onAfterRefreshDoneCallback)){
									onAfterRefreshDoneCallback.apply(self);
								}
							})
					})
			})();
		}
	};

	/**
	 * this function acts similar to refresh() but inserts the DOM-Node at the target within the given $target.
	 *
	 * @param $target                   $ - jquery object identifying the target element within the DOM
	 * @param targetPosition            int - defines the position within $target according to CONSTANTS.COMPONENT.ACTION.TARGET.POSITION
	 * @param attachTriggerOptions      object - these options will be given to the attach trigger call after a successfull dom placement
	 * @param renderPath		        string - this optional parameter can be set to a componentTree node. by default the actual component (this) will be used.
	 * @param ignoreLastMileSelector    boolean - should the lastMileSelector be ignored (default: false) (this is useful for e.g., refresh operations)
	 * @param doneCallback        		function - this is needed to know when the dom operations are done. @see MARK: ACTION_DOM_DONE_CALLBACK for further details.
	 * @param attachTrigger		   		object - context object used to store promises needed to manage attach- and postAttach-phases.
	 */
	Component.prototype.toDOM = function($target, targetPosition, attachTriggerOptions, renderPath, ignoreLastMileSelector, doneCallback, attachTrigger){
		var renderComponent = renderPath || this;
		var triggerComponent;
		if(typeof(renderComponent) === 'string') 	triggerComponent = globalThis.componentTree.trees[renderComponent].children[globalThis.componentTree.trees[renderComponent].childLayoutIndex];
		else 										triggerComponent = this;

		var html = '';
		if(targetPosition != CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.ATTACH){
			var refRenderOptions = {
				cachedHtmlUsed: false
			};
			html = globalThis.componentTree.render(renderComponent, globalThis.storage, globalThis.routeParams, refRenderOptions);
			attachTriggerOptions.cachedHtmlUsed = !!refRenderOptions.cachedHtmlUsed;
		}

		// bring this component to dom according to targetPosition
		this._toDOMAttributes = {
			html:                   html,
			targetPosition:         targetPosition,
			$target: 				$target,
			lastMileSelector: 		this.config.lastMileSelector,
			ignoreLastMileSelector: ignoreLastMileSelector,
			triggerComponent:       triggerComponent,
			attachTriggerOptions:   attachTriggerOptions,
			doneCallback,
			attachTrigger,
		};

		globalThis.componentTree.registerEnvironmentChange(this, this._nrOfPreloadingFiles, !!this.inclusionKey);
	};

    /**
     * this function is used to bring the components rendered html code into the DOM.
     * NOTE: this is an internal function which must not be called by external functions.
     */
	Component.prototype.htmlToDOM = function(){
		var toDOMAttributes = this._toDOMAttributes || {};
		delete this._toDOMAttributes;
		var $target = toDOMAttributes.$target;
		var ignoreLastMileSelector = toDOMAttributes.ignoreLastMileSelector;
		var lastMileSelector = toDOMAttributes.lastMileSelector;
		const doneCallback = toDOMAttributes.doneCallback
		const attachTrigger = toDOMAttributes.attachTrigger || { start: null, doneList: [] }

		// target available
		if(utils.isEmpty($target) || $target.length <= 0){
			// prevent target not found error messages if a parent of mine renders it's subTrees conditionally.
			let renderingSubTreeConditionally = false

			this.parentComponents(undefined, parent => {
				if((parent.config || {}).renderingSubTreeConditionally){
					renderingSubTreeConditionally = true
					return false
				}
			}, true)
			if(!renderingSubTreeConditionally){
				console.error('Component.htmlToDOM() - $target not found' + ($target && $target.selector ? ' @ ' + $target.selector : '') + ' BY ' + this.componentIndex);
			}
			if(doneCallback) doneCallback();
			return;
		}

		// estimate real target according to last mile
		var $realTarget;
		if(ignoreLastMileSelector || utils.isEmpty(lastMileSelector) || $target.is(lastMileSelector)){
			$realTarget = $target;
			if($realTarget.length > 1) $realTarget = $realTarget.first();
		}
		else {
			$realTarget = $target.find(lastMileSelector).first();

			if($realTarget.length <= 0){
				console.error('Component.htmlToDOM() - target not found @ lastMile: ' + lastMileSelector);
				if(doneCallback) doneCallback(false);
				return;
			}
		}

		// add refresh loading if necessary (prevent flickering on refreshes by opacity on loading)
		var $html = $(toDOMAttributes.html);
		if((toDOMAttributes.attachTriggerOptions || {}).refresh && !(toDOMAttributes.attachTriggerOptions || {}).refreshResourcesOnly){
			$html.addClass('refreshLoading');
		}

		switch(toDOMAttributes.targetPosition){
			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.REPLACE:
				$realTarget.replaceWith($html);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML:
				$realTarget.html($html);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.BEFORE:
				$html.insertBefore($realTarget);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.AFTER:
				$html.insertAfter($realTarget);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.PREPEND:
				$realTarget.prepend($html);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.ATTACH:
				// NOTE: this function has to be used instead of the data function to get the [data-component-index="..."] jquery-selector working
				$realTarget.removeAttr('data-inclusion-key');
				$realTarget.attr('data-component-index', (toDOMAttributes.triggerComponent || {}).componentIndex);
				$realTarget.addClass((toDOMAttributes.triggerComponent || {}).componentClass);
				if((appConfig || {}).useIDSelector && !this.config.preventIDSelector){
					$realTarget.attr('id', utils.getComponentIDByIndex((toDOMAttributes.triggerComponent || {}).componentIndex));
				}
				break;

			default:
			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND:
			case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.MODAL:
				$realTarget.append($html);
				break;
		}

		// trigger attach when dom has been changed
		const triggerDonePromiseList = attachTrigger.doneList || []
		const triggerStartPromise = attachTrigger.start || utils.promise.resolve()
		const triggerEndPromise = utils.promise.newCustom(this)
		triggerDonePromiseList.push(triggerEndPromise)
		// triggerStartPromise will get resolved after all actionSources of this action are ready to be attached.
		triggerStartPromise.then(() =>
			globalThis.componentTree.trigger(toDOMAttributes.triggerComponent, 'attach', toDOMAttributes.attachTriggerOptions || {}, true, attachTrigger).then(() =>
				triggerEndPromise.resolve()
			)
		)

		// give child-actions like includes and so on a chance to register within the same doneList before starting the postAttach-phase.
		utils.promise.resolveAllDynamicList(this, triggerDonePromiseList).then(() =>
			globalThis.componentTree.trigger(toDOMAttributes.triggerComponent, 'postAttach', toDOMAttributes.attachTriggerOptions || {}, true)
		)

		// add container component class if necessary
		if(this.config.isContainerComponent && !utils.isEmpty(this.containerComponentClass)){
			this.$.addClass(this.containerComponentClass);
		}
		// add parents' container component class if necessary
		else if (this.config.dirtyContainerComponentClass){
			this.config.dirtyContainerComponentClass = false;
			this.parent(function(parentComponent){
				if(parentComponent.config.isContainerComponent && !utils.isEmpty(parentComponent.containerComponentClass)){
					parentComponent.$.addClass(parentComponent.containerComponentClass);
				}
			});
		}

		// check potential dom inconsistencies if necessary
		if(appConfig.debug.checkForMultipleComponentOccurrences){
			utils.forEach(globalThis.componentTree.lookup, function(component, componentIndex){
				if(component.refresh$().length > 1 && !component._error){
					// globalThis.componentTree.lookup[componentIndex]._error = new ClientError('MULTIPLE_COMPONENT_INDEX_USAGE_FOUND', 'the following component index is used multiple times within dom. ' + componentIndex + ' Usually this is because a container component has not been destroyed appropriately. Check last used modals and other container components.', CONSTANTS.ERROR.LEVEL.ERROR);
					globalThis.componentTree.lookup[componentIndex]._error = new Error('the following component index is used multiple times within dom. ' + componentIndex + ' Usually this is because a container component has not been destroyed appropriately. Check last used modals and other container components.', 'MULTIPLE_COMPONENT_INDEX_USAGE_FOUND');
					throw globalThis.componentTree.lookup[componentIndex]._error;
				}
			});
		}

		// refresh jquery pointer to element which has been changed / added / replaced within the dom
		this.refresh$()

		if(doneCallback) doneCallback();
	};

    /**
     * this function will be called if preloading is active and a file has been loaded.
     * NOTE: this is an internal function which must not be called by external functions.
     */
    Component.prototype.onFileLoadDone = function(){
        this._nrOfPreloadingFiles--;
	    globalThis.componentTree.registerEnvironmentChange(this, this._nrOfPreloadingFiles);
    };

    /**
     * this function is used to handle the different kinds of errors.
     * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
     * NOTE: if this function resolves the given context is allways the original context and NOT the error handling context.
     *
     * @param   context             object - action perform context
     *          {
     *              component: ...
     *              [action]: ...
     *              error: {
     *                  statusCode: <statusCode>            mixed - status code || 'clientError'
     *                  name: <statusCode>                  string - error name
     *                  errorCode: <statusCode>             string - error code
     *                  message: <statusCode>               string - error message
     *                  details: <statusCode>               string - error details
     *                  [childErrors]: []                   [] - list of child errors
     *              },
     *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
	 *                                      int - this error handling type defines the state of error handling
     *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
     *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
     *          }
     * @returns Promise
     */
    Component.prototype._handleError = function(context){
	    // check if error handling should be skipped (used to prevent infinite loops during error handling if error handling processes throw errors)
	    if(context.action && context.action.skipErrorHandling) return utils.promise.reject(context);

	    // init
	    var self = this;
	    var storage = this.getStorage()
	    if(!componentTree) componentTree = storage.componentTree;
		if(context.statusCode === undefined){
			if(context.error){
				context.statusCode = context.error.statusCode
			} else {
				context.statusCode = 'clientError'
			}
		}
	    context.errorHandlingType = context.errorHandlingType || CONSTANTS.ERROR.HANDLING_TYPE.DEFAULT;

		if(context.statusCode === 0){
			alert(storage.__('error:0.not-reachable.message'));
		}
	    else if(context.statusCode == 504){
			alert(storage.__('error:504.container-not-reachable.message'));
		}
	    else if(context.statusCode != 200 && context.statusCode != 201){
	    	if(context.errorHandlingType == CONSTANTS.ERROR.HANDLING_TYPE.DEFAULT){
				const errorHandlerComponents = []

			    // look for a local error handling function
			    if(utils.isFunction(context.component.handleError)){
					errorHandlerComponents.push(context.component)
			    }
			    // look for a local error handling function within the component's parents.
				context.component.parentComponents(undefined, function(parentComponent){
					if(utils.isFunction(parentComponent.handleError)){
						errorHandlerComponents.push(parentComponent)
					}
				}, true)

			    // try to handle error by local error handling functions (this is an error handling function defined by a component)
				// all parents (originalActionParents inclusive) will be asked to handle this error one after another bottom to top.
				if(errorHandlerComponents.length > 0){
					return utils.promise.resolveChain(
						context,
						errorHandlerComponents.map(errorHandlerComponent => (() => {
							// previous error handling functions may have set errorUnhandled
							context.errorUnhandled = false
							// error handling may have been skipped by an error handler executed prior to this one.
							if(errorHandlerComponent.isFurtherErrorHandlingSkipped()) return utils.promise.reject(false);

							return errorHandlerComponent.handleError(context)
								.then(errorHandlingContext => {
									// console.log('errorHandled by ', errorHandlerComponent.componentClass, context.errorUnhandled !== true)

									if (context.errorUnhandled && !errorHandlerComponent.isFurtherErrorHandlingSkipped()) {
										// let the next local errorHandler give it a try.
										return true
									}

									// if the error has been handled, abort the error handler chain.
									return utils.promise.reject(false)
								})
						}))
					).then(status => {
						// console.log('local errorHandling done', status, context.errorUnhandled)

						// may be an errorHandling error or just a chain abortion
						if(status.isRejected){

							// errorHandling produced another error
							const errorHandlingError = status.rejection
							if(!utils.isEmpty(errorHandlingError)){
								errorHandlingError.childErrors = errorHandlingError.childErrors || [];
								if(context.error) errorHandlingError.childErrors.push(context.error);
								context.error = errorHandlingError;
								context.errorHandlingType = CONSTANTS.ERROR.HANDLING_TYPE.DURING_LOCAL_ERROR_HANDLING;
								return self._handleError(context);
							}
						}

						// chain has been aborted or all error handlers had their chance.
						if(context.errorUnhandled){
							context.errorHandlingType = CONSTANTS.ERROR.HANDLING_TYPE.NOT_HANDLED_LOCAL;
							return context.component._handleError(context);
						}

						return utils.promise.resolve(context);
					})
				}
            }

			// handle error by global error handling function (this is an error handling function which is used as fallback because no component is able to handle this error)
			if(context.errorHandlingType == CONSTANTS.ERROR.HANDLING_TYPE.DEFAULT || context.errorHandlingType == CONSTANTS.ERROR.HANDLING_TYPE.NOT_HANDLED_LOCAL) {
				if(
					context.error.statusCode == 401
					||
					(
						context.error.statusCode == 403
						&&
						(
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_1'
							||
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_2'
							||
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_3'
							||
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_4'
							||
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_5'
							||
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_1'
							||
							context.error.errorCode === 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_2'
							||
							context.error.errorCode === 'LOCAL_USERMANAGEMENT_PROVIDER_LOGIN_ERROR'
							||
							context.error.errorCode === 'SHADOW_COMPONENT_NOT_GRANTED'
						)
					)
					||
					(
						context.error.statusCode == 400
						&&
						(
							context.error.errorCode === 'USERMANAGEMENT_LOGIN_PARAMETER_ERROR'
						)
					)
				){
					// TODO: check relogin with another user?
					// TODO: REMOVE LOCAL STORAGE?
					// re-perform submit-resource-actions after successful re-login.
					if(context.action.type === CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE) self.registerReperformer(context, 'relogin');
					if(self.isFurtherErrorHandlingSkipped()) return utils.promise.resolve();
					self.skipFurtherErrorHandling();

					const loginDialogParent = componentTree.lookup.errorParent || this
					return loginDialogParent.performAndStoreAction(
						undefined,
						loginDialogParent.prepareAction(appConfig.credentials.reLoginAction, undefined, {}, {
							skipRollback:  true,
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  '',
						})
					)
						.fail(function(errorHandlingError){
							errorHandlingError.childErrors = errorHandlingError.childErrors || [];
							if(this.error) errorHandlingError.childErrors.push(this.error);
							return self._handleError({
								error: errorHandlingError,
								errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE.DURING_GLOBAL_ERROR_HANDLING
							});
						})
					;
				}
				else {
					if(self.isFurtherErrorHandlingSkipped()) return utils.promise.resolve();
					self.skipFurtherErrorHandling();

					return componentTree.lookup.errorParent.performAndStoreAction(
						undefined,
						this.prepareAction('error', undefined, {
							errorDisplay: utils.simpleCopy(context.error)
						}, {
							skipErrorHandling:  true,
							rollbackContext:    context,
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  '',
						})
					)
						.fail(function(errorHandlingError){
							errorHandlingError.childErrors = errorHandlingError.childErrors || [];
							if(this.error) errorHandlingError.childErrors.push(this.error);
							return self._handleError({
								error: errorHandlingError,
								errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE.DURING_GLOBAL_ERROR_HANDLING
							});
						})
					;
				}
			}

		    // handle error by global error handling function
		    if(context.errorHandlingType == CONSTANTS.ERROR.HANDLING_TYPE.NOT_HANDLED_LOCAL || context.errorHandlingType == CONSTANTS.ERROR.HANDLING_TYPE.DURING_LOCAL_ERROR_HANDLING){
				if(self.isFurtherErrorHandlingSkipped()) return utils.promise.resolve();
				self.skipFurtherErrorHandling();

				return componentTree.lookup.errorParent.performAndStoreAction(
					undefined,
					this.prepareAction('error', undefined, {
						errorDisplay: utils.simpleCopy(context.error)
					}, {
						skipErrorHandling:  true,
						rollbackContext:    context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  '',
					})
				)
					.fail(function(errorHandlingError) {
						errorHandlingError.childErrors = errorHandlingError.childErrors || [];
						if(this.error) errorHandlingError.childErrors.push(this.error);
						return self._handleError({
							error: errorHandlingError,
							errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE.DURING_GLOBAL_ERROR_HANDLING
						});
					})
				;
		    }
		    // error during global error handling function (this is the last man standing)
		    else if(context.errorHandlingType == CONSTANTS.ERROR.HANDLING_TYPE.DURING_GLOBAL_ERROR_HANDLING){
				if(self.isFurtherErrorHandlingSkipped()) return utils.promise.resolve();
				self.skipFurtherErrorHandling();

				console.error('Fallback error handling:');
			    console.log(context);
			    alert('Error Handling error occurred. Please consult an administrator....');
		    }
		    else {
				if(self.isFurtherErrorHandlingSkipped()) return utils.promise.resolve();
				self.skipFurtherErrorHandling();

				console.error('unresolvable error:');
			    console.log(context);
			    alert('Unresolvable error occurred. Please consult an administrator....');
		    }
	    }
	    // skip error handling and rollback if no error happened
	    else {
		    return utils.promise.reject(context);
	    }

	    // perform further error handling promise chain parts if necessary
	    return utils.promise.resolve(context);
    };

	/**
	 * this function is used to handle notifications from the server.
	 * // TODO: IS THIS IN USE ANY WHERE??
	 *
	 * @param 		context             object - action perform context
	 * @private
	 */
	Component.prototype._handleNotification = function(context){
		if(context.response && context.response.notification && utils.isFunction(this.handleNotification)){
			return this.handleNotification(context);
		}
	};

    /**
     * this function is used to react on an error which has been handled by the server.
     *
     * @param       response        object - json response from server
     * @private
     */
    Component.prototype._handleServerError = function(response){
	    console.error(response);

	    var $body = $('body');
	    if($body.length > 0){
	    	var $error = $(response.error || '<html><body><h1>FEHLER</h1></body></html>');
	    	$body.html($error.find('body').html());
	    }
    };

    /**
     * this function is used to do everything necessary to bring the resourceRegisterContent into the right shape and
     * into the right location within the component.
     * NOTE: this function can be overwritten by specific component implementations to perform special stuff with this resourceRegisterContent.
     *
     * @param   data                        object - action promise chain context data
     * @param   actionSourceName            string - name of the actual performed action within data.action.source
     * @param   resourceRegisterContent     mixed - content of the resource register
     */
	Component.prototype._sanitizeResourceRegisterContent = function(data, actionSourceName, resourceRegisterContent){
		// set status flag
		data.component._resourceRegisterSanitationDone = true;

		// allow primitive types like strings
		if(!utils.isCollection(resourceRegisterContent) && parseInt(resourceRegisterContent) == resourceRegisterContent) resourceRegisterContent = { resourceID: resourceRegisterContent };

		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE){
			if(utils.isFunction(this.sanitizeResourceRegisterContent)){
				this.sanitizeResourceRegisterContent(data, actionSourceName, resourceRegisterContent);
			}
			else {
				this.resourceData = utils.simpleMerge(utils.isEmpty(this.resourceData) ? {} : this.resourceData, resourceRegisterContent);
			}
		}
		else if(data.action.source[actionSourceName].component && utils.isFunction(data.action.source[actionSourceName].component.sanitizeResourceRegisterContent)) {
			data.action.source[actionSourceName].component.sanitizeResourceRegisterContent(data, actionSourceName, resourceRegisterContent);
		}
		else {
			// merge resourceRegisterContent in componentData
			data.action.source[actionSourceName].componentData = data.action.source[actionSourceName].componentData || {};
			data.action.source[actionSourceName].componentData.resourceData = utils.merge(utils.isEmpty(data.action.source[actionSourceName].componentData.resourceData) ? {} : data.action.source[actionSourceName].componentData.resourceData, resourceRegisterContent);
		}

		// reperform resourceSanitation missed by build-process
		if(data.component._reperformResourceSanitation){
			delete data.component._reperformResourceSanitation;
			data.component._sanitizeResources(false);
		}
	};

    /**
     * this function is used to sanitize resources of this component and
     * according to the given recursive parameter all childComponents if possible.
     *
     * @param   recursive                   boolean - optional - for all child components?
     * @param   isCascadedDataDealerCall    boolean - internal - has this been a cascaded dataDealerCall?
     *                                      NOTE: do not use this if you don't know exactly what you are doing!
     */
    Component.prototype._sanitizeResources = function(recursive, isCascadedDataDealerCall){
        if(this.hasDataDealer && !isCascadedDataDealerCall){
	        this._dataDealer(true);
        }

		if(utils.isFunction(this.sanitizeResources)){
			this.sanitizeResources(storage);
		}

		if(recursive){
			this.find(undefined, function(childComponent){
				childComponent._sanitizeResources(undefined, isCascadedDataDealerCall);
			});
		}
    };

    /**
     * this function is used to register a resourceDependent component by the given componentIndex to
     * get it's dataDealer up and running when it's time.
     *
     * @param   componentIndex      int - componentIndex of resourceDependent component
     */
    Component.prototype.registerResourceDependent = function(componentIndex){
    	if(!componentIndex) return;
    	if(!this.resourceDependentsRegister) this.resourceDependentsRegister = {};
    	this.resourceDependentsRegister[componentIndex] = true;
    };

    /**
     * this function is used to trigger the dataDealers.
     *
     * @param       preventSanitizeResource     boolean - should the recursive resourceSanitize-call be prevented? (default: false)
     * @private
     */
    Component.prototype._dataDealer = function(preventSanitizeResource){
    	if(!this._dataDealerCalled){
		    this._dataDealerCalled = true;
		    this.dataDealer();

		    // sanitize resource in dependency of dataDealer-dependent resources if necessary
		    if(!preventSanitizeResource && !utils.isEmpty(this.resourceData) && utils.isFunction(this.sanitizeResources)){
			    delete this.resourceDependentsRegister;

		    	// NOTE: calls all necessary dataDealers by itself
			    this._sanitizeResources(true, true);
		    }
		    // perform all resourceDependents dataDealers
		    else if(this.resourceDependentsRegister){
		    	var childComponent, childComponentIndex;
		    	for(childComponentIndex in this.resourceDependentsRegister){
				    this.resourceDependentsRegister[childComponentIndex] = false;
		    		childComponent = getComponent(childComponentIndex);
		    		if(childComponent.hasDataDealer){
		    			childComponent._dataDealer(true);
				    }
			    }
		    }
	    }
    };

	/**
	 * this function returns the next free action index and increments the internal counter
	 *
	 * @returns int     next free action index
	 */
	Component.prototype.getNextActionIndex = function(){
		return ++this.actionIndex;
	};

    /**
     * this function is used to get all actions of the actual component and
     * it's children which have resource dependencies to the actual components' parent component.
     *
     * @param actionChainIndex      int - actionChainIndex
     *                              NOTE: this flag is used for function internal calls only and must not be set by external calls!!!
     * @param actualComponent       Component - actual Component
     *                              NOTE: this flag is used for function internal calls only and must not be set by external calls!!!
	 * @param options               @see this.actionPerformChildActions() options param
     * @returns {[]}                object containing a list of promise chain returning function lists
     */
    Component.prototype.getPostBuildChildActions = function(actionChainIndex, actualComponent, options){
	    var self = this;
	    if(actionChainIndex === undefined) actionChainIndex = 0;
	    var childActionIndex = 0;
	    var performActions = {};
	    var actions;

	    // collect own actions if necessary
	    if(actionChainIndex === 0){
	    	performActions = this.collectPostBuildChildActions(actionChainIndex, this);
		    actionChainIndex++;
	    }

	    // check actual sections' children
	    var ownActionChainList, childActionChainList;
	    utils.forEach(actualComponent === undefined ? this.children : actualComponent.children, function(child){
		    if(child.type === 'component') {
		    	// prepare components actions
			    ownActionChainList = self.collectPostBuildChildActions(actionChainIndex, child, options);
			    // prepare components' child actions
			    childActionChainList = child.getPostBuildChildActions(actionChainIndex + childActionIndex + 1, undefined, options);
		    }
		    else {
			    ownActionChainList = undefined;
			    // prepare sections' and routes' child actions
			    childActionChainList = self.getPostBuildChildActions(actionChainIndex + childActionIndex, child, options);
		    }

		    // merge action list without getting actions overwritten by utils.merge of arrays
		    utils.forEach([ownActionChainList, childActionChainList], function(actionChainList){
			    utils.forEach(actionChainList || [], function(newActionChain, newActionChainIndex){
			        if(Array.isArray(performActions[newActionChainIndex])){
				        performActions[newActionChainIndex] = performActions[newActionChainIndex].concat(newActionChain);
				    }
				    else {
					    performActions[newActionChainIndex] = newActionChain;
				    }
			    });
		    });
		    childActionIndex    += utils.collectionSize(actions);
	    });

	    return performActions;
    };

	/**
	 * this function returns a list of functions returning post build perform action processes used to initialize
	 * resources of fields (resource-pickers, route-pickers, tag-pickers, ...)
	 *
	 * @param actionChainIndex      int - actionChainIndex
	 *                              NOTE: this flag is used for function internal calls only and must not be set by external calls!!!
	 * @param actualComponent       Component - actual Component
	 *                              NOTE: this flag is used for function internal calls only and must not be set by external calls!!!
	 * @param performActions       	object - list of action chains
	 *                              NOTE: this flag is used for function internal calls only and must not be set by external calls!!!
	 * @param options				@see this.actionPerformChildActions() options param
	 * @returns {[]}                object containing a list of promise chains returning function lists
	 */
	Component.prototype.getPostBuildFieldActions = function(actionChainIndex, actualComponent, performActions, options){
		var self = this;
		if(actionChainIndex === undefined) actionChainIndex = 0;
		if(actualComponent === undefined) actualComponent = this;
		if(!performActions) performActions = {};
		if(!options) options = {};

		utils.forEach(actualComponent.actions, function (action, actionName) {
			if (
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE
				&&
				action.isFieldAction
				&&
				(
					action.refreshResourcesOnComponentRefresh
					||
					(
						!action.ready
						&&
						!action.preloadResources
					)
					||
					(
						options.refreshResourcesViaHeartbeatKey
						&&
						action.fieldIndex
						&&
						(((((actualComponent.model || {}).fields || [])[action.fieldIndex] || {}).config || {}).heartbeatRefreshOn || {})[options.refreshResourcesViaHeartbeatKey]
					)
				)
				&&
				action.autoLoadByParents
			) {
				if(!performActions[actionChainIndex]) performActions[actionChainIndex] = [];
				performActions[actionChainIndex].push(function() {
					// mark postBuildActions if this is not the original action
					return actualComponent.performAction(actionName, {autoRefresh: true, postBuildAction: true, postBuildFieldAction: true, refreshResourcesViaHeartbeatKey: options.refreshResourcesViaHeartbeatKey, heartbeatPrewarmedResourceHashes: options.heartbeatPrewarmedResourceHashes });
				});
			}
		});

		// look for postBuildFieldActions in children of the actual component
		utils.forEach(actualComponent.children || {}, function (child) {
			self.getPostBuildFieldActions(utils.collectionSize(performActions), child, performActions, options);
		});

		return performActions;
	};

    /**
     * this function is a helper function of getPostBuildChildActions().
     * NOTE: never ever call this method external!
     *
     * @param   actionChainIndex        int - actionChainIndex
     * @param   leaf                    object - component tree leaf
	 * @param 	options					@see this.actionPerformChildActions() options param
     * @returns {[]}                    object containing a list of promise chain returning function lists
     */
    Component.prototype.collectPostBuildChildActions = function(actionChainIndex, leaf, options){
		options = options || {}
	    const performActions = {}

	    utils.forEach(leaf.actions, function (action, actionName) {
		    if (
		    	action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE
				&&
				!action.isFieldAction
				&&
				(
					action.refreshResourcesOnComponentRefresh
					||
					(
						!action.ready
						&&
						!action.preloadResources
					)
					||
					(
						options.refreshResourcesViaHeartbeatKey
						&&
						((leaf.config || {}).heartbeatRefreshOn || {})[options.refreshResourcesViaHeartbeatKey]
					)
				)
				&&
				action.autoLoadByParents
			) {
			    if (performActions[actionChainIndex] == undefined){
				    performActions[actionChainIndex] = [];
			    }
			    performActions[actionChainIndex].push(function() {
					// mark postBuildActions if this is not the original action
					return leaf.performAction(actionName, {autoRefresh: true, postBuildAction: (actionChainIndex > 0), refreshResourcesViaHeartbeatKey: options.refreshResourcesViaHeartbeatKey, heartbeatPrewarmedResourceHashes: options.heartbeatPrewarmedResourceHashes });
				});
		    }
	    });

	    return performActions;
    };

    /**
     * this function is used to check each api response for something needed to be done.
     * NOTE: e.g., update the browsers' application storage when something relevant has changed on the server.
     *
     * @param   response        object - fec-response
     */
    Component.prototype.checkResponse = function(response){
    	var updateClientStorage;

	    // set client storage if necessary
	    if(
	    	(updateClientStorage = (response || {}).updateClientStorage) || // resource
	    	(updateClientStorage = ((((response || {}).children || {})[(response || {}).childLayoutIndex || 0] || {}).model || {}).updateClientStorage) // in component tree
		){
	    	// TODO: CHECK SERVER SIDE STORAGE USAGE
			const storage = this.getStorage()
			if(storage && updateClientStorage.session && updateClientStorage.session.user && storage.user){
				storage.user.reset();
			}
	    	store.set(updateClientStorage)
	    }
    };

	/**
	 * this function is used to prepare a dynamic action according to the given resourceID.
	 * NOTE: action can be an action object or a name of a prepared action.
	 *
	 * @see     Component.normalizeAction for action format
	 * @param   action             string || {} - action
	 * @param   resourceID         string - resourceID
	 * @param   resourceRegister   object - this is the resourceRegister which can be used if childComponents of the actual actionComponent needs access to resourceIDs of this action-sources
	 * @param   extensionData      object - optional data flag which will be merged directly into the actions' predefined component if it is defined
	 * @returns mixed - action in case of success or false otherwise
	 */
	Component.prototype.prepareAction = function(action, resourceID, resourceRegister, extensionData){
		var originalActionKey;

		if(!utils.isCollection(action)){
			originalActionKey = action;
			if(utils.isEmpty(this.actions[action])) this.importGlobalAction(action);
			action = utils.copy(this.actions[action]);
		}
		if(utils.isEmpty(action)){
			throw new ClientError('EMPTY_ACTION', (originalActionKey != undefined ? 'no action found @ ' + originalActionKey : ''), CONSTANTS.ERROR.LEVEL.CRITICAL);
		}
		if(originalActionKey != undefined){
			action.originalActionKey = originalActionKey;
		}

		// merge extension data into action according to given use case
		if(!utils.isEmpty(extensionData)){
			action = utils.merge(action, extensionData);
		}

		// merge resource register into action according to given use case
		if(!utils.isEmpty(resourceRegister)){
			if(
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD ||
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.TAB ||
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION
			){
				action.resourceRegister = action.resourceRegister || {}
				utils.refReplace(action.resourceRegister, resourceRegister)
			}
		}

		// set resourceID of actual element if necessary
		if(resourceID !== undefined && resourceID !== null){
			if(action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD || action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE){
				// NOTE: AWFUL
				// TODO: NOT AWFUL: Container dependency or so?
				if(
					action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD &&
					(((((action.source.load.componentData || {}).actions || {}).loadContent || {}).source || {}).load || {}).resourceConfig
				){
					action.source.load.componentData.actions.loadContent.resourceID = resourceID;
				}
				action.resourceID = resourceID;
			}
			else if(
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.TAB ||
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION ||
				action.type == CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE
			){
				action.resourceID = resourceID;
			}
			else {
				return new ClientError('ACTION_RESOURCE_SET_ID_ERROR', 'cannot set actions\' resourceID according to action-type: ' + action.type, CONSTANTS.ERROR.LEVEL.CRITICAL);
				// console.error('cannot set actions\' resourceID according to action-type: ' + action.type);
			}
		}

		return action;
	};

	/**
	 * this function is used to load a component from the frontend-controller if necessary.
	 *
	 * @see         Component.normalizeAction for action format
	 * @param       data
	 *              {
	 *                  action: <action>,
	 *                  component: <component>
	 *              }
	 * @param       actionSourceName (load, tab, tabContent, ...)
	 * @returns     promise({action: <changedAction>, component: <actualComponent>})
	 */
	Component.prototype.actionPrepareComponent = function(data, actionSourceName){

		// set parentActionKey if necessary. e.g., display message via message-modal-action =>
		// 		no key,
		// 		message-action gets copied from /tarantula,
		// 		will be performed without storage,
		// 		but has a resource-register which has to be reachable.
		if(utils.isEmpty(data.action.key) && !utils.isEmpty(data.action.originalActionKey)){
			data.action.source[actionSourceName].componentData = data.action.source[actionSourceName].componentData || {}
			data.action.source[actionSourceName].componentData.parentActionKey = data.action.originalActionKey
		}

		// estimate request parameters
		var componentRoute = '';
		var componentRequestType = '';
		var prepareComponent = false;
		var alternativeParentComponentInstanceIDs = [];
		if(data.action.source[actionSourceName].componentRoute !== undefined){
			componentRoute          = data.action.source[actionSourceName].componentRoute;
			componentRequestType    = 'component';
			prepareComponent        = true;
		}
		else if(data.action.source[actionSourceName].shadowComponentRoute !== undefined){
			componentRoute          = data.action.source[actionSourceName].shadowComponentRoute;
			componentRequestType    = 'shadowComponent';
			prepareComponent        = true;

			// prepare alternative shadow component parents to be able to locate cascaded shadow components
			if(data.component.config.wasShadowComponent){
				data.component.parentComponents(undefined, function(parentComponent){
					if(parentComponent.componentInstanceID) {
						alternativeParentComponentInstanceIDs.push(parentComponent.componentInstanceID);
					}
				});
			}
		}
		else if(data.action.source[actionSourceName].builtRoute){
			componentRoute          = data.action.source[actionSourceName].builtRoute;
			componentRequestType    = 'builtRoute';
			prepareComponent        = true;
		}
		else if(data.action.source[actionSourceName].builtRouteID){
			componentRoute          = '/~/routeByID/';
			componentRequestType    = 'builtRouteID';
			prepareComponent        = true;
		}

		// request shadow component if necessary
		if(prepareComponent && !data.action.ready){
			var url;
			if(componentRequestType === 'component' || componentRequestType === 'shadowComponent'){
				// since tab- and accordion-actions will not be performed twice any longer the original-action-parent has to be used for shadowComponent-identification in these cases.
				let originalParentComponentInstanceID
				const originalActionParentComponentIndex = (data.action.source[actionSourceName].componentData || {}).originalActionParentComponentIndex
				if(originalActionParentComponentIndex){
					const parentComponent = getComponent(originalActionParentComponentIndex) || {}
					if(parentComponent.componentInstanceID){
						originalParentComponentInstanceID = parentComponent.componentInstanceID
					}
				}
				url = appConfig.routes.api + '/' + componentRequestType + '/' + componentRoute + '/' + (originalParentComponentInstanceID || data.component.componentInstanceID || data.component.getNextAvailableParentComponentInstanceID() || '~') + (alternativeParentComponentInstanceIDs.length > 0 ? '-' + alternativeParentComponentInstanceIDs.join('-') : '');
			}
			else if(componentRequestType === 'builtRouteID'){
				url = componentRoute + parseInt(data.action.source[actionSourceName].builtRouteID);
			}
			else if(componentRequestType === 'builtRoute') {
				url = componentRoute;
			}
			else {
				throw new ClientError('ACTION_COMPONENT_URL_ERROR', 'the component url cannot be estimated for the given componentRequestType: ' + componentRequestType, CONSTANTS.ERROR.LEVEL.CRITICAL);
			}

			// define requestProperties to identify resourceHash
			// TODO: MARK: SPECIAL ROUTES + check /LTR => /~/LTR changes after nginx proxy update
			var requestProperties = {
				url: 		(!!data.action.source[actionSourceName].longTermRequest ? '/LTR' : '') + (data.action.source[actionSourceName].componentUrl = url),
				headers: 	utils.merge({fec_base_route: data.component._routePath || '~', fec_fallback_scope: this.scope || ''}, data.action.source[actionSourceName].headers || {})
			}
			if((appConfig.cache || {}).grantCacheByETag && data.action.source[actionSourceName].grantCacheByETag !== false){
				// identify etag by resourceHash
				requestProperties.resourceHash = utils.md5(JSON.stringify(requestProperties))
				requestProperties.etag = etagResourceHandler.getETag(requestProperties.resourceHash)
				// use etag if and only if the corresponding resource is present
				if(requestProperties.etag && !!etagResourceHandler.getResource(requestProperties.etag)){
					requestProperties.headers['If-None-Match'] = requestProperties.etag
				}
			}

			data.actionSourceName = actionSourceName

			return $.ajax({
				url: requestProperties.url,
				cache: false,
				ifModified: !!requestProperties.etag,
				headers: requestProperties.headers,
				context: data,
			}).fail(function(error){
				// invalidate etag on errors
				if(requestProperties.resourceHash){
					etagResourceHandler.setETag(requestProperties.resourceHash)
				}
				if(requestProperties.etag){
					etagResourceHandler.setResource(requestProperties.etag);
				}

				var e = error.responseJSON || {};
				if(error.status !== undefined && !e.statusCode) e.statusCode = error.status;

				data.errorQueue.push({
					error:              e,
					actionSourceName:   actionSourceName,
					processType:        'component'
				});
			}).then(function(response, responseStatus, rawResponse){

				// check etag if possible
				if((appConfig.cache || {}).grantCacheByETag){
					let etag = ''
                    try { etag = etagResourceHandler.returnETagIfValid(rawResponse.getResponseHeader('etag')) } catch (error) {}

					if(etag && requestProperties.resourceHash){
						// use previously loaded resource if possible
						if(responseStatus === 'notmodified'){
							var cachedResource = etagResourceHandler.getResource(etag)
							if(cachedResource){
								response = utils.simpleCopy(cachedResource)
							} else {
								// TODO: ERROR?
								return this;
							}
						}
						// save new resource for later usage
						else {
							// etag has changed: reset old etag to free unused memory
							if(requestProperties.etag && requestProperties.etag !== etag){
								etagResourceHandler.setResource(requestProperties.etag);
							}

							etagResourceHandler.setETag(requestProperties.resourceHash, etag);
							etagResourceHandler.setResource(etag, utils.simpleCopy(response));
						}
					}
				}

				// handle errors already handled by the server
				if(response && response.error){
					// TODO: REMOVE THIS?!
					this.component._handleServerError(response);
				}
				else {
					// check response for miscellaneous stuff (e.g., should the user data within the client storage be updated or not?)
					this.component.checkResponse(response);

					// response identified as shadowComponent
					if(!utils.isEmpty(response.config) && !utils.isEmpty(response.config.codeName)){
						this.action.source[this.actionSourceName].shadowComponent   = response.config.codeName;
						this.component.shadowComponents[response.config.codeName]   = response;
					}
					// response identified as componentTree
					else if(response.type === 'route' && response.subType === 'page') {
						this.action.source[this.actionSourceName].routePath 		= response.path;
						this.action.source[this.actionSourceName].componentTree		= response;
					}
				}

				return this;
			});
		}

		return utils.promise.resolve(data);
	};

	/**
	 * this function is used to load a component from the frontend-controller if necessary and to build it if necessary.
	 *
	 * @see         Component.normalizeAction for action format
	 * @param       data
	 *              {
	 *                  action: <action>,
	 *                  component: <component>
	 *              }
	 * @returns     promise({action: <changedAction>, component: <actualComponent>})
	 */
	Component.prototype.actionPrepareComponents = function(data){

		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD){
			return utils.promise.resolveAll(
				this,
				Object.keys(data.action.source).map(actionSourceKey => this.actionPrepareComponent(data, actionSourceKey))
			).then(function(result) {
				if (result.isRejected) {
					return utils.promise.reject(data)
				}
				return utils.promise.resolve(data)
			})
		}

		if (data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE){
			return this.actionPrepareComponent(data, 'load');
		}

		return utils.promise.resolve(data);
	};

	/**
	 * this function returns the ready to use resourceUrl according to the given data.
	 * NOTE: this function will be called by the server and the client!
	 *
	 * @param 	resourceHash			string - resourcehash
	 * @param 	data					object - optional - action context
	 * @param 	actionSourceName		string - optional - actionSourceName
	 * @param 	resourceRegisterContent	object - optional - resourceRegisterContent
	 * @returns string - resourceUrl
	 */
	Component.prototype.getResourceUrl = function(resourceHash, data, actionSourceName, resourceRegisterContent){
		var resourceID;
		var isFieldAction = false;
		var resources;

		if((data || {}).action){
			isFieldAction = Boolean(data.action.isFieldAction);
			resourceID = data.action.resourceID;
		}

		// write the resourceID according to the resourceRegister if necessary and possible
		if(utils.isEmpty(resourceID) && !utils.isEmpty(resourceRegisterContent) && !isFieldAction){
			if(utils.isCollection(resourceRegisterContent)){
				if(!utils.isEmpty(resourceRegisterContent.resourceID)) resourceID = resourceRegisterContent.resourceID;
			}
			else {
				resourceID = resourceRegisterContent;
			}
		}

		// write the resourceID according to the form-data if necessary and possible
		if(
			utils.isEmpty(resourceID) &&
			!isFieldAction &&
			(((data || {}).action || {}).key || ((data || {}).action || {}).originalActionKey) === 'refreshResources' &&
			(resources = ((this || {}).resourceData || {}).data) &&
			(resources.attributes || {})[resources.primaryKey || 0]
		){
			resourceID = resources.attributes[resources.primaryKey];
		}

		// set default resourceID
		if(utils.isEmpty(resourceID))	resourceID = '~';
		var resourceUrl = appConfig.routes.api + '/resource/' + resourceHash + '/' + resourceID;
		// set config resourceUrl for default resources used in forms to submit their changes.
		if(
			!isFieldAction &&
			data &&
			data.component &&
			data.component.config &&
			data.component.subType === 'form' &&
			!data.component.config.resourceUrl &&
			(data.action || {}).key === 'refreshResources'
		){
			data.component.config.resourceUrl = resourceUrl;
		}
		return resourceUrl;
	};

	/**
	 * this function is used to load the resources identified by the given action parameters from the frontend-controller if necessary.
	 *
	 * @see         Component.normalizeAction for action format
	 * @params      data
	 *              {
	 *                  action: <action>,
	 *                  component: <component>
	 *              }
	 * @params      actionSourceName - string actual action source name <action>.source.<actionSourceName>
	 * @returns     promise({action: <changedAction>, component: <actualComponent>})
	 */
	Component.prototype.actionPrepareResource = function(data, actionSourceName){
		const storage = this.getStorage()

		// should the resource be loaded?
		if((!data.action.ready && !data.action.preloadResources) || ((data.action.refreshResourcesOnComponentRefresh || data.action.attachTriggerOptions.refreshResourcesViaHeartbeatKey) && data.action.attachTriggerOptions.refreshResources !== false)){
			// estimate resource route
			var resourceHash        = false;
			var resourceUrlFound    = false;
			// resourceHash from previously prepared action
			if(!utils.isEmpty(data.action.source[actionSourceName].resourceUrl)){
				resourceUrlFound = true;
			}
			// resource config from shadow component
			else if(!utils.isEmpty(data.action.source[actionSourceName].shadowComponent) && !!data.component.shadowComponents[data.action.source[actionSourceName].shadowComponent] && !!data.component.shadowComponents[data.action.source[actionSourceName].shadowComponent].config && !utils.isEmpty(data.component.shadowComponents[data.action.source[actionSourceName].shadowComponent].config.resourceConfig)){
				resourceHash = this.shadowComponents[action.source[actionSourceName].shadowComponent].config.resourceConfig;
			}
			// resource config from action componentData
			else if(!!data.action.source[actionSourceName].componentData && !!data.action.source[actionSourceName].componentData.config && !utils.isEmpty(data.action.source[actionSourceName].componentData.config.resourceConfig)){
				resourceHash = data.action.source[actionSourceName].componentData.config.resourceConfig;
			}
			// resource config from action component
			// TODO: CLEANUP - this case should never ever be in charge
			else if(!!data.action.source[actionSourceName].component && !!data.action.source[actionSourceName].component.config && !utils.isEmpty(data.action.source[actionSourceName].component.config.resourceConfig)){
				// resourceHash = data.action.source[actionSourceName].component.config.resourceConfig;
				throw new Error('INVALID USAGE OF resourceConfig in parentAction of loaded component');
			}
			// actions' resource config found
			else if(!utils.isEmpty(data.action.source[actionSourceName].resourceConfig)){
				resourceHash = data.action.source[actionSourceName].resourceConfig;
			}

			// look for (within myself and my parents) and write the right resourceRegisterContents into the actual action if necessary
			let resourceRegisterContent
			let resourceRegisterKey
			// look for resourceRegisterKey in action
			if(data.action.source[actionSourceName].resourceRegisterKey !== undefined){
				resourceRegisterKey = data.action.source[actionSourceName].resourceRegisterKey;
			}
			else if(!utils.isEmpty(data.action.source[actionSourceName].componentData) && !utils.isEmpty(data.action.source[actionSourceName].componentData.config) && !utils.isEmpty(data.action.source[actionSourceName].componentData.config.resourceRegisterKey)){
				resourceRegisterKey = data.action.source[actionSourceName].componentData.config.resourceRegisterKey;
			}

			if(resourceRegisterKey !== undefined){
				// actions' resourceRegister is defined completely
				if((data.action.resourceRegister || {})[resourceRegisterKey] !== undefined){
					resourceRegisterContent = data.action.resourceRegister[resourceRegisterKey];
				}
				// resourceRegister is located within one of the actual components parents actions
				else {
					resourceRegisterContent = this.getResourceRegisterContent(resourceRegisterKey);
				}
			}
			// save resourceRegisterContent
			if(!utils.isEmpty(resourceRegisterContent)){
				this._sanitizeResourceRegisterContent(data, actionSourceName, resourceRegisterContent);
			}

			// resourceHash found?
			if(resourceUrlFound || !!resourceHash){
				// set resourceUrl if necessary
				if(!resourceUrlFound){
					data.action.source[actionSourceName].resourceUrl = data.component.getResourceUrl(resourceHash, data, actionSourceName, resourceRegisterContent);
				}

				// prepare resourceFilters to send
				var resourceFilters;
				if (data.action.source[actionSourceName].resourceFilters) {
					resourceFilters = data.action.source[actionSourceName].resourceFilters;
				}
				if(typeof(data.component.getResourceFilters) === 'function'){
					resourceFilters = data.component.getResourceFilters(storage, resourceFilters, data.action.originalActionKey || data.action.key || '', data.action.fieldCode || '', data.action.attachTriggerOptions || {});
				}

				// prepare optional data for request
				var optionalData;
				if(resourceFilters){
					optionalData = utils.replace(data.action.source[actionSourceName].data || {}, { resourceFilters: resourceFilters });
				} else {
					optionalData = data.action.source[actionSourceName].data || {};
				}
				if(!utils.isEmpty(optionalData)) 	optionalData = JSON.stringify(optionalData);
				else 								optionalData = undefined;

				// prepare additionalHeaders to send
				var additionalHeaders = {};
				if(typeof(data.component.getResourceAdditionalHeaders) === 'function'){
					additionalHeaders = data.component.getResourceAdditionalHeaders(storage, data.action.originalActionKey || data.action.key || '', data.action.fieldCode || '') || {};
				}

				var loadResourcesGrantedByComponent = typeof data.component.loadResourcesGranted !== 'function' || data.component.loadResourcesGranted(storage, resourceFilters, data.action.originalActionKey || data.action.key || '', data.action.fieldCode || '', data.action.attachTriggerOptions || {});

				// submit resource action
				if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE){
					// TODO: MARK: SPECIAL ROUTES + check /LTR => /~/LTR changes after nginx proxy update
					return $.ajax({
						url: (!!data.action.source[actionSourceName].longTermRequest ? '/LTR' : '') + data.action.source[actionSourceName].resourceUrl,
						cache: false,
						headers: utils.merge(additionalHeaders, {fec_base_route: data.component._routePath || 'NO_ROUTE_PATH_DEFINED', fec_fallback_scope: this.scope || ''}, data.action.source[actionSourceName].headers || {}),
						method: data.action.source[actionSourceName].httpMethod || 'POST',
						context: utils.replace(data, {
							actionSourceName: actionSourceName
						}),
						data: optionalData
					}).fail(function(error){
						var e = error.responseJSON || {};
						if(error.status !== undefined && !e.statusCode) e.statusCode = error.status;

						data.errorQueue.push({
							error:              e,
							actionSourceName:   actionSourceName,
							processType:        'resource'
						});
					}).then(function(response){
						// save response for later usage
						this.action.source[this.actionSourceName]._response = response;

						return this;
					});
				}
				// prevent resource load process if the action is marked writeOnly
				else if(data.action.source[actionSourceName].resourceWriteOnly){
					if (data.action.type != CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE) {
						// tell shadow component its resource url if necessary
						if(!!data.action.source[actionSourceName].shadowComponent){
							data.component.shadowComponents[data.action.source[actionSourceName].shadowComponent].config.resourceUrl = data.action.source[actionSourceName].resourceUrl;
						}
						// tell predefined component its resource url if necessary
						if(!!data.action.source[actionSourceName].component){
							data.action.source[actionSourceName].component.config.resourceUrl = data.action.source[actionSourceName].resourceUrl;
						}
					}
				}
				// load resources
				else if (
					(!data.action.source[actionSourceName].loadWhenPrimaryKeyPresentOnly || data.action.source[actionSourceName].resourceUrl.match(/\/~$/) === null)
					&&
					loadResourcesGrantedByComponent
				){

					// define requestProperties to identify resourceHash
					// TODO: MARK: SPECIAL ROUTES + check /LTR => /~/LTR changes after nginx proxy update
					const requestProperties = {
						method: 	data.action.source[actionSourceName].httpMethod || 'GET',
						url: 		(!!data.action.source[actionSourceName].longTermRequest ? '/LTR' : '') + data.action.source[actionSourceName].resourceUrl,
						headers: 	utils.merge(additionalHeaders, { fec_base_route: data.component._routePath || 'NO_ROUTE_PATH_DEFINED', fec_fallback_scope: this.scope || ''}, data.action.source[actionSourceName].headers || {}),
						data: 		optionalData
					}

					let refCachedResources
					if((appConfig.cache || {}).grantCacheByETag && data.action.source[actionSourceName].grantCacheByETag){
						// identify etag by resourceHash
						requestProperties.resourceHash = utils.collectionMD5(requestProperties)
						requestProperties.etag = etagResourceHandler.getETag(requestProperties.resourceHash)
						// use etag if and only if the corresponding resource is present
						refCachedResources = etagResourceHandler.getResource(requestProperties.etag)
						if(requestProperties.etag && !!refCachedResources){
							requestProperties.headers['If-None-Match'] = requestProperties.etag
						}
					}

					// trust cached resources if possible
					// e.g., if the heartbeat-prewarmer has loaded this very resource (identified via resourceHash) directly before this resource should be refreshed this should and would lead to a 304 request which then can be omitted.
					let getResourcesPromise
					if(
						(appConfig.cache || {}).grantCacheByETag &&
						requestProperties.resourceHash &&
						refCachedResources &&
						(data.action.attachTriggerOptions || {}).refreshResourcesViaHeartbeatKey &&
						((data.action.attachTriggerOptions || {}).heartbeatPrewarmedResourceHashes || {})[requestProperties.resourceHash]
					){
						getResourcesPromise = utils.promise.resolve(utils.simpleCopy(refCachedResources))
					}
					// get resources if necessary
					else {
						// register requestProperties for heartbeatPrewarming if possible
						const ajaxProperties = {
							url: requestProperties.url,
							cache: false,
							ifModified: !!requestProperties.etag,
							headers: requestProperties.headers,
							method: requestProperties.method,
							data: requestProperties.method !== 'GET' ? requestProperties.data : null
						}
						if((appConfig.cache || {}).grantCacheByETag && requestProperties.resourceHash && (data.action.source[actionSourceName].grantCacheByETag || {}).heartbeatRefreshOn){
							etagResourceHandler.registerRequestProperties((data.action.source[actionSourceName].grantCacheByETag || {}).heartbeatRefreshOn, requestProperties.resourceHash, ajaxProperties)
						}

						// get resources
						getResourcesPromise = $.ajax(ajaxProperties)
							.fail(error => {
								// invalidate etag on errors
								if(requestProperties.resourceHash){
									etagResourceHandler.setETag(requestProperties.resourceHash)
								}
								if(requestProperties.etag){
									etagResourceHandler.setResource(requestProperties.etag);
								}

								var e = error.responseJSON || {};
								if(error.status !== undefined && !e.statusCode) e.statusCode = error.status;

								data.errorQueue.push({
									error:              e,
									actionSourceName:   actionSourceName,
									processType:        'resource'
								});
							}).then((response, responseStatus, rawResponse) => {

								// check etag if possible
								if ((appConfig.cache || {}).grantCacheByETag && data.action.source[actionSourceName].grantCacheByETag) {
									let etag = ''
									try {
										etag = etagResourceHandler.returnETagIfValid(rawResponse.getResponseHeader('etag'))
									} catch (error) {
									}

									if (etag && requestProperties.resourceHash) {
										// use previously loaded resource if possible
										if (responseStatus === 'notmodified') {
											var cachedResource = etagResourceHandler.getResource(etag)
											if (cachedResource) {
												response = utils.simpleCopy(cachedResource)
											} else {
												// TODO: ERROR?
												return false
											}
										}
										// save new resource for later usage
										else if (response && response.data) {
											// etag has changed: reset old etag to free unused memory
											if (requestProperties.etag && requestProperties.etag !== etag) {
												etagResourceHandler.setResource(requestProperties.etag);
											}

											etagResourceHandler.setETag(requestProperties.resourceHash, etag);
											etagResourceHandler.setResource(etag, utils.simpleCopy(response));
										}
									}
								}
								return response
							})
					}

					// prepare resources if necessary
					return getResourcesPromise.then(response => {

						if(response !== false){

							let resourceFieldType = false
							let refModelField
							if(data.action.resourceFieldType){
								// standard form
								if(data.action.fieldCode && (refModelField = (data.component.model.namedFields || {})[data.action.fieldCode])){
									resourceFieldType = data.action.resourceFieldType
								}
								// standard form and tables
								else if(data.action.fieldIndex && (refModelField = (data.component.model.fields || {})[data.action.fieldIndex])){
									resourceFieldType = data.action.resourceFieldType
								}
							}

							switch(resourceFieldType){
								case 'resourcePicker':
									utils.fields.prepareResourcePicker(refModelField, refModelField, response, storage, { scope: data.component.scope });
									break;

								case 'tagPicker':
									utils.fields.prepareTagPicker(refModelField, refModelField, response, storage, undefined, data.component.scope); // TODO: scope vs resourceLoader scope cleanup
									break;

								case 'routePicker':
									utils.fields.prepareRoutePicker(refModelField, refModelField, response, storage, { scope: data.component.scope });
									break;

								case 'routePickerFull':
									utils.fields.prepareRoutePickerFull(refModelField, refModelField, response, storage, { scope: data.component.scope });
									break;

								case 'routeComponentPicker':
									utils.fields.prepareRouteComponentPicker(refModelField, refModelField, response, storage, { scope: data.component.scope });
									break;

								case 'categoryPicker':
									utils.fields.prepareCategoryPicker(refModelField, refModelField, response || {}, storage, { scope: data.component.scope });
									break;

								case 'mediaImage':
									utils.fields.prepareMediaImage(refModelField, refModelField, response, storage, { scope: data.component.scope });
									break;

								case 'mediaFile':
									utils.fields.prepareMediaFile(refModelField, refModelField, response, storage, { scope: data.component.scope });
									break;

								default:
									// save response for later usage
									data.action.source[actionSourceName]._response = response;
							}
						}


						// NOTE: for $.ajax({context}) downwards compatibility
						return utils.replace(data, {
							actionSourceName: actionSourceName
						})
					})
				}
			}

			// sanitize resource in dependency of resourceRegisterContent if necessary
			if(!utils.isEmpty(resourceRegisterContent) && !utils.isEmpty(data.component.resourceData) && utils.isFunction(data.component.sanitizeResources) && data.action.ready){
				data.component._sanitizeResources(true);
			}
		}

		return utils.promise.resolve(data);
	};

	/**
	 * this function is used to load the resources identified by the given action parameters from the frontend-controller if necessary.
	 *
	 * @see         Component.normalizeAction for action format
	 * @param       data
	 *              {
	 *                  action: <action>,
	 *                  component: <component>
	 *              }
	 * @returns     promise({action: <changedAction>, component: <actualComponent>})
	 */
	Component.prototype.actionPrepareResources = function(data){

		// refresh actual actions resourceRegister in original action in case of non stored actions
		if(utils.isEmpty(data.action.key) && !utils.isEmpty(data.action.originalActionKey)){
			// handle resourceRegister
			if(!utils.isEmpty(data.action.resourceRegister)){
				data.component.actions[data.action.originalActionKey].resourceRegister = data.action.resourceRegister;
			}
			else {
				delete data.component.actions[data.action.originalActionKey].resourceRegister;
			}
		}

		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD || data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE){
			return utils.promise.resolveAll(
				this,
				Object.keys(data.action.source).map(actionSourceKey => this.actionPrepareResource(data, actionSourceKey))
			).then(function(result){
				if (result.isRejected) {
					return utils.promise.reject(data)
				}

				return utils.promise.resolve(data)
			})
		}
		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE){
			return this.actionPrepareResource(data, 'load');
		}
		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE){
			return this.actionPrepareResource(data, 'submit');
		}

		return utils.promise.resolve(data);
	};

    /**
     * this function will be called after the component and the resource has been loaded, but before the component will be built.
     * it is used to call all needed sanitize functions according to the loaded resources
     *
     * @see         Component.normalizeAction for action format
     * @param       data
     *              {
	 *                  action: <action>,
	 *                  component: <component>
	 *              }
     * @returns     promise({action: <changedAction>, component: <actualComponent>})
     */
	Component.prototype.actionSanitizeResources = function(data){

		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD){
			return utils.promise.resolveAll(
				this,
				Object.keys(data.action.source).map(actionSourceKey => this.actionSanitizeResource(data, actionSourceKey))
			).then(function(result){
				if (result.isRejected) {
					return utils.promise.reject(data)
				}

				return utils.promise.resolve(data)
			})
		}
		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE || data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE){
			return this.actionSanitizeResource(data, 'load');
		}
		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE){
			return this.actionSanitizeResource(data, 'submit');
		}
		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.TAB){
			return utils.promise.resolveAll(
				this,
				[
					this.actionSanitizeResource(data, 'tab'),
					this.actionSanitizeResource(data, 'tabContent')
				]
			).then(function(result){
				if (result.isRejected) {
					return utils.promise.reject(data)
				}

				return utils.promise.resolve(data)
			})
		}
		if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION){
			return this.actionSanitizeResource(data, 'element');
		}

		return utils.promise.resolve(data);
	};

    /**
     * this function will be called after the component and the resource has been loaded, but before the component will be built.
     * it is used to call all needed sanitize functions according to the loaded resources of the given actionSourceName.
     *
     * @see         Component.normalizeAction for action format
     * @param       data
     *              {
	 *                  action: <action>,
	 *                  component: <component>
	 *              }
     * @param       actionSourceName - string actual action source name <action>.source.<actionSourceName>
     * @returns     promise({action: <changedAction>, component: <actualComponent>})
     */
    Component.prototype.actionSanitizeResource = function(data, actionSourceName){
    	var response = data.action.source[actionSourceName]._response;
	    if(response === undefined) {
	    	if(!data.action.ready){
			    // tell shadow component its resource url if necessary
			    if (!!data.action.source[actionSourceName].shadowComponent) {
				    data.component.shadowComponents[data.action.source[actionSourceName].shadowComponent].config.resourceUrl = data.action.source[actionSourceName].resourceUrl;
			    }
			    // tell predefined component its resource url if necessary
			    if (!!data.action.source[actionSourceName].component && data.action.source[actionSourceName].resourceUrl) {
				    data.action.source[actionSourceName].component.config.resourceUrl = data.action.source[actionSourceName].resourceUrl;
			    }
		    }
	    }
	    else {
		    // sanitize submit resource action
		    if(data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE){
			    // handle errors already handled by the server
			    if(response.error){
				    data.component._handleServerError(response);
			    }
			    else {
				    // check response for miscellaneous stuff (e.g., should the user data within the client storage be updated or not?)
				    data.component.checkResponse(response);

				    // TODO: CLEANUP
				    // console.log('submit receive', response, data);
				    // TODO: parallel resource loads not supported by response data structure
				    data.response = response;
			    }
		    }
		    // sanitize receive resource action
		    else {
			    // handle errors already handled by the server
			    if(response && response.error){
				    data.component._handleServerError(response);
			    }
			    else {
				    // check response for miscellaneous stuff (e.g., should the user data within the client storage be updated or not?)
				    data.component.checkResponse(response);

				    // perform a resource dependent actions - cleanup
				    data.component.resourceActionCleanup();

				    if (data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE) {
					    if (data.action.setResourceData) {
						    data.component.resourceData = response;

						    // inherit resources if necessary
							data.component.inheritResources(data, response);

						    // sanitize resources if possible
						    if ((!data.action.buildComponent || data.action.ready) && !utils.isEmpty(response) && utils.isFunction(data.component.sanitizeResources)) data.component._sanitizeResources(true);
					    }
					    else {
						    data.action.response = response;
					    }
				    }
				    else if (data.action.ready && data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD) {
					    let componentInCharge
						// MARK: COMPONENT_IN_CHARGE_ACTION_SOURCE_NAME_DILEMMA
						const actionSourceNames = ['load', 'tabContent']
						for(const actionSourceName of actionSourceNames){
							if(data.action.source[actionSourceName]){
								if (data.action.source[actionSourceName].routePath)  	componentInCharge = data.action.source[actionSourceName].componentTree.children[data.action.source[actionSourceName].componentTree.childLayoutIndex];
								else                                    				componentInCharge = data.action.source[actionSourceName].component;
								break;
							}
						}

					    componentInCharge.resourceData = response;

						// inherit resources if necessary
						data.component.inheritResources(data, response);

					    // sanitize resources if possible
					    if (utils.isFunction(componentInCharge.sanitizeResources) && !utils.isEmpty(response)) componentInCharge._sanitizeResources(true);
				    }
				    // prepare non-ready actions
				    else {
					    // merge resources
					    var componentDataContainerInCharge;
					    if (data.action.source[actionSourceName].routePath)    componentDataContainerInCharge = data.action.source[actionSourceName].componentTree.children[data.action.source[actionSourceName].componentTree.childLayoutIndex];
					    else                                                   componentDataContainerInCharge = data.action.source[actionSourceName].componentData;
					    componentDataContainerInCharge.resourceData = utils.merge(componentDataContainerInCharge.resourceData || {}, response);

					    // tell shadow component its resource url if necessary
					    if (!!data.action.source[actionSourceName].shadowComponent) {
						    data.component.shadowComponents[data.action.source[actionSourceName].shadowComponent].config.resourceUrl = data.action.source[actionSourceName].resourceUrl;
					    }
					    // tell predefined component its resource url if necessary
					    if (!!data.action.source[actionSourceName].component) {
						    data.action.source[actionSourceName].component.config.resourceUrl = data.action.source[actionSourceName].resourceUrl;
					    }
				    }
			    }
		    }
	    }

	    return utils.promise.resolve(data);
    };

	/**
	 * this function is used to inherit resource form one parent- to child-components.
	 * TODO: handle multi inheritance issues?
	 *
	 * @param data				object - action context
	 * @param resourceData		object - resourceData
	 */
	Component.prototype.inheritResources = function(data, resourceData){
    	if(!resourceData) return;
    	var actualResourceData = resourceData;

		data.component.find(undefined, function(childComponent){
			if(childComponent.config){
				if(childComponent.config.captureParentResources){
					childComponent.resourceData = actualResourceData
					// resourceUrls are needed e.g., for form submits
					if(!childComponent.config.resourceUrl && data.action.source.load.resourceUrl){
						childComponent.config.resourceUrl = data.action.source.load.resourceUrl
					}

				} else if(childComponent.config.inheritResources){
					if(
						childComponent.config.inheritResourceAlias &&
						childComponent.config.inheritResourceAliasContainer &&
						actualResourceData.data &&
						actualResourceData.data[childComponent.config.inheritResourceAliasContainer] &&
						actualResourceData.data[childComponent.config.inheritResourceAliasContainer][childComponent.config.inheritResourceAlias]
					){
						actualResourceData = actualResourceData.data[childComponent.config.inheritResourceAliasContainer][childComponent.config.inheritResourceAlias];
					}

					childComponent.resourceData = actualResourceData;
				}
			}
		});
	};

	/**
	 * this method is used to define if a component's resources may be loaded or not.
	 * in some cases it may be useful to let the component decide if it's resources should be loaded or not.
	 * NOTE: this method is meant to be overwritten!
	 * NOTE: this method will be called by the fec-server only since it prevents the registration of the resourceLoader only (not the loading itself)!
	 *
	 * @params 	storage 		object - actual storage
	 * @returns boolean success
	 */
	Component.prototype.preloadResourcesGranted = function(storage){
		return true;
	};

	/**
	 * this function is used to really perform an action.
	 *
	 * @see         Component.normalizeAction for action format
	 * @param       data
	 *              {
			 *                  component: <actualComponent>,
			 *                  action: <action>
			 *              }
	 * @returns     promise({action: <changedAction>, component: <actualComponent>})
	 */
	Component.prototype.actionBuild = function(data){

		// TODO: error testing
		// throw new Error('test Error');
		// throw new ClientError('INVALID_ERROR', 'some details for this error', CONSTANTS.ERROR.LEVEL.CRITICAL);

		// this function is only used to be able to abort nice
		// data.action = (function(data.action){


		// build action component and refresh resource if necessary
		if (data.action.buildComponent) {
			var self = this;

			// initialize action components if necessary
			if(!data.action.ready) {
				// call sanitizer used to manipulate the context before the componentTree.build will be processed
				if(typeof(data.component.preBuildSanitize) === 'function') data.component.preBuildSanitize(data);

				let intermediaryParentComponentIndex, intermediaryParentComponentInstanceID
				utils.forEach(data.action.source, function (source, sourceName) {
					intermediaryParentComponentIndex = 0
					intermediaryParentComponentInstanceID = 0

					// use correct parent identifiers for this build
					if(source.setParentViaActionSourceKey){
						if(((data.action.source[source.setParentViaActionSourceKey] || {}).component || {}).componentIndex){
							intermediaryParentComponentIndex = data.action.source[source.setParentViaActionSourceKey].component.componentIndex
							intermediaryParentComponentInstanceID = data.action.source[source.setParentViaActionSourceKey].component.componentInstanceID
						} else {
							data.error = new Error(`cannot set parent by defined setParentViaActionSourceKey flag for this componentBuild! componentIndex: ${self.componentIndex}, actionKey: ${data.action.key}, actionSourceName: ${sourceName}\n\nThis may happen if the action-source of a container is defined later in the list than the action-source of the element which is dependent on it.`)
							console.error(data.error)
							return false
						}
					}

					if (utils.isEmpty(source.component)) {
						// initialize shadow component
						if (!utils.isEmpty(source.shadowComponent) && !utils.isEmpty(self.shadowComponents[source.shadowComponent])) {
							data.action.source[sourceName].component = globalThis.componentTree.build(
								undefined,
								utils.merge(
									self.shadowComponents[source.shadowComponent],
									{
										type: 'component',
										config: {
											isShadowComponent: false,
											wasShadowComponent: true
										},
										parentActionKey: data.action.key,
										isParentActionStatic: !!data.action.static,
										parentActionSourceName: sourceName,
										intermediaryParentComponentIndex,
										intermediaryParentComponentInstanceID
									},
									source.componentData
								),
								false,
								false,
								true,
								globalThis.storage,
								undefined,
								undefined,
								undefined,
								undefined,
								data.component.config.isContainerComponent,
								false,
								data.component._routePath,
								undefined,
								self.componentIndex,
								self.componentInstanceID,
								true,
								self.scope
							);

							if(data.component.config.isContainerComponent && data.action.source[sourceName].component.potentialContainerComponentClasses){
								data.component.containerComponentClass = (data.component.containerComponentClass ? data.component.containerComponentClass + ' ' : '') + data.action.source[sourceName].component.potentialContainerComponentClasses.join(' ');
								data.action.source[sourceName].component.config.dirtyContainerComponentClass = true;
							}
							delete data.action.source[sourceName].component.potentialContainerComponentClasses;
							data.action.source[sourceName].component.model.decisionScope = data.action.decisionScope;
						}
						// initialize predefined component
						else if (!utils.isEmpty(source.componentData.component)) {
							data.action.source[sourceName].component = globalThis.componentTree.build(
								undefined,
								utils.merge(
									{
										type: 'component',
										parentActionKey: data.action.key,
										isParentActionStatic: !!data.action.static,
										parentActionSourceName: sourceName,
										intermediaryParentComponentIndex,
										intermediaryParentComponentInstanceID
									},
									source.componentData,
								),
								false,
								false,
								true,
								globalThis.storage,
								undefined,
								undefined,
								undefined,
								undefined,
								data.component.config.isContainerComponent,
								(source.componentData && source.componentData.config && source.componentData.config.isInclusionShadow),
								data.component._routePath,
								undefined,
								self.componentIndex,
								self.componentInstanceID,
								true,
								self.scope
							);

							if(data.component.config.isContainerComponent && data.action.source[sourceName].component.potentialContainerComponentClasses){
								data.component.containerComponentClass = (data.component.containerComponentClass ? data.component.containerComponentClass + ' ' : '') + data.action.source[sourceName].component.potentialContainerComponentClasses.join(' ');
								data.action.source[sourceName].component.config.dirtyContainerComponentClass = true;
							}
							delete data.action.source[sourceName].component.potentialContainerComponentClasses;
							data.action.source[sourceName].component.model.decisionScope = data.action.decisionScope;
						}
						// initialize loaded componentTree
						else if (!utils.isEmpty(source.routePath)) {
							// set layout components parameters defined by the action before build pocess starts.
							if(source.componentData && source.componentTree.children[source.componentTree.childLayoutIndex]){
								utils.refMerge(
									source.componentTree.children[source.componentTree.childLayoutIndex],
									{
										intermediaryParentComponentIndex,
										intermediaryParentComponentInstanceID,
										parentActionKey: data.action.key,
										isParentActionStatic: !!data.action.static,
										parentActionSourceName: sourceName,
										model: {
											decisionScope: data.action.decisionScope,
										}
									},
									source.componentData,
								)
							}

							globalThis.componentTree.build(
								source.routePath,
								source.componentTree,
								false,
								true,
								true,
								globalThis.storage,
								undefined,
								undefined,
								undefined,
								undefined,
								false,
								false,
								undefined,
								undefined,
								self.componentIndex,
								self.componentInstanceID,
								undefined,
								self.scope
							);

							// tree is saved within componentTree Class now. set componentTree as reference within the action.
							data.action.source[sourceName].componentTree = globalThis.componentTree.trees[source.routePath];
						}
					}
					// reinitialize action components data only
					else {
						// TODO: i think it should not be possible to re-build a component like this since postponed children were introduced.
						console.log('postponed children should have replaced this case')

						// NOTE: merge of whole component would kill the component prototype!
						utils.refMerge(data.action.source[sourceName].component.model, source.componentData.model || {})
						utils.refMerge(data.action.source[sourceName].component.config, source.componentData.config || {})

						// set action components' parent action parameters
						data.action.source[sourceName].component.parentActionKey = data.action.key
						data.action.source[sourceName].component.isParentActionStatic = !!data.action.static
						data.action.source[sourceName].component.parentActionSourceName = sourceName
						data.action.source[sourceName].component.originalActionParentComponentIndex = source.componentData.originalActionParentComponentIndex
						data.action.source[sourceName].component.originalParentActionKey = source.componentData.originalParentActionKey
						data.action.source[sourceName].component.model.decisionScope = data.action.decisionScope
					}
				});

				if(data.error){
					return utils.promise.reject(data)
				}

				// call sanitizer used to manipulate the context after the componentTree.build will be processed
				if(typeof(data.component.postBuildSanitize) === 'function') data.component.postBuildSanitize(data);
			}
		}

		// return fallback
		return utils.promise.resolve(data);
	};

	/**
	 * since actions support multiple different action parts now, the target preparation has to done once per actionSource instead of once per action.
	 * this function is used to do exactly that.
	 *
	 * @param data			object - action context
	 * @param refTarget		object - action-target reference
	 * @returns {{targetMode: number, target}}
	 */
	Component.prototype.prepareActionTarget = function(data, refTarget){
		let target, targetMode;

		// estimate target
		switch (refTarget.element) {
			case CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELECTOR:
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.JQUERY;
				target      = $(refTarget.selector);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR:
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.JQUERY;
				var $parent;
				if(!!refTarget.parentComponentInstanceID && this.componentInstanceID != refTarget.parentComponentInstanceID){
					this.parentComponents(undefined, function(parentComponent){
						if(parentComponent.componentInstanceID == refTarget.parentComponentInstanceID){
							$parent = parentComponent.refresh$();
							return false;
						}
					});

					if($parent === undefined){
						// TODO: throw error
						console.error('$parent not found for action target');
					}
				}
				else {
					$parent = this.refresh$();
				}
				target      = $parent.find(refTarget.selector);
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF:
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT;
				target      = this;
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.PARENT_COMPONENT:
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT;
				target      = this.parent();
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.JQUERY:
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.JQUERY;
				target 		= refTarget.$target
				break;

			case CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.ACTION_SOURCE_KEY:
				if(refTarget.actionSourceKey && (target = ((data.action.source || {})[refTarget.actionSourceKey || '~~~NOT_IDENFIEID_ACTION_SOURCE_KEY~~~'] || {}).component)){
					targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT;
				}
				else {
					console.error('target could not be estimated according to the given action.target', refTarget);
				}
				break;

			default:
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.INVALID;
				console.error('target could not be estimated according to the given action.target.element: ' + refTarget.element);
				return;
		}

		// switch to preferred mode whenever it is possible
		// load type prefers jquery
		if(data.action.type === CONSTANTS.COMPONENT.ACTION.TYPE.LOAD || data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE){
			if (targetMode === CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT) {
				targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.JQUERY;
				target      = target.refresh$();
			}
		}
		// other types prefer components
		else {
			if (targetMode === CONSTANTS.COMPONENT.ACTION.TARGET.MODE.JQUERY) {
				var targetComponentIndex = target.data('component-index');
				if (typeof(targetComponentIndex) !== 'undefined') {
					targetMode  = CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT;
					target      = getComponent(targetComponentIndex);
				}
			}
		}

		return {
			target,
			targetMode
		}
	};

    /**
     * this function is used to really perform an action.
     *
     * @see         Component.normalizeAction for action format
     * @param       data
     *              {
	 *                  component: <actualComponent>,
	 *                  action: <action>
	 *              }
     * @returns     promise({action: <changedAction>, component: <actualComponent>})
     */
    Component.prototype.actionPerform = function(data){
		// init
		var self = this;
		// var target, targetMode;

		// if a component performs multiple actions in parallel and one is dependent on the other it may wait until the first one is finished
		// this comes in handy if e.g., the tabs of a tabStrip should be loaded parallel but added in the same order as before.
		// NOTE: be careful where to use it since recursions (a waits for b and b waits for a) may lead to a deadlock.
		if((data.component.waitingActions || {})[data.action.waitForActionID || '~~~']){
			return data.component.waitingActions[data.action.waitForActionID].then(() => {
				// prevent endless loops if promise-event-handler is not fast enough deleting this waiting action
				delete data.component.waitingActions[data.action.waitForActionID]
				return this.actionPerform(data)
			})
		}

	    if (data.action.buildComponent || data.action.forwardedBuildComponent) {

			var {
				target,
				targetMode
			} = this.prepareActionTarget(data, data.action.target)

	    }

	    // check what to do
	    switch (data.action.type) {
		    // open a new window
		    case CONSTANTS.COMPONENT.ACTION.TYPE.OPEN:
			    // TODO: NIU?!
			    window.open(data.action.url, data.action.windowName);
			    break;

		    // open a tab in an existing tab strip
		    case CONSTANTS.COMPONENT.ACTION.TYPE.TAB:
			    if (targetMode !== CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT) {
				    // TODO: ERROR HANDLING
				    console.error('Component.actionBuild() - invalid target mode for action.type = CONSTANTS.COMPONENT.ACTION.TYPE.TAB');
			    }
			    else if(utils.isFunction(target.addTab)) {
				    // NOTE: tab actions do not need a focus tab if they are initialized.
				    // NOTE: they will be focused according to their last opened tab and this will be handled by the tabStrip itself.
				    // NOTE: BUT a tab action is (if not defined otherwise) NOT refreshPersistent. This leads to the behaviour that such a tab-action won't be called twice by autoRefresh.
				    // NOTE: as a matter of fact the action is reperformable if the user interacts with the gui but not automatically.
			        // NOTE: this action is only reperformable if the tab has not been removed (tabs can remove themselves under specific circumstances: e.g., by user gui interaction - close)
				    if (data.action.initialized && target.registry[data.action.tabConnection.tabRegisterSecret]) {
						target.registry[data.action.tabConnection.tabRegisterSecret].tab.activate()
				    }
				    else {
					    return target.addTab(data, self.componentIndex).then(function(tabData){
						    data.action.tabConnection = tabData.action.tabConnection;
						    data.action.initialized = true;

						    return utils.promise.resolve(data);
					    }).fail(function(context){
						    // this is necessary for external handler usage
						    data.action.tabConnection = context.action.tabConnection;

						    // save action to prevent tabConnection data from being deleted before rollback has been completed.
						    if(data.action.key) data.component.actions[data.action.key] = data.action;

						    target.removeTab(data.action.tabConnection.tabRegisterSecret);
						    return utils.promise.reject(this);
					    });
				    }
			    }
			    else {
			    	// TODO: throw error non tabstip component found
				    console.error('throw error non tabstip component found');
			    }
			    break;

			// TODO: are TYPE.TAB AND TYPE.ACCORDION not similar enough in order to combine them?
		    // open an accordion element in an existing accordion
		    case CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION:
			    if (targetMode !== CONSTANTS.COMPONENT.ACTION.TARGET.MODE.COMPONENT) {
				    // TODO: ERROR HANDLING
				    console.error('Component.actionBuild() - invalid target mode for action.type = CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION');
			    }
			    else if(utils.isFunction(target.addElement)) {
				    // NOTE: tab actions do not need a focus element if they are initialized.
				    // NOTE: they will be focused according to their last opened element and this will be handled by the accordion itself.
				    // NOTE: BUT an element action is (if not defined otherwise) NOT refreshPersistent. This leads to the behaviour that such an element-action won't be called twice by autoRefresh.
				    // NOTE: as a matter of fact the action is reperformable if the user interacts with the gui but not automatically.
			        // NOTE: this action is only reperformable if the element has not been removed (elements can remove themselves under specific circumstances: e.g., by user gui interaction - close)
				    if (data.action.initialized && target.registry[data.action.accordionConnection.elementRegisterSecret]) {
				    	target.registry[data.action.accordionConnection.elementRegisterSecret].element.activate(false);
				    }
				    else {
					    return target.addElement(data, self.componentIndex).then(function(elementData){
						    data.action.accordionConnection = elementData.action.accordionConnection;
						    data.action.initialized = true;

						    return utils.promise.resolve(data);
					    }).fail(function(context){
						    // this is necessary for external handler usage
						    data.action.accordionConnection = context.action.accordionConnection;

						    // save action to prevent accordionConnection data from being deleted before rollback has been completed.
						    if(data.action.key) data.component.actions[data.action.key] = data.action;

						    target.removeElement(data.action.accordionConnection.elementRegisterSecret);
						    return utils.promise.reject(this);
					    });
				    }
			    }
			    else {
			    	// TODO: throw error non accordion component found
				    console.error('throw error non accordion component found');
			    }
			    break;

		    // load content from api and render the conclusion into a given target
		    case CONSTANTS.COMPONENT.ACTION.TYPE.LOAD:
		    case CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE:
			    if(targetMode !== CONSTANTS.COMPONENT.ACTION.TARGET.MODE.JQUERY) {
				    console.error('Component.actionBuild() - loads has to have jquery objects!');
			    } else {
					// TODO: check if multi-actions with dependencies to one another (e.g., tab- or accordion-actions) may cause race-condition-errors.

					// MARK: ACTION_DOM_DONE_CALLBACK
					// perform the different action.source-elements in order of dependency.
					// setParentViaActionSourceKey-flag is in charge of this feature.
					// e.g., a tabContent should be rendered into a tabContentContainer.
					const actionSourcesByLevel = {
						pre: [],
						post: []
					}

					// "when are attach triggers allowed to run"-promise.
					// TODO: includes somehow share the same action context (data)?!
					data.attachTrigger.start = data.attachTrigger.start || utils.promise.newCustom(this)

					for(const actionSourceKey in data.action.source){
						const actionSource = data.action.source[actionSourceKey]

						let levelTarget
						if(actionSource.setParentViaActionSourceKey){
							// dependent action-sources have to wait until the other are done.
							levelTarget = actionSourcesByLevel.post
						} else {
							levelTarget = actionSourcesByLevel.pre
						}

						// add element to dom
						levelTarget.push(() => {
							// "when is this really done"-promise.
							const promise = utils.promise.newCustom(this)

							// single action source may override their target if necessary.
							let actionTarget 	= data.action.target
							let usedTarget 		= target
							if(actionSource.target){
								actionTarget = actionSource.target
								const preparedActionSourceTarget = this.prepareActionTarget(data, actionTarget)
								usedTarget = preparedActionSourceTarget.target
							}

							// identify component
							let component
							let renderPath
							let intermediaryParentComponentIndex
							if(!utils.isEmpty(actionSource.routePath)){
								// intermediaryParentComponentIndex may be set within the componentTree even before the action has been initialized
								let componentTree = actionSource.componentTree || {}
								if(componentTree.childLayoutIndex !== undefined && ((componentTree.children || {})[componentTree.childLayoutIndex] || {}).intermediaryParentComponentIndex){
									intermediaryParentComponentIndex = componentTree.children[componentTree.childLayoutIndex].intermediaryParentComponentIndex
								}

								if (data.action.initialized) {
									component = actionSource.componentTree.children[actionSource.componentTree.childLayoutIndex]
								} else {
									component = this
								}
								renderPath = actionSource.routePath
							} else {
								component = actionSource.component
								intermediaryParentComponentIndex = (component || {}).intermediaryParentComponentIndex
							}

							// action targets have to be corrected if setParentViaActionSourceKey is in effect.
							// e.g., if an addTab action is performed the tabContent has to be built and rendered just as if tabContentContainer had tabContent as a child,
							// event though the build process is handled by the tabstrip.
							// a "self" target-element would point to the wrong component in these cases. e.g., to the tabStrip instead of the tabContent.
							if(actionTarget.element === CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF){
								if(intermediaryParentComponentIndex){
									usedTarget = getComponent(intermediaryParentComponentIndex).$;
								} else if(component.parentComponentIndex) {
									usedTarget = getComponent(component.parentComponentIndex).$;
								}
							}

							if(!component){
								return promise.reject(new Error(`unable to complete this action without a component! componentIndex: ${this.componentIndex}, actionKey: ${data.action.key}`))
							}

							if (data.action.initialized) {
								component.refresh(false, data.action.attachTriggerOptions || {}, function(attachTriggerOptions){
									// TODO: check "this" for () => {} usage
									this.toDOM(usedTarget, actionTarget.position, attachTriggerOptions, renderPath, undefined, () => promise.resolve(), data.attachTrigger);
								}, false, undefined, undefined, true, () => promise.resolve(), data.attachTrigger);
							} else {
								if(data.action.type === CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE){
									// set _routePath of inclusion components
									component._routePath = data.component._routePath;
									// placholder replacement
									if(actionTarget.position == CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.ATTACH && data.action.placeholderRendered){
										actionTarget.position = CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.REPLACE;
									}
								}

								component.toDOM(usedTarget, actionTarget.position, data.action.attachTriggerOptions || {}, renderPath, undefined, () => promise.resolve(), data.attachTrigger);
							}

							return promise
						})
					}

					// preform then all
					return utils.promise.resolveChain(
						this,
						[
							() => utils.promise.resolveAll(this, actionSourcesByLevel.pre),
							() => utils.promise.resolveAll(this, actionSourcesByLevel.post)
						]
					).then(result => {
						data.action.initialized = true

						if(result.results[0].isRejected || result.results[1].isRejected){
							data.error = new Error('component.actionPerform() ERROR: if this one occurs the results should be checked')
							// TODO: why is this necessary to see this thingy
							console.error(data.error, result)
							return utils.promise.reject(data)
						}

						data.attachTrigger.start.resolve()
						return utils.promise.resolve(data)
					})
				}
			    break;

		    case CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE:
			    // NOTE: nothing to do. Resource has been loaded already
			    break;

		    case CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE:
			    // NOTE: nothing to do. Resource has been submited already
			    break;

		    // fallback
		    default:
			    console.error('unkown action could not be performed: ' + data.action.type);
			    break;
	    }

	    // return fallback
	    return utils.promise.resolve(data);
    };

    /**
     * this function is used to perform all static children's actions after the actionBuild of an action.
     * this is necessary in case of static children's resourceDependencies according to their parents.
     *
     * @param   data        Promise Context || true (true means perform child actions in context of the actual component
     * @param   options     {
	 *     						refreshResourcesViaHeartbeatKey: 'someKey', // field- and child-actions may decide if they have to refresh on their own.
	 *     						heartbeatPrewarmedResourceHashes: {<resourceHash>: true, ...} // field- and child-actions may decide if they can trust the cached data or not on their own.
	 * 						}
     * @returns Promise
     */
	Component.prototype.actionPerformChildActions = function(data, options = { refreshResourcesViaHeartbeatKey: false, heartbeatPrewarmedResourceHashes: {} }){
		var postBuildChildActions, postBuildFieldActions;

		// the one and only action type which is responsible for performing static child actions making sense is the load-action
		if(
			data === true ||
			data.action.type === CONSTANTS.COMPONENT.ACTION.TYPE.LOAD ||
			(
				// NOTE: inclusion shadows will be rendered in attach-phase to prevent errors caused by missing resources.
				data.action.type === CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE &&
				((((data.action.source || {}).load || {}).component || {}).config || {}).isInclusionShadow
			)
		){
			// prepare data dealers for all children which may get refreshed
			(data === true ? this : data.component).find(undefined, function(childComponent){
				if(childComponent.hasDataDealer){
					childComponent._dataDealerCalled = false;
				}
			});

			// TODO: FEC 5 UPDATE TESTING
			// estimate parent component containing the static children containing the actions which should be performed.
			const components = {};
			if(data === true) components.this = this;
			else {
				for(const actionSourceKey in data.action.source || {}){
					if((data.action.source[actionSourceKey] || {}).component){
						components[actionSourceKey] = data.action.source[actionSourceKey].component
					} else if((data.action.source[actionSourceKey] || {}).componentTree){
						components[actionSourceKey] = data.action.source[actionSourceKey].componentTree.children[data.action.source[actionSourceKey].componentTree.childLayoutIndex]
					}
				}
			}

			const promises = []
			for(const key in components || {}){
				// perform postBuildChildActions
				postBuildChildActions = components[key].getPostBuildChildActions(undefined, undefined, options);
				// perform postBuildFieldActions (e.g., LOAD -> load-resource-picker)
				postBuildFieldActions = components[key].getPostBuildFieldActions(undefined, undefined, undefined, options);
				promises.push(
					utils.promise.performAllChains(components[key], postBuildChildActions).then(() =>
						utils.promise.performAllChains(components[key], postBuildFieldActions).then(() => true)
					)
				)
			}

			return utils.promise.performAll(this, promises).then(() => data)
		}
		// e.g., LOAD -> LOAD_RESOURCES -> load-resource-picker
		else if (
			((data.action || {}).attachTriggerOptions || {}).postBuildAction
			&&
			!((data.action || {}).attachTriggerOptions || {}).postBuildFieldAction
		) {
			postBuildFieldActions = this.getPostBuildFieldActions();
			return utils.promise.performAllChains(this, postBuildFieldActions).then(function(fieldData){
				return utils.promise.resolve(data);
			});
		}

		// return promise fallback
		return utils.promise.resolve(data);
	};

    /**
     * this function is used to perform the preparation-phase within the perform-action-process.
	 * this means execute data dealers and the prepare methods afterwards.
     * dataDealers are used to move resources or other component-data from one component to another.
     * NOTE: this function calls the dataDealers in a late-decendant form (parents will be called first).
     * NOTE: dataDealers must not contain asyncronous code!
     * TODO: check if dataDealer phase is working on server-rendered code which will be attached to the component by the client afterwards.
     *
     * @param   data        Promise Context
     * @returns Promise
     */
    Component.prototype.actionPerformPreparation = function(data){
    	// call all dataDealers which are not located within postBuildAction-processes to prevent doubled dataDealer-calls.
    	if(data && data.component && data.action && data.action.attachTriggerOptions && !data.action.attachTriggerOptions.postBuildAction){
			if(data.component.hasDataDealer){
				data.component._dataDealer();
			}

			// perform all children-dataDealers
			data.component.find(undefined, function(childComponent){
				if(childComponent.hasDataDealer){
					childComponent._dataDealer();
				}
			});

			// TODO: check if this is a problem
			// perform all action component-dataDealers
			if(data.action.buildComponent && !data.action.ready){
				utils.forEach(data.action.source, function(source, sourceActionKey){
					if(source.component && source.component.hasDataDealer){
						source.component._dataDealer();
					}
					else if(source.componentTree && source.componentTree.hasDataDealer) {
						source.componentTree._dataDealer();
					}
				});
			}

			// execute prepare if necessary
			utils.forEach(data.action.source, function(source, sourceActionKey){
				let component
				if(source.component){
					component = source.component
				} else if(source.componentTree && source.componentTree.childLayoutIndex !== undefined) {
					component = (source.componentTree.children || [])[source.componentTree.childLayoutIndex]
				}

				if(component){
					globalThis.componentTree.executeOn(component, 'prepare', {
						storage: storage,
						isServer: false,
						options: {}
					}, true);
				}
			});
		}

    	return utils.promise.resolve(data);
    };

    /**
     * this function is used to perform the post-processing of an action.
     *
     * @see         Component.normalizeAction for action format
     * @param       data
     *              {
	 *                  component: <actualComponent>,
	 *                  action: <action>
	 *              }
     * @returns     promise({action: <changedAction>, component: <actualComponent>})
     */
    Component.prototype.actionPostProcessing = function(data){
	    if(data.action.postProcessing){
		    utils.forEach(Array.isArray(data.action.postProcessing) ? data.action.postProcessing : [data.action.postProcessing], function(postProcessing){
			    if(utils.isFunction(postProcessing)){
				    postProcessing(data);
			    }
			    else if(postProcessing.forward){
				    window.location.href = postProcessing.forward;
			    }
			    else if(postProcessing.reload){
				    window.location.href = window.location.href;
			    }
			    else if(postProcessing.destroyLocalStore){
					globalThis.store.destroy();
			    }
		    });
	    }

		// handle notifications if necessary
		var notificationPromise = data.component._handleNotification(data);
		if(notificationPromise && utils.isCollection(notificationPromise) && utils.isFunction(notificationPromise.promise)){
			return notificationPromise.then(function(notificationContext){
				return utils.promise.resolve(data);
			})
		}
		else {
			return utils.promise.resolve(data);
		}
    };

    /**
	 * this function is used to normalize action definitions and set default values if necessary.
	 * the following flags are building the action format:
	 *
	 * TODO: actualize docs!
	 *
	 * {
	 *      type: one of CONSTANTS.COMPONENT.ACTION.TYPE (LOAD is default)
	 *      buildComponent: <boolean> (if a component has to be built, will be decided according to the other parameters and will be overwritten if it is already defined),
	 *      component: <Component which will eventually be created for this action> (this field is not designed to be defined from outside)
	 *      source: {
	 *          [shadowComponent]: <CodeName of ShadowComponent (this can be a local one - defined by the actual component, or a global one - defined within the actual routes root component)>,
	 *          [resourceRoute]: <id of a resource which can be requested from frontend controller>,
	 *          // TODO: IMPL. (maybe the resource db names of the service system should be used here?!)
	 *          [resourceDB]: own (default) | useCase,
	 *          [model]: {
	 *              <all model flags which should be merged on the component which will eventually be created for this action>,
	 *              [resource]: {
	 *                  <this flag will be merged or defined (according to if it is predefined or not) by the data received via resourceRoute and resourceDB from the frontend controller)
	 *              }
	 *          },
	 *      },
	 *      target: {
	 *          element: one of CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT (SUB_SELECTOR is default)
	 *          position: one of CONSTANTS.COMPONENT.ACTION.TARGET.POSITION (HTML is default)
	 *          [selector]: <selector> (needed for selector and subSelector elements)
	 *      }
	 * }
	 *
	 * @param   action      mixed - {} action which should be normalized (format is described above) or action key of this.actions
	 * @returns             {} | boolean - normalized action or clientError in an error case
	 */
	Component.prototype.normalizeAction = function(action){
		// take default action if necessary
		action = action || 'default';

		// take prepared action if possible and necessary
		if(!utils.isCollection(action)){
			var actionKey = action;
			if(!utils.isEmpty(this.actions[actionKey]) || this.importGlobalAction(actionKey)) {
				action      = this.actions[actionKey];
				action.key  = actionKey;
				// if an action has been marked as ready it already has been normalized. so we can return here.
				if(!!action.ready) return action;
			}
			else {
				return new ClientError('ACTION_CANNOT_BE_FOUND_BY_KEY', 'ACTION_KEY: ' + actionKey, CONSTANTS.ERROR.LEVEL.CRITICAL);
				// console.error('Component.normalizeAction() - action cannot be found by key: ' + actionKey);
				// return false;
			}
		}

		// set ready state
		action.ready 				= action.ready || false

		// set default type
		action.type                 = action.type || CONSTANTS.COMPONENT.ACTION.TYPE.LOAD;

		// set if this is a static action or not (static actions are potentially overwritten ones which will not be deleted by a component destroy)
		action.static               = Boolean(action.type !== CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE && (!action.originalActionKey || action.originalActionKey === action.key || action.originalActionKey && !action.key));

		// set default resource dependency
		action.resourceDependent    = action.resourceDependent || false;

		// handle target properties if necessary
		if(action.type != CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE && action.type != CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE){
			action.target           = action.target || {};
			action.target.element   = action.target.element || CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR;
			action.target.position  = action.target.position || CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML;

			if(action.target.position == CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.MODAL){
				action.target.element = CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELECTOR;
				action.target.selector = action.target.selector || 'html > body';
			}

			if(utils.isEmpty(action.target.selector) && (action.target.element === CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELECTOR || action.target.element === CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR)){
				return new ClientError('ACTION_NO_TARGET_SELECTOR_DEFINED', 'some details for this error', CONSTANTS.ERROR.LEVEL.CRITICAL);
				// console.error('Component.normalizeAction() - no target selector defined!');
				// return false;
			}
		}

		// ensure numeric types of some fields
		if(utils.isString(action.type))                             action.type             = parseInt(action.type);
		if(action.target && utils.isString(action.target.element))  action.target.element   = parseInt(action.target.element);
		if(action.target && utils.isString(action.target.position)) action.target.position  = parseInt(action.target.position);

		// handle runtime decisions
		action.buildComponent = (
			action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD ||
			action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE
		);
		action.forwardedBuildComponent = (
			action.type == CONSTANTS.COMPONENT.ACTION.TYPE.TAB ||
			action.type == CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION
		);
		if(typeof(action.refreshResourcesOnComponentRefresh) === 'undefined') action.refreshResourcesOnComponentRefresh = action.buildComponent;

		// prepare source properties
		if(action.buildComponent && !utils.isEmpty(action.source)){
			utils.forEach(action.source, function(source, sourceName){
				action.source[sourceName].componentData = source.componentData || {};
			});
		}

		// set default refreshPersistent behaviour
		if(typeof(action.refreshPersistent) === 'undefined') action.refreshPersistent = action.type != CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE && action.type != CONSTANTS.COMPONENT.ACTION.TYPE.TAB && action.type != CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION;

		// set default autoLoadByParents behaviour
		if(action.autoLoadByParents == undefined) action.autoLoadByParents = false;

		// set default behaviour for LOAD_RESOURCE target
		if(action.setResourceData == undefined) action.setResourceData = false;

		return action;
	};

	/**
	 * this function is used to perform actions. this can be a "tab open", dynamic loading of a foreign sub-component-tree and so on.
	 *
	 * @see         Component.normalizeAction for action format
	 * @param       action                          mixed - empty for default action stored in this.actions.default || action key for stored action || {} action definition.
	 * @param       actionAttachTriggerOptions      object - options used for the attach-trigger of the action component(s)
	 * @param       decisionScope      				object - action decisionScope to use
	 * @param 		attachTrigger		   			object - context object used to store promises needed to manage attach- and postAttach-phases.
	 * @returns     promise({action: <performedAction>, component: <actualComponent>})
	 */
	Component.prototype.performAction = function(action, actionAttachTriggerOptions, decisionScope, attachTrigger){

		// check if action can be performed and normalize action if so
		if(action instanceof ClientError) return utils.promise.reject(action);
		action = this.normalizeAction(action);
		if(action instanceof ClientError) return utils.promise.reject(action);

		// save reset action to be able to perform a reset of this action if and only if this is the first execution of this action
		if(!this.resetActions[action.key || action.originalActionKey] && action.static){
			this.resetActions[action.key || action.originalActionKey] = utils.simpleCopy({
				...action,
				rollbackContext: undefined
			});
		}

		// set additional attach trigger options
		action.attachTriggerOptions = utils.merge(action.attachTriggerOptions || {}, actionAttachTriggerOptions || {});

		const self = this;
		const data = actionRegistry.register({ component: this, action: action, errorQueue: [], statusShown: false, attachTrigger: attachTrigger || { start: null, doneList: [] } })
		data.action.decisionScope = decisionScope || {};
		data.component._nrOfActionsInProgress++;

		// if a component performs multiple actions in parallel and one is dependent on the other it may wait until the first one is finished
		// this comes in handy if e.g., the tabs of a tabStrip should be loaded parallel but added in the same order as before.
		// NOTE: be careful where to use it since recursion (a waits for b and b waits for a) leads to a deadlock.
		data.component.waitingActions = data.component.waitingActions || {}
		if(data.action.isAwaitable && data.action.key && !data.component.waitingActions[data.action.key]){
			// if some crazy component performs two actions with the same key in parallel before the first one is done this part would misbehave if the real waitingAction-creator would not be marked. this is what this flag is for.
			data.action.isAwaitableCreator = true
			data.component.waitingActions[data.action.key] = utils.promise.newCustom(this)
		}

		var statusController;
		if(
			appConfig.statusControllerActionHandling
			&&
			(statusController = getComponent('statusController'))
			&&
			(
				(
					data.action.statusControllerLoading = (
						data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD
						||
						data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE
						||
						data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.TAB
						||
						data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION
					)
				)
				||
				(
					data.action.statusControllerSaving = (
						data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE
					)
				)
			)
		){
			var message;
			if(data.action.statusControllerLoading){
				message = 'status.progress.load';
				if(data.action.statusControllerLoadingMessage != undefined) message = data.action.statusControllerLoadingMessage;
			}
			else if(data.action.statusControllerSaving){
				message = 'status.progress.save';
				if(data.action.statusControllerSavingMessage != undefined) message = data.action.statusControllerSavingMessage;
			}

			if(message){
				statusController.showStatus(message);
				data.statusShown = true;
			}
			else {
				data.action.statusControllerLoading = false;
				data.action.statusControllerSaving  = false;
			}
		}

		if(appConfig.timeMeasurement) data.timings = [{ title: 'ACTION - START', ts: new Date().getTime() }];

		// TODO: maybe it would be wise to prevent most of the other action steps for TAB and ACCORDION actions until .actionPerform()

		// reconnect heartbeatController if necessary
		if(globalThis.heartbeatController) {
			globalThis.heartbeatController.reconnect()
		}

		return utils.promise.resolveAll(data, [
			data.component.actionPrepareComponents(data),
			data.component.actionPrepareResources(data)
		])
		.then(function(result){

			if(result.isRejected){
				// errorHandlers may handle the full error queue or just the first error found.
				data.error = (data.errorQueue[0] || {}).error

				return data.component._handleError(data)
					.then(function(data){
						if(((data || {}).component || {}).rollbackAction){
							return data.component.rollbackAction(data);
						}
						return utils.promise.resolve();
					})
					.then(function(){
						// component's error handler may decide to force the action to continue.
						// e.g., if a ninja component does not exist a 404 error should not prevent the corresponding tab from being rendered.
						if(data.forceActionSuccess){
							return utils.promise.resolve(data)
						}
						return utils.promise.reject(data)
					})
				;
			}

			return utils.promise.resolve();
		}).then(function(){
			if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - LOADED', ts: new Date().getTime() });

			// check if this action should be aborted
			if(typeof(data.component.abortAction) === 'function' && data.component.abortAction(data) === true){
				return utils.promise.abort(data);
			}

			// NOTE:    the response of the previous promises will be set within the data-reference.
			//          so there is no need for updating the data flag here.
			return data.component.actionSanitizeResources(data).then(function(data){
				if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - RESOURCE SANITIZE', ts: new Date().getTime() });
				return data.component.actionBuild(data).then(function(data){
					if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - BUILD', ts: new Date().getTime() });
					return data.component.actionPerformChildActions(data).then(function(data){
						if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - PERFORM CHILD ACTIONS', ts: new Date().getTime() });
						return data.component.actionPerformPreparation(data).then(function(data){
							if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - PERFORM PREPARATION', ts: new Date().getTime() });
							return data.component.actionPerform(data).then(function(data){
								if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - PERFORM', ts: new Date().getTime() });
								return data.component.actionPostProcessing(data).then(function(data){
									if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - POST PROCESSING', ts: new Date().getTime() });
									if(!utils.isEmpty(data.action.key)){
										// delete attach trigger options each time an action has been performed
										delete data.action.attachTriggerOptions;

										// set this action as ready for work
										action.ready = true;

										// store action
										data.component.actions[data.action.key] = action;
										if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - POST PROCESSING DONE', ts: new Date().getTime() });
									}

									return utils.promise.resolve(data);
								});
							});
						});
					});
				});
			});
		}).then(function(data){

			if(appConfig.timeMeasurement && data.timings) data.timings.push({ title: 'ACTION - FOCUS', ts: new Date().getTime() });

			// focus right component if necessary
			if(
				data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD
				||
				(
					data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.LOAD_RESOURCE
					&&
					!$('*:focus:visible').length
				)
				||
				data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.TAB
				||
				data.action.type == CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION
			){
				componentTree.focusRightComponent()
			}

			return utils.promise.resolve(data);
		}).always(function(){

			// release waiting actions
			if(data.component.waitingActions[(data.action || {}).key || '~~~'] && data.action.isAwaitableCreator){
				data.component.waitingActions[data.action.key].resolve()
				// prevent unnecessary entries if nobody is waiting
				delete data.component.waitingActions[data.action.key]
			}

			if(appConfig.timeMeasurement && data.timings){
				data.timings.push({ title: 'ACTION - DONE', ts: new Date().getTime() });
				var timings = "\n";
				for(var t = 1; t < data.timings.length; t++){
					data.timings[t].delta = data.timings[t].ts - data.timings[0].ts;
					timings += "\t" + (data.timings[t].delta || 0) + ' [' + (data.timings[t].ts - data.timings[t-1].ts) + ']: ' + data.timings[t].title + " ;\n";
				}

				// console.log('ACTION-TIMING', data.component.componentIndex, data.component.componentClass, data.action.type, timings);
			}

			// console.log('end');

			var statusController;
			if(data && (statusController = getComponent('statusController'))){
				if(data.action){
					if(data.statusShown){
						statusController.removeStatus();
					}
				}
				else {
					statusController.removeStatus(true);
				}
			}

			self._nrOfActionsInProgress--;
			actionRegistry.deregister(data)
			if(self._nrOfActionsInProgress <= 0){
				self.releaseFurtherErrorHandling()
				globalThis.componentTree.killingSpree(self.componentIndex);
			}
		});
	};

	/**
	 * this function is used to perform actions and store then in the components action store.
	 *
	 * @see     Component.performAction for action format
	 * @param   id                      string - optional - identifies the action within the store. this value can be used later to perform the action again by Component.performAction. if this value is undefined a dynamic id will be generated.
	 * @param   action                  mixed - {} action definition (see Component.normalizeAction() for documentation).
	 * @param   forceActionOverwrite    boolean - should the action be overwritten if the actionID has already been defined
	 * @return  promise                 promise({action: <changedAction>, component: <actualComponent>})
	 */
	Component.prototype.performAndStoreAction = function(id, action, forceActionOverwrite){
		// id fallback definition
		if(typeof(id) === 'undefined') id = 'dyn_' + this.getNextActionIndex();

		// set action id for scope issues if necessary
		if(utils.isEmpty(this.actions[id]) || forceActionOverwrite){
			action.key = id;

			// overwrite existing action may lead to component (or componentTree) destroy.
			if(forceActionOverwrite){
				utils.forEach((this.actions[id] || {}).source, (source, sourceName) => {
					if(source.component instanceof Component){
						source.component.destroy();
					}
					if(source.componentTree && source.componentTree.childLayoutIndex != undefined && source.componentTree.children[source.componentTree.childLayoutIndex] instanceof Component){
						source.componentTree.children[source.componentTree.childLayoutIndex].destroy();
					}
				});
			}

			// actions may wait only for stored actions by id (action.key)
			action.isAwaitable = true

			this.actions[id] = action;
		}

		// perform action and save action result
		return this.performAction(id);
	};

    /**
     * this function is used to perform a decision which is mainly an action.
     * the only difference to an action is that the promise returned will be resolved when the user has made a decision
     * instead of the load action has been done.
     *
     * @param action                    object - action to perform
     * @param variables                 object - this variables object will be given to the actions component as decisionScope
     * @param attachTriggerOptions      object - attach trigger options (work like those of normal actions)
     */
	Component.prototype.performDecision = function(action, variables, attachTriggerOptions){
		return this.performAction(action, attachTriggerOptions, variables).then(function(context){
			context.action.decision = $.Deferred();
			return context.action.decision.promise();
		});
	};

    /**
     * if the component loaded via action within the performDecision process has to call this function when the user
     * has made a decision. the decider component can implement a decided-function which knows what to do with
     * itself after the user has made a decision. if not the decider component will be destroyed immediately.
     * the given decision parameter will be given within the promise resolve in the following format:
     *      {
     *          decision: <decision>,
     *          scope:    <decisionScope of the decider component>
     *      }
     *
     * @param decision      mixed - this is up to the decider component
     */
	Component.prototype.decide = function(decision){
		var parentComponent, action;
		if(
			this.parentActionKey &&
			this.parentComponentIndex &&
			(parentComponent = getComponent(this.parentComponentIndex)) &&
			(action = parentComponent.actions[this.parentActionKey]) &&
			action.decision && typeof(action.decision.resolve) === 'function'
		){
			action.decision.resolve({
				decision:   decision,
				scope:      action.decisionScope || {}
			});
		}

		if(typeof(this.decided) === 'function'){
			this.decided(decision);
		}
		else {
			var $activeElement = $(document.activeElement);
			this.destroy();
			if($activeElement.length > 0){
				$activeElement.focus();
			}
		}
	};

	/**
	 * show modal message
	 *
	 * @param resourceRegister	object - define messageDisplay and other stuff if necessary
	 * @param extensionData		object - define rollbackContext and other stuff if necessary
	 * @returns {actionContext}
	 */
	Component.prototype.performMessage = function(resourceRegister, extensionData){
		return this.performAction(
			this.prepareAction(
				'message',
				undefined,
				resourceRegister || {},
				{
					...(extensionData || {}),
					statusControllerLoadingMessage: '',
					statusControllerSavingMessage:  ''
				}
			)
		);
	};

    /**
     * this function is used to replace the parent identifiers of the actual component by the given component
     * NOTE: use this function with caution! there are no layout dependent or other fancy checks at the moment.
	 * // TODO: is this in use anywhere?
     *
     * @param   newParentComponent      Component - new parent component
     * @returns boolean - success
     */
    Component.prototype.replaceParentBy = function(newParentComponent){
    	if(!newParentComponent) return false;

    	this.parentComponentIndex       = newParentComponent.componentIndex;
    	this.parentComponentInstanceID  = newParentComponent.componentInstanceID;
    	delete this.parentSectionID;
    	this.parentTemplateID           = newParentComponent.templateID;

    	// TODO: complete this list in case of bugs according to parent- or action-parent- parameters

    	return true;
    };

    /**
     * this function is used to import the action identified by the given actionKey
     * from the global action stores (root-layout-components) to the actual components action store.
     * NOTE: it returns false if the action cannot be found.
     *
     * @param   actionKey       string | int - actionKey
     * @returns                 boolean - true if the action has been successfully imported or false in an error case
     */
	Component.prototype.importGlobalAction = function(actionKey){
		if(!utils.isCollection(actionKey)){
			// import route action
			let sourceAction
			// TODO: check all parent routes instead of rootRoute only
			// TODO: check parent routes before parent components?
			for(const route of [this._routePath, globalThis.rootRoute]){
				const {
					children,
					childLayoutIndex
				} = (globalThis.componentTree.trees[route || '~~~MISSING~ROUTE~~~'] || {})
				if((sourceAction = (((children || {})[childLayoutIndex || '~~~MISSING~CHILD~LAYOUT~INDEX~~~'] || {}).actions || {})[actionKey])){
					this.actions[actionKey] = utils.copy(sourceAction)
					return true
				}
			}

			// check parent components
			let actionFound = false
			this.parentComponents(undefined, parentComponent => {
				if(!actionFound && (parentComponent.actions || {})[actionKey]){
					this.actions[actionKey] = utils.copy(parentComponent.actions[actionKey])
					actionFound = true
					return false
				}
				return true
			})
			if(actionFound){
				return true
			}

			// check globalActions
			if((sourceAction = (globalThis.componentTree.globalActionsByScope[this.scope || '~'] || {})[actionKey])){
				this.actions[actionKey] = utils.copy(sourceAction)
				return true
			}
		}
		return false
	};

    /**
     * this function is used to return the wanted action.
     * NOTE: this is useful if another component should be able to use it.
     *
     * @param   actionKey       string - wanted actionKey
     * @param   actionExtension object - optional - action extension data will be merged on original action definition
     * @return  {} - wantedActionDefinition or empty Object
     */
	Component.prototype.exportAction = function(actionKey, actionExtension){
		if(this.actions[actionKey]) return utils.merge(this.actions[actionKey], actionExtension || {});
		return actionExtension || {};
	};

    /**
     * this function is used to roll back an action after error handling.
     *
     * @param   context         object - rollback context. see Component.prototype._handleError() for further documentation.
     * @returns promise
     */
    Component.prototype.rollbackAction = function(context){
    	// skip rollback if this error can be handled in a forward way (e.g., show login form if session timeout happened)
    	if(context.action.skipRollback || context.forceActionSuccess) return utils.promise.resolve(context);

	    // be sure that the right context will be given to the rollback function
	    if(context && context.action && context.action.rollbackContext) return this.rollbackAction(context.action.rollbackContext);

	    if(context.action){
	        // destroy actual context component if necessary
		    if(context.action.ready && context.action.buildComponent){
			    utils.forEach(context.action.source || [], function(source){
			       if(source.component) source.component.destroy();
			       else if(source.componentTree && source.componentTree.children[source.componentTree.childLayoutIndex]) source.componentTree.children[source.componentTree.childLayoutIndex].destroy();
			    });
		    }

		    // delete action only if necessary
		    if(context.action.key && context.component.actions[context.action.key]) {
			    context.component.resetAction(context.action.key);
		    }
	    }

	    // in the special case of a rollback the other actions has to be prevented. so this function will allways reject and can never ever resolve the corresponding promise chain.
	    return utils.promise.reject(context);
    };

    /**
     * this function is used to reset an action to its state which was in charge before the action has been performed.
     *
     * @param   actionKey       string - actionKey - which action should be reset
     */
    Component.prototype.resetAction = function(actionKey){
	    if(actionKey && (this.resetActions[actionKey] || {}).static) this.actions[actionKey] = utils.simpleCopy(this.resetActions[actionKey]);
    };

    /**
     * this function is used to return the componentInstanceID of the closest parent which has one or false otherwise.
     *
     * @returns int - componentInstanceID or false in an error case
     */
	Component.prototype.getNextAvailableParentComponentInstanceID = function(){
		var parentComponentInstanceID = false;
		this.parentComponents(undefined, function(parentComponent){
			if(parentComponent.componentInstanceID){
				parentComponentInstanceID = parentComponent.componentInstanceID;
				return false;
			}
		});
		return parentComponentInstanceID;
	};

    /**
     * this function returns the closest resource register content identified by the given resourceRegisterKey within this components' parents.
     *
     * @param   resourceRegisterKey     string - resourceRegisterKey
     * @param   checkAllParents     	boolean - checkAllParentAction's resourceRegisters
     * @returns mixed resourceRegisterContent (if not found undefined is returned)
     */
	Component.prototype.getResourceRegisterContent = function(resourceRegisterKey, checkAllParents = true){
		if(resourceRegisterKey !== undefined){
			let parentActionKey = this.parentActionKey
			let originalParentActionKey = this.originalParentActionKey
			let resourceRegisterContent;

			this.parentComponents(undefined, parentComponent => {
				if(parentActionKey && ((parentComponent.actions[parentActionKey] || {}).resourceRegister || {})[resourceRegisterKey] !== undefined){
					resourceRegisterContent = parentComponent.actions[parentActionKey].resourceRegister[resourceRegisterKey];
					return false;
				}
				if(originalParentActionKey && ((parentComponent.actions[originalParentActionKey] || {}).resourceRegister || {})[resourceRegisterKey] !== undefined){
					resourceRegisterContent = parentComponent.actions[originalParentActionKey].resourceRegister[resourceRegisterKey];
					return false;
				}

				if(!checkAllParents){
					return false
				}

				parentActionKey = parentComponent.parentActionKey
				originalParentActionKey = parentComponent.originalParentActionKey;
			}, true);

			return resourceRegisterContent;
		}

		return undefined;
	};

	/**
	 * this function is used to initialize this component's ruleSet for later use if necessary.
	 */
	Component.prototype.initValidatorRuleSet = function(){
		if(this.validatorRuleSet && !utils.isEmpty(this.validatorRuleSet)){
			this.validatorRuleSetID = validator.initRules(this.validatorRuleSetID || this.componentID, this.validatorRuleSet);
		}
	};

	/**
	 * this function is used to validate the actual components resources
	 *
	 * @params 	resourceAttributes				{} | [] - resources which should be validated or a list of priority ordered resources
	 * 											NOTE: this flag should be of the format like the data.attributes flag of resourceData.
	 * @params 	fieldCodes						object - optional - list of fieldCodes which should be validated
	 * 											NOTE: if this list is empty all fieldCodes will be validated
	 * @params 	additionalFieldData				object - list of all fieldCodes associated with its additional data
	 * @params 	preventValidationFieldCodes		object - list of all fieldCodes (<fieldCode> => true) which should not be validated.
	 */
	Component.prototype.validate = function(resourceAttributes, fieldCodes, additionalFieldData, preventValidationFieldCodes){
		if(this.validatorRuleSet){
			// get right resources according to the priority resource list if necessary
			var resources;
			if(Array.isArray(resourceAttributes)){
				resources = {};
				var affectedFieldCodes = validator.getAffectedFieldCodes(this.validatorRuleSetID);
				var r, fieldCode;
				var resourceKeys = {};
				for(r in resourceAttributes) {
					resourceKeys[r] = Object.keys(resourceAttributes[r]);
				}
				for(fieldCode in affectedFieldCodes){
					for(r in resourceKeys) {
						if(utils.indexOf(resourceKeys[r], fieldCode) >= 0){
							resources[fieldCode] = resourceAttributes[r][fieldCode];
							break;
						}
					}
				}
			}

			return validator.validate(
				this.validatorRuleSetID,
				fieldCodes,
				resources || resourceAttributes,
				storage.langCode || ((appConfig || {}).language || {}).default || 'de-at',
				additionalFieldData || {},
				preventValidationFieldCodes
			);
		}

		return {
			invalid: 	false,
			fields: 	{}
		};
	};



	///////////////////////////////
	///// COMMON HELPER // TODO: are these functions at the right location
	///////////////////////////////

	/**
	 * this function is used to wrap the users' method (hasAccessTo).
	 * this is helpful if the scope should be taken from the actual component to check the actual privilegeCode
	 *
	 * @param	privilegeCode		string - privilege code
	 * @param 	scope				string - optional - scope within the privilege should be available
	 * @return 	boolean - does the actual user has the privilege or not?
	 */
	Component.prototype.hasAccessTo = function(privilegeCode, scope){
		if(!scope) scope = this.scope;
		const storage = this.getStorage()

		return storage.user ? storage.user.hasAccessTo(privilegeCode, scope) : false;
	};

	/**
	 * this function is used to wrap the users' method (hasAttributeAccessTo).
	 * this is helpful if the scope should be taken from the actual component to check the actual privilege of the given attributeName
	 *
	 * @param	attributeName		string - name of the attribute
	 * @param   crudType			string - create | read | update | delete (default: read)
	 * @param 	scope				string - optional - scope within the privilege should be available
	 * @return 	boolean - does the actual user has the privilege of the given attributeName or not?
	 */
	Component.prototype.hasAttributeAccessTo = function(attributeName, crudType, scope){
		if(!scope) scope = this.scope;
		const storage = this.getStorage()

		return storage.user ? storage.user.hasAttributeAccessTo(scope, this.config.privilegeBase || undefined, crudType, attributeName) : false;
	};

	/**
	 * this function works similar to the hasAccessTo method but proofs
	 * if the actual user has a specific role option (identified by roleOptionCode) according to the given scope.
	 * NOTE: this may be used for miscellaneous options like show the id of an element within a tree.
	 *
	 * @param	roleOptionCode		string - roleOptionCode
	 * @param 	scope				string - optional - scope within the roleOptionCode should be available
	 * @return 	boolean - does the actual user has set the roleOption or not?
	 */
	Component.prototype.hasRoleOption = function(roleOptionCode, scope){
		if(!scope) scope = this.scope;
		const storage = this.getStorage()

		return storage.user ? storage.user.hasRoleOption(roleOptionCode, scope) : false
	};

	/**
	 * this function works just like the user.hasRoleInScope method
	 *
	 * @param 	scope				string - optional - scope within the actual user should have a scopeRole
	 * @return 	boolean - does the actual user have a role within this scope or not?
	 */
	Component.prototype.hasRoleInScope = function(scope){
		if(!scope) scope = this.scope;
		const storage = this.getStorage()

		return storage.user ? storage.user.hasRoleInScope(scope) : false
	};

	/**
	 * this function works like setTimeout only within a loop.
	 * one essential difference to setTimeout is that you don't lose the scope of the Component Object.
	 * this means that <this> will target the component object even within the callback function.
	 *
	 * @param callback      function - callback
	 * @param delay         int - delay measured in milliseconds between loops
	 */
	Component.prototype.timeoutLoop = function(callback, delay){
		setTimeout(function(self){
			callback.call(self);
			self.timeoutLoop(callback, delay);
		}, delay, this);
	};

	/**
	 * this function works like timeoutLoop only without the loop.
	 *
	 * @param callback      function - callback
	 * @param delay         int - delay measured in milliseconds between loops
	 */
	Component.prototype.timeout = function(callback, delay){
		setTimeout(function(self){
			callback.call(self);
		}, delay, this);
	};

	/**
	 * if one calls this function within the <delay> number of milliseconds twice,
	 * only the second one will actually be invoked and the timer starts again.
	 *
	 * this function works similar to frontendController.delayedLastOf(), but with callbacks.
	 * this might come in handy if a short burst of things should be prevented from cascading further.
	 *
	 *
	 * @param key      		string - which identifier should be used for this callback.
	 * @param callback      function - callback
	 * @param [delay=50]    int - number of milliseconds to delay the callback.
	 */
	Component.prototype.delayedLastOf = function(key, callback, delay = 50){
		if(!key || !callback || !utils.isFunction(callback)){
			console.error('delayedLastOf() cannot work without a key or callback')
			return
		}

		if(!delay){
			callback.call(this)
			return
		}

		this._delayedLastOf = this._delayedLastOf || {}
		if(this._delayedLastOf[key]){
			clearTimeout(this._delayedLastOf[key])
			delete this._delayedLastOf[key]
		}
		this._delayedLastOf[key] = setTimeout(function() {
			callback.call(self)
		}, delay, this)
	};

    /**
    * get anchor identifier for html attribute "id".
    *
    * @return string | boolean anchor id or false in an error case
    */
    Component.prototype.getAnchorID = function(){
        return utils.dom.getAnchorID(this.routeComponentID, this.componentName);
    };

	/**
	 * this function is used to perform actions via callback function on all components within the given collection
	 *
	 * @param   collection              		{} | [] - a part of componentTree
	 * @param   lateDescendingCallback  		function - this function will be called before the recursion descent
	 *                                  		NOTE: if this function returns 'break' the traversing will be aborted immediately (tree root first)
	 *                                  		NOTE: if this function returns 'breakRecursion' the recursion descent will be aborted but the rest of the tree will be reached afterwards.
	 * @param   earlyDescendingCallback 		function - this function will be called after the recursion descent (tree leaf first)
	 *                                  		NOTE: if this function returns 'break' the traversing will be aborted immediately
	 * @param   calledComponentList     		array - this list will be used to prevent multiple calls of callback on the same components
	 *                                  		NOTE: this is possible e.g., when a component is within the children list and within the parents registry
	 *                                  		NOTE: this list parameter is used for internal process handling only and must not be set from outside!!!
	 * @param 	intermediaryChildrenGranted     boolean - default: true - is traversing intermediary children granted or not?
	 * @returns                         		returns false if the callback returns false
	 */
	var forAllChildComponents = function(collection, lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted = true){
		// init
		var result;
		var internalCalledComponentList = {
			early: {},
			late: {}
		};
		if(!calledComponentList) calledComponentList = internalCalledComponentList;

		if(collection instanceof Component){
			// check actual component itself
			if(appConfig.isClient && !collection.$) collection.refresh$();
			if(typeof(lateDescendingCallback) === 'function'){
				if(!calledComponentList.late[collection.componentIndex]) {
					calledComponentList.late[collection.componentIndex] = true;
					result = lateDescendingCallback(collection);
				}
				if(result === 'breakRecursion') return;
				else if(result === 'break')     return 'break';
			}

			// check actual components' children
			utils.forEach(collection.children, function(element){
				if((result = forAllChildComponents(element, lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted)) === 'break'){
					return false;
				}
			});
			if(result === 'break') return 'break';

			// check actual components' intermediary children if necessary
			if(intermediaryChildrenGranted){
				utils.forEach(collection.intermediaryChildren || {}, function(element){
					if((result = forAllChildComponents(element, lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted)) === 'break'){
						return false;
					}
				});
				if(result === 'break') return 'break';
			}

			// check actual components' actions
			utils.forEach(collection.actions, function(element){
				if((element || {}).ready){
					utils.forEach(element.source || {}, function(actionSource){
						if(!utils.isEmpty(actionSource.component)){
							if((result = forAllChildComponents(actionSource.component, lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted)) === 'break'){
								return false;
							}
						}
						else if(!utils.isEmpty(actionSource.componentTree)){
							if((result = forAllChildComponents(actionSource.componentTree.children[actionSource.componentTree.childLayoutIndex], lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted)) === 'break'){
								return false;
							}
						}
					})
				}
			})
			if(result === 'break') return 'break';

			// check actual components' registry
			utils.forEach(collection.registry || [], function(registryGroup){
				utils.forEach(registryGroup || [], function(element){
					if(element instanceof Component){
						if((result = forAllChildComponents(element, lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted)) === 'break'){
							return false;
						}
					}
				});
				if(result === 'break') return false;
			});
			if(result === 'break') return 'break';

			if(typeof(earlyDescendingCallback) === 'function'){
				if(!calledComponentList.early[collection.componentIndex]){
					calledComponentList.early[collection.componentIndex] = true;
					result = earlyDescendingCallback(collection);
				}
				if(result === 'break')     return 'break';
			}
		}
		else if(collection.type === 'section' || collection.type === 'route'){
			// check actual sections' children
			utils.forEach(collection.children, function(element){
				if((result = forAllChildComponents(element, lateDescendingCallback, earlyDescendingCallback, calledComponentList, intermediaryChildrenGranted)) === 'break'){
					return false;
				}
			});
		}
		else {
			// TODO: THROW ERROR
		}

		return result;
	};



	//////////////////////////////////////////////////////////////////////
	///// HELPERS WHICH CAN NOT LIVE WITHIN COMPONENT CLASS
	//////////////////////////////////////////////////////////////////////

	/**
	 * this helper functions will be made available for all templates.
	 *
	 * @param   storage     object - actual storage
	 * @returns {} - an object containing some helper functions which should be available within the ejs-templates.
	 */
	Component.prototype.helpers = function(storage){
		var self = this;
		const helpers = {

            /**
            * returns an object containing all languageConnections of the actual requested route.
            * the langCode is used as key and the nearly full routeProperties object as value.
            * since there will be some cases where one wants to fall back to the corresponding home page
            * if the connected route is not available / visible at the moment a parameter (connectedRoutesOnly) has been introduced to prevent this behaviour if necessary.
            *
            * this is the order in which the routes are selected:
            *   - visible connected route
            *   - visible parent of connected route if type != language
            *   - home page identified by language of the connected route (if granted by connectedRoutesOnly=false)
            *   - home page of tree part without language node (if granted by connectedRoutesOnly=false)
            *
            * furthermore, the routeProperties are extended by an artificial attribute "connectionType" which may be one of the following:
            *   - "connected" in case the connected route has been selected
            *   - "connectedParent" in case one of the connected routes parents has been selected
            *   - "home" in case a home node has been selected
            *   - "" in an error case
            *
            * it is worth to mention that the main part of the described logic is implemented within the /api and the /fec/lib/componentTree.js.prepareRouteLanguageConnections()
            *
            * @param [connectedParentNodesGranted=false]   	boolean - if this parameter is set to true parents of connected routes may be used instead of connected routes if they would not be visible otherwise.
            * @param [homeNodesGranted=false]          		boolean - if this parameter is set to true home routes in the corresponding language may be used instead of connected routes if they would not be visible otherwise.
            * @return {{<langCode>: <routeProperties>}}
            */
            getRouteLanguageConnections: function(connectedParentNodesGranted = false, homeNodesGranted = false){
                var routeLanguageConnections = ((storage.request || {}).route || {}).routeLanguageConnections || {}
                var result = {};
                var langCode, lang;
                for(langCode in routeLanguageConnections){
                    lang = routeLanguageConnections[langCode] || {}
					result[langCode] = lang.connected || null
					if(connectedParentNodesGranted) {
						result[langCode] = result[langCode] || lang.connectedParent || null
					}
					if(homeNodesGranted){
						result[langCode] = result[langCode] || lang.home || null
					}
                }

                return utils.simpleCopy(result);
            },

			/**
			 * renders default variant of <link/> meta tags for all routes connected via their inherited language.
			 *
			 * @param [connectedParentNodesGranted=false]   	boolean - if this parameter is set to true parents of connected routes may be used instead of connected routes if they would not be visible otherwise.
			 * @return {string}
			 */
			renderAlternateLinkMetaTags: function(connectedParentNodesGranted = false){
				var serviceUrl 	= ((storage.app || {}).webService || {}).url || '';
				var routes 		= this.getRouteLanguageConnections(connectedParentNodesGranted)
				var tags 		= [];

				if(!serviceUrl){
					console.error('/fec/lib/component.helpers.renderAlternateLinkMetaTags() - missing service url!')
					return ''
				}
				serviceUrl = String(serviceUrl).replace(/\/+$/, '')

				var langCode, route, url, renderDefaultAlternate = false;
				for(langCode in routes){
					route = routes[langCode];
					if(route){
						if(route.optExternalURL){
							url = route.optExternalURL
						} else {
							url = serviceUrl + route.path
						}

						tags.push(`<link rel="alternate" hreflang="${langCode}" href="${url}" />`)
					} else {
						renderDefaultAlternate = true
					}
				}

				if(renderDefaultAlternate){
					tags.push(`<link rel="alternate" hreflang="x-default" href="${serviceUrl}/" />`)
				}
				return tags.join("\n");
			},

			/**
			 * renders default variant of routeLanguageConnectionFlags for all routes connected via their inherited language.
			 *
			 * @param [connectedParentNodesGranted=false]    	boolean - if this parameter is set to true parents of connected routes may be used instead of connected routes if they would not be visible otherwise.
			 * @param [homeNodesGranted=false]                	boolean - if this parameter is set to true home routes in the corresponding language may be used instead of connected routes if they would not be visible otherwise.
             * @param [renderActualLanguage=false]         		boolean - if this parameter is set to true the actual route will be implied in the returned list.
             * @param [renderEmptyConnectionFallback=true]      boolean - if this parameter is set to true every language get it's flag but will point at the root-node if there is no route available.
             * @param [availableLangCodes=false]      			object || false - if set this may be an object containing custom css-classes for the icons which should be for the flags. e.g.: { 'de-at': { icon: 'test-at' }, ...}
             * 	                        						note that this list has to be complete and will not be merged with the serviceConfig.availableLangCodes.
             * @param [fallbackIcon='']      					string - icon to use if language can't be matched with an icon based on availableLangCodes.
			 * @return {string} html
			 */
			renderLanguageConnections: function(connectedParentNodesGranted = false, homeNodesGranted = false, renderActualLanguage = false, renderEmptyConnectionFallback = true, availableLangCodes = false, fallbackIcon = ''){
				availableLangCodes 		= availableLangCodes || utils.language.getConfig(storage).available;
				var serviceUrl 			= ((storage.app || {}).webService || {}).url || '';
				var actualRoute 		= ((storage || {}).request || {}).route || {}
				var routes 				= this.getRouteLanguageConnections(connectedParentNodesGranted, homeNodesGranted)
				var tags 				= [];

				if(!serviceUrl){
					console.error('/fec/lib/component.helpers.renderLanguageConnections() - missing service url!')
					return ''
				}
				serviceUrl = String(serviceUrl).replace(/\/+$/, '')
				if(utils.isEmpty(availableLangCodes)){
					console.error('/fec/lib/component.helpers.renderLanguageConnections() - appConfig.language.available missing!')
					return ''
				}

				var langCode, route, url, iconClass, target;
				for(langCode in routes){
					route = routes[langCode];
					iconClass = (availableLangCodes[langCode] || {}).icon || fallbackIcon || ''
					target = ''

					if(route){
						if(renderActualLanguage || route.routeID !== actualRoute.routeID){
							if(route.optExternalURL){
								url = route.optExternalURL
								target = 'target="_blank" rel="noopener"';
							} else {
								url = serviceUrl + route.path
							}

							tags.push(`<a hreflang="${langCode || ''}" href="${url}" title="${route.name || ''}" ${target}><i class="${iconClass}"></i></a>`)
						}
					} else if(renderEmptyConnectionFallback) {
						tags.push(`<a hreflang="${langCode || ''}" href="${serviceUrl}/"><i class="${iconClass}"></i></a>`)
					}
				}

				return tags.join("\n");
			},

			/**
			 * this function returns routes for navs matching the correct category-tag, status and time-period
			 *
			 * @param   resourceData         {} 		resourceData from template
			 * @param   code		         string 	return nav-routes tagged with this category
			 * @param   status		         [<visibleStatus>, ...] 	force return of routes matching the given list of status
			 * @return  [] list of matching nav entries
			 */
			getNavRoutesByCodeV1: function(resourceData, code, status){

				var ignoreDate = false;
				var data = [];
				var curTime = new Date().getTime();
				var c, r, isVisible, rtPeriodStart, rtPeriodEnd;

				// given status limits what is returned and visible for the visitor
				if (typeof status === 'undefined' || !status || status.length <= 0){
					var s;
					status = (((storage || {}).user || {}).data || {}).visibleStatus || {
						'active': 			true,
						'preview & active': true
					};
					if(status.preview){
						ignoreDate = true;
					}
				}

				if (resourceData.data) {
                    var routeData, routeAttributes;
					for (c in resourceData.data) {
						if (resourceData.data[c].attributes.value === code) {
							for (r in resourceData.data[c].children.cms_routes.data) {
                                routeData = resourceData.data[c].children.cms_routes.data[r] || {};
                                routeAttributes = routeData.attributes || {};
								// status is correct
								isVisible = status[routeAttributes.status || 'NA'];

								// check period
								if (!ignoreDate) {
									rtPeriodStart = routeAttributes.periodStart;
									if (rtPeriodStart !== null) {
										rtPeriodStart = new Date(rtPeriodStart).getTime();
										if (curTime < rtPeriodStart) isVisible = false;
									}
									rtPeriodEnd = routeAttributes.periodEnd;
									if (rtPeriodEnd !== null) {
										rtPeriodEnd = new Date(rtPeriodEnd).getTime();
										if (curTime > rtPeriodEnd) isVisible = false;
									}
								}
								if (isVisible) data.push(routeData);
							}
						}
					}
				}
				return data;
			},

			/**
			 * this function returns routes for navs matching the correct category-tag, status and time-period
			 *
			 * @param   resourceData         {} 		resourceData from template
			 * @param   code		         string 	return nav-routes tagged with this category
			 * @param   status		         [<visibleStatus>, ...] 	force return of routes matching the given list of status
			 * @return  [] list of matching nav entries
			 */
			getNavRoutesByCode: function(resourceData, code, status){

				// TODO: remove downwards compatibility code (status param inclusive) once every navigation has been migrated to the new format.
				if(resourceData.version !== '2'){
					return this.getNavRoutesByCodeV1(resourceData, code, status)
				}

				var data = [];

				if (resourceData.data) {
					var langCode = (((storage || {}).request || {}).route || {}).langCode || 'de-at';
					var entity;

					for (entity of resourceData.data) {
						if (entity.navs[code || '~NA~'] && entity.attributes.langCode === langCode) {
							data.push(entity);
						}
					}
				}

				return data;
			},

			/**
			 * renders default navigations <li><a></a></li> by the given code
			 *
			 * @param   resourceData         {}        resourceData from template
			 * @param   code                 string    return nav-routes tagged with this category
			 * @return {string}
			 */
			renderNavRoutesByCode: function(resourceData, code){
				var route 		= ((storage || {}).request || {}).route || {}
				var breadCrumbs = ((storage || {}).request || {}).breadCrumbs || []
				var navData 	= this.getNavRoutesByCode(resourceData, code);
				var nav 		= [];
				var activeRoutes = {}, b;

				// activate main menu entry
				if(route.routeID){
					activeRoutes[route.routeID] = true
				}
				// or by parent routes in breadcrumbs
				for (b in breadCrumbs) {
					if(breadCrumbs[b].routeID){
						activeRoutes[breadCrumbs[b].routeID] = true;
					}
				}

				var entity, attributes, url, name, target, active;
				let liClasses = [], liAttributes = []
				let navIcon, icon
				for(entity of navData){
					attributes = entity.attributes || {}
					target = ''
					name = 'NO NAME FOUND'
					active = false
					navIcon = (attributes.config || {}).navIcon || {}
					liAttributes = []
					liClasses = []

					if(entity.type === 'route' || !entity.type){
						name = attributes.name
						active = activeRoutes[attributes.routeID]
						if (attributes.optExternalURL) {
							target = 'target="_blank" rel="noopener"';
							url = attributes.optExternalURL;
						} else {
							url = attributes.path;
						}
					} else if(entity.type === 'routeComponent'){
						name = attributes.componentName
						url = attributes.path
					}

					name = String(name || '').trim()
					if(active){
						liClasses.push('active')
					}

					icon = ''
					if(navIcon.iconClass){
						icon = `<i class="${navIcon.iconClass}"></i>`

						if(navIcon.showIconOnly){
							liClasses.push('iconOnly')
							name = ''
						}
					}

					if(liClasses.length > 0){
						liAttributes.push(`class="${liClasses.join(' ')}"`)
					}

					nav.push(`<li ${liAttributes.join(' ')}><a href="${url}" title="${name}" ${target}>${icon}${name}</a></li>`)
				}

				return nav.join("\n")
			},

			/**
			 * this function is a clone of detectFullRenderedImages which is used to return only one single image instead
			 * of a list of images. especially if you are expecting one single image this can be useful.
			 * NOTE: for parameter descriptions see detectFullRenderedImages function beyond.
			 *
			 * @see     detectFullRenderedImages()
			 * @return  {} - detected image
			 */
			detectRenderedImage: function(images, imageConfig, requestedServiceCode, dimensions, codeNames){
				return self.detectRenderedImage(images, imageConfig, requestedServiceCode, dimensions, codeNames);
			},

			/**
			 * this function is used to get the actual list of images according to the actual environment.
			 *
			 * @param   images              	object - image or list of images			(e.g., model.image)
			 * @param   imageConfig         	object - config of the image templateAtom	(e.g., model._image)
			 * @param   requestedServiceCode    string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
			 * @param   dimensions				{{ width: number, height: number }} - these max dimensions will be used to estimate the best matching images if defined.
			 * 									otherwise its tried to detect the maximum dimensions needed to be filled by the detected images.
			 * @param   codeNames				String or Array of Strings - return only rendered images according to the given codeNames.
			 * @returns [] - list of images (for further details see utils.media.detectFullRendered() documentation)
			 */
			detectRenderedImages: function(images, imageConfig, requestedServiceCode, dimensions, codeNames){
				return self.detectRenderedImages(images, imageConfig, requestedServiceCode, dimensions, codeNames);
			},

			/**
			 * this function is used to render a section, the content of a section only or simply the content of all children.
			 *
			 * @param   sectionName                 string - sectionName
			 * @param   renderSectionTag            boolean - should the section-tag be rendered?
			 * @param   forceRenderSectionTag       boolean - should even an empty named section being rendered?
			 * @return  string - rendered html
			 */
			renderSection: function(sectionName, renderSectionTag, forceRenderSectionTag){
				if(self.renderMemory){
					var content;
					if(sectionName) {
						if((content = (self.renderMemory.renderedSections || {})[sectionName]) !== undefined){
							if(renderSectionTag === false) return content.tagExclusive || '';
							return content.tagInclusive || '';
						}
					} else if(self.renderMemory.renderedChildren) {
						return self.renderMemory.renderedChildren;
					}
				}

				// render empty section tag if necessary
				if(forceRenderSectionTag){
					return componentList.templates.section({ name: sectionName, content: '' });
				}

				return '';
			},

			renderSectionMeta: function(sectionName){
				// TODO: IMPL POIA
				/*
					FORMAT:
					[
						{
							type: 'section' || 'component',
							name: <sectionName>,
							componentClass: <componentClass>,
							extensionComponentClass: <extensionComponentClass>,
							containerComponentClass: <containerComponentClass>,
							isEmpty: <boolean>, // innerHtml is empty
							children: [...]
						},
						...
				 */
			},

			hasAccessTo: function(privilegeCode, scope){
				return self.hasAccessTo(privilegeCode, scope);
			},

			hasAttributeAccessTo: function(attributeName, crudType, scope){
				return self.hasAttributeAccessTo(attributeName, crudType, scope);
			},

			hasRoleOption: function(roleOptionCode, scope){
				return self.hasRoleOption(roleOptionCode, scope);
			},

			hasRoleInScope: function(scope){
				return self.hasRoleInScope(scope);
			},

			renderTreePart: function(tree){
				// NOTE: 	during build-phase collected resourcePreloaders are never performed!
				// 			the build process is merely needed to transform js-objects into Component-objects including their template functions, model-fields by name and so on.
				// 			the resources of these components would have to be loaded and prepared before this step.
				// 			this is a special variant of a rendering process (e.g., ninja components loaded as a resource and rendered afterwards like news teasers at homepage)
				// TODO: this has not been tested with fecClients and / or multi-render call cases yet!
				// TODO: this may be used with tree being a whole route. this case has not been tested yet. at the moment only a sub-componentTree (e.g., like a news teaser and its children) has been considered to be a case for this function-call.
				// TODO: trees rendered via this function will not be reachable via tree traversing functions, because it is handled as a resource and will be built here on its own.
				const builtTree = storage.componentTree.build(undefined, tree, false, false, appConfig.isClient, storage, {}, {}, {}, true, false, true, '', false, 0, 0, false, self.scope)

				if(builtTree){
					return storage.componentTree.render(builtTree, storage);
				}

				return '';
			},



			//////////////////////////////////////////
			/// proxyCaches
			//////////////////////////////////////////

			proxyCaches: {

				/**
				 * returns a frontend usable url and registers all necessary information to prepare the filesystem.
				 *
				 * @param serviceType       string - type of proxyCacheService to use (e.g., zip, youtube, ...)
				 * @param params            object - full content definition of the wanted proxyCache element.
				 *                          case serviceType = zip: @see fec/server/zip.generate() for details.
				 * @returns {string}        url
				 */
				getUrl(serviceType, params){
					if(!storage.isServer) 				return console.error('client side zip file content declaration is prohibited');
					if(!storage.proxyCacheController) 	return console.error('proxyCacheController not found');

					return storage.proxyCacheController.getUrl(serviceType, params)
				},

				youtube: {

					/**
					 * returns the internal proxy cache thumb url according to the given parameters.
					 *
					 * @param id			string - video id
					 * @param thumbQuality	string - video quality (subType of serverAppConfig)
					 * @return {string}		maybe empty string in an error case
					 */
					getThumbUrl: function(id, thumbQuality = ''){
						return Youtube.getThumbUrl(appConfig, storage, id, thumbQuality)
					},

					/**
					 * returns the internal proxy cache details according to the given parameters.
					 *
					 * @param videoUrl		string - youtube videoUrl
					 * @param thumbQuality	string - video quality (subType of serverAppConfig)
					 * @return {object}		detailed parameters of the video e.g., {id,url,thumb,watchUrl,embedUrl}
					 */
					getDetailsByUrl: function(videoUrl, thumbQuality = ''){
						return Youtube.getDetailsByUrl(appConfig, storage, videoUrl, thumbQuality)
					},
				},

				zip: {

					/**
					 * @see /server/proxyCacheController.getUrl()
					 * @param params		object - content definition
					 						e.g., {
												filename: 'collection.zip', // this filename is only used for Content-Disposition header. extension will be set if != zip.
												zipOptions: { // used within new Archiver('zip', zipOptions). @see https://www.archiverjs.com/docs/archiver/#archiver-class for details.
													zlib: {
														level: 0, // sets the compression level. 0-9
													},
												},
												options: {
													errors: {
														fileNotFound: { // how to behave on file not found errors
															log: true, // tell logHandler about it
															throw: false, // throwing an error would abort the zip-file-generation
														},
													},
												},
												content: [
													{
														type: 'directory',
														name: 'test',
														content: [
															{
																type: 'file',
																path: './private/usedForGit.txt',
																[name: 'test'] // one may use another name within the zip-file than within the filesystem. if the wrong or no extension is used the paths extension will be appended.
															},
															{
																type: 'url', // local project data should not be added via own url since the overhead is much higher than just have a look into the filesystem.
																url: 'https://www.codeup.at/agb.pdf',
																[name: 'test.pdf'] // one may use another name within the zip-file than within the filesystem. if the wrong or no extension is used the paths extension will be appended.
															},
															{
																type: 'media',
																mediaID: 15473,
																[mediaRenderedID: 35861],
																[name: 'test.png'], // one may use another name within the zip-file than within the cms_media entry. if the wrong or no extension is used the cms_media extension will be appended.
															},
															{
																type: 'media',
																mediaID: 15470,
																[name: 'test.docx'], // one may use another name within the zip-file than within the cms_media entry. if the wrong or no extension is used the paths extension will be appended.
															},
															...
														],
													},
													...
												]
											}
					 * @returns {void|*}
					 */
					getUrl(params){
						return helpers.proxyCaches.getUrl('zip', params)
					},
				},

				url: {

					/**
					 * @see /server/proxyCacheController.getUrl() for details
					 * @param params		object - content definition
					 						e.g., {
												url: 'https://codeup.at/agb.pdf', // url to get resource from. NOTE: without extension this is not granted. there are no fallbacks to html or so at the moment.
												[name]: 'CopdeupAGBs.pdf', // optional name. extension will be overwritten if it does not match the url ones.
											}
					 * @returns {void|*}
					 */
					getUrl(params){
						return helpers.proxyCaches.getUrl('url', params)
					},
				},
			},

		};
		return helpers
	};

	/**
	 * this function is a clone of detectFullRenderedImages which is used to return only one single image instead
	 * of a list of images. especially if you are expecting one single image this can be useful.
	 * NOTE: for parameter descriptions see detectFullRenderedImages function beyond.
	 *
	 * @see     detectFullRenderedImages()
	 * @return  object - detected image
	 */
	Component.prototype.detectRenderedImage = function(images, imageConfig, requestedServiceCode, dimensions, codeNames){
		const imageList = this.detectRenderedImages(images, imageConfig, requestedServiceCode, dimensions, codeNames)
		if(Array.isArray(imageList) && imageList.length > 0){
			return imageList[0]
		}
		return {}
	};

	/**
	 * this function is used to get the actual list of images according to the actual environment.
	 *
	 * @param   images              	object - image or list of images			(e.g., model.image)
	 * @param   imageConfig         	object - config of the image templateAtom	(e.g., model._image)
	 * @param   requestedServiceCode    string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
	 * @param   dimensions				{{ width: number, height: number }} - these max dimensions will be used to estimate the best matching images if defined.
	 * 									otherwise its tried to detect the maximum dimensions needed to be filled by the detected images.
	 * @param   codeNames				String or Array of Strings - return only rendered images according to the given codeNames.
	 * @returns [] - list of images (for further details see utils.media.detectFullRendered() documentation)
	 */
	Component.prototype.detectRenderedImages = function(images, imageConfig, requestedServiceCode, dimensions, codeNames){
		dimensions = dimensions || {}
		const storage = this.getStorage()

		// estimate max image dimensions as fallback.
		// NOTE:    if there are more imageCandidates than one, according to the given environment and imageConfig,
		//          this fallback can be used to estimate the best fitting imageCandidate.
		if(storage.isClient){
			// are we able to use the components container dimensions?
			if(this.$ && this.$.length > 0){
				dimensions.width = dimensions.width || this.$.outerWidth()
				dimensions.height = dimensions.height || this.$.outerHeight()
			}
			// are we able to use the actual window dimensions?
			else if(((this.activeEnvironment || {}).dimensions || {}).window){
				dimensions.width = dimensions.width || this.activeEnvironment.dimensions.window.width
				dimensions.height = dimensions.height || this.activeEnvironment.dimensions.window.height
			}
		}

		const result = utils.media.image.detectRendered(images, storage, imageConfig, requestedServiceCode, !!this._tryToPreloadImages, () => {
			this.onFileLoadDone()
		}, dimensions, codeNames)
		this._nrOfPreloadingFiles += result.nrOfPreloadingImages
		return result.imageList
	};

	/**
	 * this function is used to wrap the missing includeCallback of ejs2
	 *
	 * @param   file                    string - filename relative to caller without extension
	 * @param   refData	                object - data object which should be used for the included template
	 * @param   parentComponentGroup    array - this is the componentGroup of the parentComponent which should be able to include the actual needed template.
	 *                                  NOTE: this is used by internal inheritance logic only and must not be defined within an ejs-template or an js-include!
	 * @param   aliasComponentKey       string - this is the componentKey of the originally wanted component template. in case of inheritance this flag will be used to shorten further template searches.
	 *                                  NOTE: this is used by internal inheritance logic only and must not be defined within an ejs-template or an js-include!
	 * @param   templateComponentKey    string - componentKey for template to include (can differ from component according to active inheritance logic)
	 *                                  NOTE: this is used by internal inheritance logic only and must not be defined within an ejs-template or an js-include!
	 * @param   storage                 object - actual storage
	 * @param   routeParams				object - parameters defined by the actual route-call
	 * @param 	ejsInclude				boolean - in case of ejs-includes this param will be set to true.
	 * @param 	forceImmediateRender	boolean - should this inclusion (and all child inclusions) be rendered immediately?
	 * @returns string - rendered template
	 */
	Component.prototype.include = function(file, refData, parentComponentGroup, aliasComponentKey, templateComponentKey, storage, routeParams, ejsInclude, forceImmediateRender){
		// init
		const self	= this
		storage 				= storage || this.getStorage()
		routeParams 			= routeParams || (appConfig.isClient && globalThis.routeParams ? globalThis.routeParams : {})
		const isShadowInclude = file && utils.isCollection(file)
		const data = {
			...(refData || {})
		}

		// prevent storage componentTree instance from being transported through data attribute
		if(data && data.storage && data.storage.componentTree) delete data.storage.componentTree;

		if(!isShadowInclude) {
			// estimate component group
			parentComponentGroup    = utils.simpleCopy(parentComponentGroup || this.component);
			var componentGroup      = componentList.normalizeComponentGroup(utils.concat(parentComponentGroup.slice(0, parentComponentGroup.length - 1), file.split('/')));
			var componentKey        = componentList.buildKey(componentGroup);
			templateComponentKey    = templateComponentKey || componentKey;

			// load component, template and style if necessary
			// NOTE:    in case of includes processed by shadow components (which will never ever be rendered on the server)
			//          it is possible that the server does not know anything about a component which will be possibly needed here.
			componentList.load(componentGroup);
		}

		// render local template if possible (load template if necessary)
		if(isShadowInclude || utils.isFunction(componentList.templates[templateComponentKey])){
			// remember template- and component- aliases to improve performance
			// TODO: GET THIS WORKING
			// if(!utils.isEmpty(aliasComponentKey)){
			// 	if(!utils.isFunction(componentList.templates[aliasComponentKey])){
			// 		componentList.templates[aliasComponentKey] = componentList.templates[templateComponentKey];
			// 		console.log('TEMPLATE SHORTCUT', aliasComponentKey, ' <= ', templateComponentKey);
			// 	}
			// 	if(utils.isEmpty(componentList.components[aliasComponentKey]) && !utils.isEmpty(componentList.components[componentKey])){
			// 		console.log('COMPONENT SHORTCUT', aliasComponentKey, ' <= ', componentKey, componentList.components[componentKey]._componentClass);
			// 		componentList.components[aliasComponentKey] = utils.merge(utils.copy(componentList.components[componentKey]), { _componentClass: componentKey });
			// 		// componentList.components[aliasComponentKey] = utils.copy(componentList.components[componentKey]);
			// 		// if(utils.isEmpty(componentList.components[aliasComponentKey]._componentClass)) componentList.components[aliasComponentKey]._componentClass = componentKey;
			// 	}
			// }


			var usedComponentKey, usedComponentGroup;
			if(isShadowInclude) {
				usedComponentKey = file.componentClass;
				usedComponentGroup = file.component;
			}
			else {
				if(!utils.isEmpty(componentList.components[aliasComponentKey])) usedComponentKey = aliasComponentKey;
				else if(!utils.isEmpty(componentList.components[componentKey])) usedComponentKey = componentKey;
				else                                                            usedComponentKey = aliasComponentKey || componentKey;
				usedComponentGroup = usedComponentKey.split('_');
			}

			// render this element and include the corresponding component if possible
			if(isShadowInclude || componentList.components[usedComponentKey]){
				// TODO: CLEANUP
				if(!componentTree) componentTree = storage.componentTree;

				if(data){
					// prevent storage componentTree instance from being transported through data attribute
					// TODO: if data contains a storage shouldn't be this an error case since the storage is available via helpers anyway?
					if(data.storage && data.storage.componentTree) delete data.storage.componentTree;

					// sanitize include if necessary
					if(!isShadowInclude && componentList.components[usedComponentKey].config.hasIncludeSanitizer){
						componentList.components[usedComponentKey].methods.sanitizeInclude(data, storage);
					}
				}

				var inclusionKey;
				var renderPlaceholder = false;

				if(isShadowInclude || !componentList.components[usedComponentKey].includeOnlyComponent) {
					this.inclusionPerformed = true;
					renderPlaceholder = (
						((ejsInclude || isShadowInclude) && !forceImmediateRender && appConfig.isClient)
						||
						// included components which are prepared at the client have to be rendered at the client too.
						// TODO: maybe the prepare-method existence is not the only special case.
						appConfig.isServer && (componentList.components[usedComponentKey].methods || {}).prepare !== undefined
					);

					// set include callback for cascading templates
					// NOTE: since inclusions (as well as LOAD-actions) wait for one another before the attach-phase starts
					// it is possible that recurring inclusions of children render placeholder containing the very same inclusion keys
					// if this inclusionKey would equal to a runtime-index only.
					// therefor, the componentIndex of the including parentComponent has to prefix the actualInclusionKey
					// in order to be unique over all inclusions (even the child-inclusions and their ones and so on.)
					inclusionKey = `${this.componentIndex}_${this.actualInclusionKey++}`;
					var componentData = {}, component;

					if(appConfig.useFecClient){
						if (isShadowInclude && appConfig.isClient) {
							// NOTE: ensure that the references won't be killed
							component = file;
							component.inclusionActionSourceComponentIndex = self.componentIndex;
							component.inclusionKey = inclusionKey;
							component.scope = component.scope || self.scope;
							component.config = component.config || {};
							component.config.preventIDSelector = component.config.preventIDSelector || this.config.preventIDSelector;
						}
						else {
							componentData 				= utils.simpleCopy(data)
							componentData.component 	= usedComponentGroup
							componentData.inclusionKey 	= inclusionKey
							componentData.inclusionActionSourceComponentIndex = self.componentIndex

							if(!data.scope) 							componentData.scope = self.scope;
							if(!componentData.config) 					componentData.config = {};
							if(!componentData.config.preventIDSelector) componentData.config.preventIDSelector = this.config.preventIDSelector;
						}

						// store action for clients to create component
						this.actions['include-' + inclusionKey] = {
							placeholderRendered: renderPlaceholder,
							parentInclusionKey: (this.inclusionChain.length > 0 ? this.inclusionChain.slice(-1)[0] : undefined),
							type: CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE,
							source: {
								load: {
									component: component,
									componentData: componentData
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.ATTACH,
								selector: '[data-inclusion-key="' + inclusionKey + '"]'
							}
						};

						// append actual inclusion key to inclusionChain to be able to know the inclusion parent within the inclusion cascade
						this.inclusionChain.push(inclusionKey);
					}
				}

				if(renderPlaceholder){
					// inclusion shadows will be rendered instead of attached
					if(appConfig.inject.loadingClass){
						rendered = '<div class="loading" data-inclusion-key="' + inclusionKey + '"></div>';
					} else {
						rendered = '<div data-inclusion-key="' + inclusionKey + '"></div>';
					}
				} else {
					rendered = this.render(
						storage,
						routeParams,
						componentList.templates[templateComponentKey],
						utils.merge(
							{
								model:          componentList.components[usedComponentKey].model || {},
								config:         componentList.components[usedComponentKey].config || {},
								formMapping:    componentList.components[usedComponentKey].formMapping || {},
								resourceData:   componentList.components[usedComponentKey].resourceData || {}
							},
							data,
							{
								model: {
									inclusionKey: inclusionKey
								},
								config: {
									preventIDSelector: (componentList.components[usedComponentKey].config || {}).preventIDSelector || this.config.preventIDSelector
								}
							}
						),
						usedComponentGroup,
						false,
						(
							(componentList.components[usedComponentKey].extensionComponentClass ? componentList.components[usedComponentKey].extensionComponentClass + ' ' : '')
							+
							(componentList.components[usedComponentKey]._componentClass ? componentList.components[usedComponentKey]._componentClass : usedComponentKey)
						),
						inclusionKey,
						// TODO: REMOVE last parm?
						file
					);
				}

				// var rendered = '';
				// if(isShadowInclude) {
				// 	// inclusion shadows will be rendered instead of attached
				// 	rendered = '<div class="loading" data-inclusion-key="' + inclusionKey + '"></div>';
				// }
				// else {
				// 	rendered = this.render(
				// 		storage,
				// 		routeParams,
				// 		componentList.templates[templateComponentKey],
				// 		utils.merge(
				// 			{
				// 				model:          componentList.components[usedComponentKey].model || {},
				// 				config:         componentList.components[usedComponentKey].config || {},
				// 				formMapping:    componentList.components[usedComponentKey].formMapping || {},
				// 				resourceData:   componentList.components[usedComponentKey].resourceData || {}
				// 			},
				// 			data,
				// 			{
				// 				model: {
				// 					inclusionKey: inclusionKey
				// 				}
				// 			}
				// 		),
				// 		usedComponentGroup,
				// 		false,
				// 		(
				// 			(componentList.components[usedComponentKey].extensionComponentClass ? componentList.components[usedComponentKey].extensionComponentClass + ' ' : '')
				// 			+
				// 			(componentList.components[usedComponentKey]._componentClass ? componentList.components[usedComponentKey]._componentClass : usedComponentKey)
				// 		),
				// 		inclusionKey,
				// 		// TODO: REMOVE last parm?
				// 		file
				// 	);
				// }

				// if(componentList.components[usedComponentKey].includeOnlyComponent) {
				// 	rendered = this.render(
				// 		storage,
				// 		routeParams,
				// 		componentList.templates[templateComponentKey],
				// 		utils.merge(
				// 			{
				// 				model:          componentList.components[usedComponentKey].model || {},
				// 				config:         componentList.components[usedComponentKey].config || {},
				// 				formMapping:    componentList.components[usedComponentKey].formMapping || {},
				// 				resourceData:   componentList.components[usedComponentKey].resourceData || {}
				// 			},
				// 			data,
				// 			{
				// 				model: {
				// 					inclusionKey: inclusionKey
				// 				}
				// 			}
				// 		),
				// 		usedComponentGroup,
				// 		false,
				// 		(
				// 			(componentList.components[usedComponentKey].extensionComponentClass ? componentList.components[usedComponentKey].extensionComponentClass + ' ' : '')
				// 			+
				// 			(componentList.components[usedComponentKey]._componentClass ? componentList.components[usedComponentKey]._componentClass : usedComponentKey)
				// 		),
				// 		inclusionKey,
				// 		// TODO: REMOVE last parm?
				// 		file
				// 	);
				// } else {
				// 	// 	inclusion shadows will be rendered instead of attached
				// 	rendered = '<div class="loading" data-inclusion-key="' + inclusionKey + '"></div>';
				// }

				if(isShadowInclude || !componentList.components[usedComponentKey].includeOnlyComponent) {
					// pop off actual inclusion key from inclusionChain to be able to know the inclusion parent within the inclusion cascade
					this.inclusionChain.pop();
				}

				// if(componentList.components[usedComponentKey].includeOnlyComponent) {
				// 	return rendered;
				// }
				//
				// return {
				// 	rendered: rendered,
				// 	actionKey: 'include-' + inclusionKey
				// };

				if(isShadowInclude){
					return {
						rendered: rendered,
						actionKey: 'include-' + inclusionKey
					};
				}

				return rendered;
			}
			else {
				if(!data.model) 		data.model = {};
				if(!data.config) 		data.config = {};
				if(!data.formMapping) 	data.formMapping = {};
				if(!data.resourceData) 	data.resourceData = {};

				// set include callback for cascading templates
				data.include    = function(a, b, c, d, e, f, g){
					// correct file path of cascaded inclusions to get the inclusion function working relative to the real actual folder of inclusion occurrence
					// cut off last inclusion part (real file after folder)
					var parentFile = file.split('/');
					parentFile.pop();
					// push new inclusion file
					parentFile.push(a);
					// set file argument within this call
					a = parentFile.join('/');

					// set right parentComponentGroup and perform inclusion
					return self.include(a, b, parentComponentGroup || self.component, d, e, storage, routeParams, true, forceImmediateRender);
				};
				data.includeShadow = function(shadowComponentCodeName, data, storage, routeParams){
					return self.includeShadow(shadowComponentCodeName, data, storage, routeParams, true);
				};
				data.CONSTANTS  	= CONSTANTS;
				data.utils      	= utils;
				data.routeParams 	= routeParams;
				data.helpers    	= this.helpers(storage);
				data.storage    	= {
					sessionID:  storage.sessionID,
					session:    storage.session || {},
					user:       storage.user,
					app:        storage.app,
					request:    storage.request || {},
					isServer:   storage.isServer,
					isClient:   storage.isClient,
					langCode: 	storage.langCode,
					__: 		storage.__,
				};
				// data.__ = storage.__; // TODO: POIA
				data.environment = this.activeEnvironment || {};
				data.scope = this.scope;

				if(usedComponentKey != templateComponentKey){
					usedComponentKey += ' ' + templateComponentKey;
				}

				return this.injectIndex(componentList.templates[templateComponentKey](data), false, usedComponentKey, undefined, templateComponentKey, storage);
			}
		}
		// look for a template and a component definition at other locations
		else {
			// render template according to own name and extension path if necessary and possible
			if(templateComponentKey == componentKey){
				var parentComponentKey = componentList.buildKey(parentComponentGroup);
				if(!utils.isEmpty(componentList.components[parentComponentKey]._extends)){
					// this inclusion will throw a "template not found"-error which has to be prevented to be able to search within other locations too
					try { return this.include(file, data, componentList.components[parentComponentKey]._extends, aliasComponentKey || componentKey, undefined, storage, routeParams, ejsInclude, forceImmediateRender); } catch (error){}
				}
			}

			// render template according to extended component if necessary and possible
			if(!utils.isEmpty(componentList.components[templateComponentKey]) && !utils.isEmpty(componentList.components[templateComponentKey]._extends)){
				return this.include(file, data, parentComponentGroup, aliasComponentKey || templateComponentKey, componentList.buildKey(componentList.normalizeComponentGroup(componentList.components[templateComponentKey]._extends)), storage, routeParams, ejsInclude, forceImmediateRender);
			}
		}

		// no rendering possible
		throw new Error('template not found or error in inclusion of ' + file);
	};

	/**
	 * this function is used to include an inclusionShadowComponent according to the given data.
	 * NOTE: this function can be used on server- as well as on client-side.
	 * NOTE: on client-side the function should be used with targetSelector and targetPosition Parameters to prevent problems
	 * 		(like raceconditions between dom-insertion and bind component to dom-object inclusion-action)
	 *
	 * TODO: routeparams server-side?
	 *
	 * @param 	shadowComponentCodeName		string - codeName of shadowComponent
	 * @param 	refData						object - data to use (like other includes' data)
	 * @param 	storage						object - optional - actual storage
	 * @param 	routeParams					object - optional - actual routeParams
	 * @param 	ejsInclude					boolean - in case of ejs-includes this param will be set to true.
	 * 										NOTE: in case of js-includes there is nothing to do
	 * @param 	targetSelector				jQuery | string - jQuerySelector identifying the target in case of js-includes
	 * @param 	targetPosition				int - CONSTANTS.COMPONENT.ACTION.TARGET.POSITION[...] - Where to insert the element into the dom according to the given target identified by targetSelector-param.
	 * @returns string rendered | boolean
	 */
	Component.prototype.includeShadow = function(shadowComponentCodeName, refData, storage, routeParams, ejsInclude, targetSelector, targetPosition){
		// init
		var self 	= this;
		storage 	= storage || this.getStorage();
		routeParams = routeParams || (appConfig.isClient && globalThis.routeParams ? globalThis.routeParams : {});
		const data = {
			...(refData || {})
		}

		// initial checks
		if(!shadowComponentCodeName){
			// TODO: THROW ERROR
			return '';
		}

		// look for shadow
		var shadowComponent;
		if(self.inclusionShadowComponents && self.inclusionShadowComponents[shadowComponentCodeName]){
			shadowComponent = utils.copy(self.inclusionShadowComponents[shadowComponentCodeName])
		}
		else {
			self.parentComponents(undefined, function(parentComponent){
				if(!shadowComponent && parentComponent.inclusionShadowComponents && parentComponent.inclusionShadowComponents[shadowComponentCodeName]){
					shadowComponent = parentComponent.inclusionShadowComponents[shadowComponentCodeName];
				}
			});
		}

		if(shadowComponent){

			// build shadow
			// TODO: why not inherit the own scope?
			shadowComponent = storage.componentTree.build(
				undefined,
				utils.merge(
					shadowComponent,
					{
						type: 'component',
						config: {
							isShadowComponent: false,
							wasShadowComponent: true
						}
					},
					data
				),
				false,
				false,
				appConfig.isClient,
				storage,
				undefined,
				undefined,
				undefined,
				undefined,
				self.config.isContainerComponent,
				true,
				self._routePath,
				undefined,
				self.componentIndex,
				self.componentInstanceID,
				appConfig.isClient
			);

			// set scope if necessary
			if(!shadowComponent.scope) shadowComponent.scope = this.scope;

			if(appConfig.isClient){
				shadowComponent = storage.componentTree.lookup[shadowComponent.componentIndex];
			}

			// TODO: test this container component class feature in case of shadowInclusions
			if(self.config.isContainerComponent && shadowComponent.potentialContainerComponentClasses){
				self.containerComponentClass = (self.containerComponentClass ? self.containerComponentClass + ' ' : '') + shadowComponent.potentialContainerComponentClasses.join(' ');
				shadowComponent.config.dirtyContainerComponentClass = true;
			}
			delete shadowComponent.potentialContainerComponentClasses;

			// write config resourceUrl if necessary
			if(
				!shadowComponent.config.resourceUrl &&
				shadowComponent.actions &&
				shadowComponent.actions.refreshResources &&
				shadowComponent.actions.refreshResources.source &&
				shadowComponent.actions.refreshResources.source.load &&
				shadowComponent.actions.refreshResources.source.load.resourceConfig
			){
				shadowComponent.config.resourceUrl = shadowComponent.getResourceUrl(shadowComponent.actions.refreshResources.source.load.resourceConfig);
			}

			// render / include real component
			var inclusion = self.include(shadowComponent, {
				scope: 			shadowComponent.scope || '',
				config: 		shadowComponent.config || {},
				model: 			shadowComponent.model || {},
				resourceData: 	shadowComponent.resourceData || {},
				formMapping: 	shadowComponent.formMapping || {}
			}, undefined, undefined, shadowComponent.componentClass, storage, routeParams);

			if(appConfig.isClient){
				var $target, DOMOperationDone = false;
				if(targetSelector && ($target = $(targetSelector)).length > 0 && targetPosition){
					DOMOperationDone = true;
					switch(targetPosition){
						case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.REPLACE:
							$target.replaceWith(inclusion.rendered);
							break;

						case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML:
							$target.html(inclusion.rendered);
							break;

						case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.BEFORE:
							$(inclusion.rendered).insertBefore($target);
							break;

						case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.AFTER:
							$(inclusion.rendered).insertAfter($target);
							break;

						case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.PREPEND:
							$target.prepend(inclusion.rendered);
							break;

						case CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND:
							$target.append(inclusion.rendered);
							break;

						default:
							DOMOperationDone = false;
					}
				}

				if(!ejsInclude && inclusion.actionKey && self.actions[inclusion.actionKey] && !self.hooksInCharge.include){
					if(DOMOperationDone){
						// immediate bind of component to dom element
						self.performAction(inclusion.actionKey, { autoRefresh: true });
						return true;
					}
					else {
						// no rendering possible
						throw new Error('please use the targetSelector and targetPosition Parameters to prevent malfunctions of this shadow inclusion: ' + shadowComponentCodeName);
					}
				}
			}

			return inclusion.rendered;
		}

		// no rendering possible
		throw new Error('error in inclusion of shadow ' + shadowComponentCodeName);
	};

	/**
	 * this function is used to perform includes which has not been performed yet in case of manually handled and js-sided includes.
	 * NOTE: 	if a js-sided include will be performed, the inclusion html will be handled manually and
	 * 			after the manual dom-operations are done this function can be used to perform the inclusion action.
	 * 			if this is not the case this function must not be used!
	 * @returns {Promise}
	 */
	Component.prototype.performMissingIncludes = function(){
		var self = this;
		var performingActions = [];

		// re-perform refresh persistent and inclusion-actions
		if(!utils.isEmpty(this.actions)){
			utils.forEach(this.actions, function(action, actionKey){
				// NOTE: this undefined check is necessary because other components can grab actions if they are inclusion-actions and they belong to another component
				if(typeof(action) != 'undefined'){
					// perform include actions which should be performed within this component
					if(action.type == CONSTANTS.COMPONENT.ACTION.TYPE.INCLUDE && !action.parentInclusionKey && !action.ready){
						performingActions.push(self.performAction(actionKey, { autoRefresh: true }));
					}
				}
			});
		}

		return utils.promise.performAll(performingActions);
	};



	///////////////////////////////
	///// TRAVERSE
	///////////////////////////////

	/**
	 * this function works similar than jQuery closest method.
	 * it looks for and returns the component within all parents of this component according to the given componentClass.
	 * if the given componentClass is empty the actual parent component will be returned.
	 * NOTE: this function is not jquery dependent!
	 *
	 * @param   closestComponentClass       	string - component class of wanted parent
	 * @param   callback                    	function - this function will be called with the found component as first parameter
	 * @param   followOriginalActionParents		boolean - default: false - this flag tells the function if originalActionParentComponentIndex identified components should be treated as parents too.
	 * @param   context                     	object - this is the context used to store the reference on the component which has called the closest method originally
	 * @param   refInternalStates               object - internal helper states
	 * 											ATTENTION: NEVER EVER SET THIS FROM OUTSIDE!
	 */
	Component.prototype.closest = function(closestComponentClass, callback, followOriginalActionParents, context, refInternalStates){
		if(!context) context = this;
		if(!refInternalStates) refInternalStates = {};
		if(!callback || refInternalStates.parentFound) return;

		const parentComponentIndexes = []
		if(this.intermediaryParentComponentIndex){
			parentComponentIndexes.push(this.intermediaryParentComponentIndex)
		}
		// intermediary parents have to be children of the parent. therefor the parent will be found within the recursion anyway if an intermediaryParentComponentIndex has been defined.
		else if(this.parentComponentIndex){
			parentComponentIndexes.push(this.parentComponentIndex)
		}
		if(followOriginalActionParents && this.originalActionParentComponentIndex){
			parentComponentIndexes.push(this.originalActionParentComponentIndex)
		}

		const emptyComponentClass = utils.isEmpty(closestComponentClass) || String(closestComponentClass).trim() === '*'

		for(const parentComponentIndex of parentComponentIndexes){
			const parent = getComponent(parentComponentIndex)
			if(!parent) continue;

			if(emptyComponentClass || parent.hasClass(closestComponentClass)){
				// TODO: why is this extra check needed. e.g., eventProperties.onSubmitDone within participantsTable if no real parallelism exists?
				if(!refInternalStates.parentFound){
					refInternalStates.parentFound = true
					callback.apply(context, [parent]);
				}
			}
			else {
				parent.closest(closestComponentClass, callback, followOriginalActionParents, context, refInternalStates);
			}
		}
	};

	/**
	 * this function works similar than jQuery parent method.
	 * it looks for and returns the parent component of this one.
	 *
	 * @param   callback                    function - this function will be called with the found component as first parameter
	 */
	Component.prototype.parent = function(callback){
		this.closest(undefined, callback);
	};

	/**
	 * this function returns the furthest component identified by its componentClass within a given parent identified by its jquery selector
	 *
	 * @param   furthestComponentClass      string - component class of wanted parent
	 * @param   withinSelector              string - jquery selector of the parent which should not be passed
	 * @param   callback                    function - this function will be called with the found component as first parameter.
	 */
	Component.prototype.furthest = function(furthestComponentClass, withinSelector, callback){
		let furthestComponentIndex

		if(this.$){
			this.$.parentsUntil(withinSelector).each(function(){
				if($(this).hasClass(furthestComponentClass)){
					furthestComponentIndex = $(this).data('componentIndex');
				}
			});
		}

		if(typeof(furthestComponentIndex) !== 'undefined'){
			callback.apply(this, [getComponent(furthestComponentIndex)]);
		}
	};

	/**
	 * this function works similar than jQuery find method.
	 * it looks for and returns a list of components within the actual component according to the given componentClass.
	 *
	 * TODO: maybe componentClass can be replaced by a jquery selector (but works for components only)
	 *
	 * @param   componentClass          		string - component class of wanted children. if this flag will be left empty all children components will be returned.
	 * @param   lateDescendingCallback  		function - this function will be called before the recursion descent
	 *                                  		NOTE: if this function returns 'break' the traversing will be aborted immediately (tree root first)
	 *                                  		NOTE: if this function returns 'breakRecursion' the recursion descent will be aborted but the rest of the tree will be reached afterwards.
	 * @param   earlyDescendingCallback 		function - this function will be called after the recursion descent (tree leaf first)
	 *                                  		NOTE: if this function returns 'break' the traversing will be aborted immediately
	 * @param 	intermediaryChildrenGranted     boolean - default: true - is traversing intermediary children granted or not?
	 */
	Component.prototype.find = function(componentClass, lateDescendingCallback, earlyDescendingCallback, intermediaryChildrenGranted = true){
		var lateDescendingCallbackFound     = typeof(lateDescendingCallback) === 'function';
		var earlyDescendingCallbackFound    = typeof(earlyDescendingCallback) === 'function';

		if(lateDescendingCallbackFound || earlyDescendingCallbackFound){
			var self = this;
			var emptyComponentClass = utils.isEmpty(componentClass) || String(componentClass).trim() === '*';
			forAllChildComponents(
				this,
				lateDescendingCallbackFound ? function(element){
					if ((emptyComponentClass || element.hasClass(componentClass)) && element.componentIndex != self.componentIndex){
						return lateDescendingCallback.apply(self, [element]);
					}
				} : undefined,
				earlyDescendingCallbackFound ? function(element){
					if ((emptyComponentClass || element.hasClass(componentClass)) && element.componentIndex != self.componentIndex){
						return earlyDescendingCallback.apply(self, [element]);
					}
				} : undefined,
				undefined,
				intermediaryChildrenGranted
			);
		}
	};

	/**
	 * this is combination of find(), furthest() and closest() to locate a component within the componentTree.
     * e.g., componentPath: "< templates_parent > templates_child << templates_ant@.templates_granny" would mean locate:
	 * 		closest templates_parent,
	 * 		find templates_child
	 * 		furthest templates_ant which is located within an element identifiable by .templates_granny
	 *
	 * @param componentPath		{string} componentPath
	 * @param callback			{function} callback receiving the found component as argument
	 * @param notFoundCallback	{function} callback in case the component has not been found
	 * @param self				{Component} used for internal purposes only!!!
	 * @return {*}
	 */
	Component.prototype.locate = function(componentPath, callback, notFoundCallback, self = null){
		if(callback){
			if(componentPath){
				// identify next operation
				componentPath = String(componentPath)
				const operation = String(componentPath).match(/^([<]{1,2}|[>])\s*([^\s]+)\s*(.*)$/)
				if(operation !== null && operation.length > 2){
					const operator 			= operation[1]
					const componentClass 	= operation[2]
					const nextComponentPath = operation[3]
					let found = false

					if(operator === '<'){
						this.closest(componentClass, function(component){
							component.locate(nextComponentPath, callback, notFoundCallback, self || this)
							found = true
						})
					} else if(operator === '<<'){
						const componentClassParts = String(componentClass).split('@')
						this.furthest(componentClassParts[0] || '', componentClassParts[1], function(component){
							component.locate(nextComponentPath, callback, notFoundCallback, self || this)
							found = true
						})
					} else if(operator === '>'){
						this.find(componentClass, function(component){
							component.locate(nextComponentPath, callback, notFoundCallback, self || this)
							found = true
						})
					} else {
						console.error(`locate needs a valid operator ${operator} for the given componentPath ${componentPath}`)
						found = true
					}

					if(!found && notFoundCallback){
						notFoundCallback.apply(self || this)
					}

				} else {
					console.error(`locate needs a valid componentPath operation ${componentPath}`)
				}
			} else {
				// target reached
				callback.apply(self || this, [this])
			}
		} else {
			console.error('locate needs a callback')
		}
	};

	/**
	 * this function calls the callback each time a parent component matches the given component class and is located within a given parent identified by its jquery selector.
	 *
	 * @param   componentClass      string - component class of wanted parent - optional
	 * @param   withinSelector      string - jquery selector of the parent which should not be passed - optional
	 * @param   callback            function - this function will be called for each found component with the found component as first parameter.
	 */
	Component.prototype.parents = function(componentClass, withinSelector, callback){
		if(withinSelector === undefined) withinSelector = 'html';

		this.$.parentsUntil(withinSelector).each(function(){
			var $element = $(this);
			if((componentClass === undefined && $element.data('componentIndex') !== undefined) || $element.hasClass(componentClass)){
				var component = getComponent($element.data('componentIndex'));
				if(component != undefined){
					callback.apply(this, [getComponent($element.data('componentIndex'))]);
				}
				else {
					console.error('component not found according to given componentIndex: ', $element.data('componentIndex'), ' @ element: ', $element, globalThis.componentTree);
				}
			}
		});
	};

	/**
	 * this function calls the callback each time a parent component matches the given component class.
	 * NOTE: this function can be used without jquery!
	 * NOTE: this function cannot identify parents outside the route-component which is in charge!
	 *
	 * @param   componentClass      			string | array | whitespace separated string - component class(es) of wanted parent - optional
	 * @param   callback            			function - this function will be called for each found component with the found component as first parameter.
	 *                              			NOTE: if the callback function returns false the parentComponent's loops / recursions will be aborted immediately.
	 * @param   followOriginalActionParents		boolean - default: false - this flag tells the function if originalActionParentComponentIndex identified components should be treated as parents too.
	 * @param   context             			Component - this flag is set to the calling context.
	 *                              			NOTE: NEVER EVER SHOULD BE USED FROM OUTSIDE!
	 * @returns boolean - this result is negligible since it is used for internal recursion abortion purposes only.
	 */
	Component.prototype.parentComponents = function(componentClass, callback, followOriginalActionParents, context){
		if(appConfig.isClient) {
			if (!componentTree) {
				componentTree = globalThis.componentTree
			}
		} else {
			const storage = this.getStorage()
			// since route params have been introduced all kinds of componentInstances may differ from one another
			// even if they have the very same componentInstanceID and are located within the same route (or layout).
			// the whole tree can store very different states, resources and so on based on the given routeParams.
			// e.g., frontend-event-registration-form including the applicant-authentication based on routeParam: authHash.
			// since this is the only tree-traversing method used by the server and this is the only place potential problems can occur
			// the buildMemory had to be referenced by the storage and may not be used on and on as it was the case befor.
			// this has to be done to get the right componentTree.mapping which may respect the different (by the routeParams) componentInstances based on the very same componentInstances.
			// e.g., applicantRegistrationForm-PostAuth.
			componentTree = storage.buildMemory || storage.componentTree;
		}
		if(utils.isString(componentClass)) componentClass = componentClass.split(' ');
		if(!context) context = this;

		const parentComponentIdentifiers = {}
		if(appConfig.isClient){
			parentComponentIdentifiers.lookup = []
			if(this.intermediaryParentComponentIndex){
				parentComponentIdentifiers.lookup.push(this.intermediaryParentComponentIndex)
			}
			// intermediary parents have to be children of the parent. therefor the parent will be found within the recursion anyway if an intermediaryParentComponentIndex has been defined.
			else {
				parentComponentIdentifiers.lookup.push(this.parentComponentIndex)
			}

			if(followOriginalActionParents && this.originalActionParentComponentIndex && this.originalActionParentComponentIndex !== this.parentComponentIndex){
				parentComponentIdentifiers.lookup.push(this.originalActionParentComponentIndex)
			}
		} else {
			parentComponentIdentifiers.mapping = [this.parentComponentInstanceID]
		}

		for(const componentTreeListType in parentComponentIdentifiers){
			for(const parentComponentIdentifier of parentComponentIdentifiers[componentTreeListType] || []){
				const parentComponent = (componentTree[componentTreeListType] || {})[parentComponentIdentifier];
				let componentMatch = !componentClass;
				if(!!parentComponent){
					const parentComponentClasses = (parentComponent.componentClass + ' ' + parentComponent.extensionComponentClass).split(' ');
					if(!componentMatch){
						utils.forEach(componentClass, clazz => {
							if(parentComponentClasses.indexOf(clazz) >= 0){
								componentMatch = true;
								return false;
							}
						});
					}

					if(
						componentMatch
						&&
						callback.apply(context, [parentComponent]) === false
					){
						return false
					}

					if(typeof parentComponent.parentComponents === 'function' && parentComponent.parentComponents(componentClass, callback, followOriginalActionParents, context) === false){
						return false
					}
				}
			}
		}

		return true
	};

	/**
	 * this function is used to determine if the actual component has the given componentClass
	 *
	 * @param   componentClass      string - componentClass
	 * @returns {boolean}
	 */
	Component.prototype.hasClass = function(componentClass){
		return (this.componentClass + ' ' + this.extensionComponentClass + ' ' + this.containerComponentClass).split(' ').indexOf(componentClass) >= 0;
	};



	//////////////////////////////////
	///  actionRegistry
	//////////////////////////////////

	/**
	 * returns true if error handling is skipped at the moment.
	 *
	 * @see frontend-controller/lib/actionRegistry.js#isFurtherErrorHandlingSkipped
	 *
	 * @returns boolean
	 */
	Component.prototype.isFurtherErrorHandlingSkipped = function(){
		return actionRegistry.isFurtherErrorHandlingSkipped()
	};

	/**
	 * skips further error handling until the actual components action in progress is done.
	 * this may not work if another component has skipped further error handling before this call.
	 *
	 * @see frontend-controller/lib/actionRegistry.js#skipFurtherErrorHandling
	 */
	Component.prototype.skipFurtherErrorHandling = function(){
		return actionRegistry.skipFurtherErrorHandling(this.componentIndex)
	};

	/**
	 * releases the skip status of the actual error handling if this is the component which has been skipped further error handling in the first place.
	 *
	 * @see frontend-controller/lib/actionRegistry.js#releaseFurtherErrorHandling
	 */
	Component.prototype.releaseFurtherErrorHandling = function(){
		return actionRegistry.releaseFurtherErrorHandling(this.componentIndex)
	};

	/**
	 * registers a given actionContext within a group identified by the given reperformType which may be performed later.
	 *
	 * @see frontend-controller/lib/actionRegistry.js#registerReperformer
	 *
	 * @param context           {Object} - actionContext
	 * @param reperformType     {String} - re-perform type e.g., relogin
	 */
	Component.prototype.registerReperformer = function(context, reperformType = ''){
		return actionRegistry.registerReperformer(context, reperformType)
	};

	/**
	 * reperforms all registered actions according to the given reperformType.
	 *
	 * @see frontend-controller/lib/actionRegistry.js#reperformRegisteredActions
	 *
	 * @param reperformType     string - reperformType
	 * @returns Promise
	 */
	Component.prototype.reperformRegisteredActions = function(reperformType = ''){
		return actionRegistry.reperformRegisteredActions(reperformType)
	};



	module.exports = Component;
